import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

export type Language = "zh-TW" | "en";

type Translations = {
  [key: string]: {
    [key: string]: string;
  };
};

const translations: Translations = {
  "zh-TW": {
    "settings.title": "設定",
    "settings.profile.edit": "編輯個人資料",
    "settings.profile.vip": "VIP 方案 (開發中)",
    "settings.appearance.title": "外觀與顯示",
    "settings.appearance.darkMode": "深色模式",
    "settings.appearance.themeColor": "主題顏色",
    "settings.appearance.theme_preview": "主題預覽",
    "settings.theme.blue": "經典藍",
    "settings.theme.sapphire": "藍寶石",
    "settings.theme.sky": "天空藍",
    "settings.theme.cyan": "海洋青",
    "settings.theme.seafoam": "海沫青",
    "settings.theme.teal": "水鴨綠",
    "settings.theme.mint": "薄荷綠",
    "settings.theme.green": "翡翠綠",
    "settings.theme.forest": "森林綠",
    "settings.theme.lime": "萊姆綠",
    "settings.theme.money": "財富金",
    "settings.theme.amber": "琥珀黃",
    "settings.theme.orange": "夕陽橘",
    "settings.theme.copper": "紅銅",
    "settings.theme.coral": "珊瑚橘",
    "settings.theme.peach": "蜜桃橙",
    "settings.theme.red": "熱情紅",
    "settings.theme.wine": "酒紅",
    "settings.theme.pink": "櫻花粉",
    "settings.theme.fuchsia": "時尚紫",
    "settings.theme.lavender": "薰衣草紫",
    "settings.theme.violet": "紫羅蘭",
    "settings.theme.grape": "葡萄紫",
    "settings.theme.indigo": "深邃靛",
    "settings.theme.navy": "海軍藍",
    "settings.theme.midnight": "午夜藍",
    "settings.theme.slate": "極簡灰",
    "settings.theme.stone": "暖石灰",
    "settings.general.title": "一般與偏好",
    "settings.general.categories": "類別管理",
    "settings.general.categories.desc": "記帳分類設定",
    "settings.general.water_gyro": "水流跟隨手機擺動",
    "settings.general.reminder": "每日記帳提醒",
    "settings.general.reminder_desc": "每天在指定時間提醒你快速記下當天花費",
    "settings.general.reminder_time": "提醒時間",
    "settings.general.reminder_time_title": "設定提醒時間",
    "settings.general.smart_budget": "智慧預算提醒",
    "settings.general.smart_budget_desc": "每次記帳後都會檢查本月預算剩餘與使用比例，接近你設定的提醒門檻時主動通知你",
    "settings.general.smart_budget_threshold": "提醒門檻",
    "settings.general.smart_budget_threshold_title": "設定提醒門檻",
    "settings.general.language": "語言",
    "settings.general.currency": "預設幣別",
    "settings.data.title": "資料管理",
    "settings.data.export": "匯出資料 (Excel)",
    "settings.data.clear": "清除所有資料",
    "settings.data.delete_account": "刪除帳號",
    "settings.other.title": "其他",
    "settings.other.help": "說明與回饋",
    "settings.other.privacy": "隱私權政策",
    "settings.other.terms": "服務條款",
    "settings.other.version": "版本資訊",
    "settings.feedback.title": "說明與回饋",
    "settings.feedback.desc": "歡迎留下評價或直接寫信給我們，協助 MoneyTrack 變得更好。",
    "settings.feedback.app_store": "到 App Store 評分與留言",
    "settings.feedback.app_store_hint": "開啟 App 商店頁面，可評分與撰寫評論",
    "settings.feedback.app_store_pending": "上架後即可開啟商店頁面評分",
    "settings.feedback.email": "寫信給客服",
    "settings.feedback.store_soon_title": "App Store 頁面尚未就緒",
    "settings.feedback.store_soon_desc": "正式上架後即可從此處前往評分與留言。目前請改用 Email 回饋。",
    "settings.logout": "登出帳號",
    "settings.logout.confirm": "確定要登出嗎？",
    
    "budget.planner.jar.chart.title": "支出類別分析",
    "budget.planner.jar.create.title": "創建新存錢罐",
    "budget.planner.jar.create.name": "存錢罐名稱",
    "budget.planner.jar.create.name.placeholder": "例如：旅遊基金",
    "budget.planner.jar.create.target": "目標金額",
    "budget.planner.jar.create.color": "主題顏色",
    "budget.planner.jar.create.submit": "立即創建",
    "budget.planner.jar.create.success": "存錢罐已創建",
    "budget.planner.jar.create.error": "創建存錢罐失敗",
    "budget.planner.jar.create.validate_error": "請填寫存錢罐名稱和目標金額",
    "budget.planner.jar.history.empty": "尚無交易記錄",
    "budget.planner.jar.icon.select": "選擇圖示",
    "budget.planner.jar.icon.search": "搜尋圖示...",
    "budget.planner.jar.target_toggle": "設定目標金額",
    "budget.planner.jar.target_placeholder": "輸入目標金額",
    "budget.planner.jar.currency_select": "選擇存錢罐幣別",
    "budget.planner.jar.name_required": "請輸入存錢罐名稱",
    "budget.planner.jar.target_required": "請輸入目標金額",
    "budget.planner.jar.target_type_desc": "目標型 - 追蹤達成進度",
    "budget.planner.jar.accum_type_desc": "∞ 累積型 - 持續累積餘額",
    
    


    // Dialogs - Edit Profile
    "dialog.profile.title": "編輯個人資料",
    "dialog.profile.desc": "設定顯示在各頁面上的名稱",
    "dialog.profile.name": "顯示名稱",
    "dialog.profile.namePlaceholder": "輸入您的暱稱",
    "dialog.profile.email": "Email",
    "dialog.profile.emailDesc": "無法更改",
    "dialog.profile.cancel": "取消",
    "dialog.profile.save": "儲存變更",
    "dialog.profile.saving": "儲存中...",

    // Dialogs - Clear Data 1
    "dialog.clear.title": "確認清除所有資料",
    "dialog.clear.confirm_desc": "您確定要清除帳號內的所有財務資料嗎？",
    "dialog.clear.warning": "此操作無法復原。",
    "dialog.clear.consequence.1": "記帳、預算、資產、投資、存錢罐等資料將永久刪除",
    "dialog.clear.consequence.2": "您的登入帳號會保留，之後仍可繼續使用",
    "dialog.clear.consequence.3": "確認清空後會自動回到資產首頁",
    "dialog.clear.cancel": "取消",
    "dialog.clear.confirm": "確認清除",

    // Dialogs - Clear Data 2
    "dialog.final.title": "最後確認",
    "dialog.final.confirm_desc": "請問您確定要執行清除嗎？",
    "dialog.final.warning": "清除後所有資料將無法復原。",
    "dialog.final.consequence.1": "財務資料會立刻被清空",
    "dialog.final.consequence.2": "登入帳號本身不會被刪除",
    "dialog.final.cancel": "取消",
    "dialog.final.confirm": "確認清除",
    "dialog.final.confirming": "清除中...",

    "dialog.delete_account.title": "確認刪除帳號",
    "dialog.delete_account.confirm_desc": "這與「清除所有資料」不同，會連登入身分一起移除。",
    "dialog.delete_account.warning": "此操作無法復原。",
    "dialog.delete_account.consequence.1": "永久刪除登入身分與個人資料",
    "dialog.delete_account.consequence.2": "記帳、預算、資產、投資、存錢罐、借貸一併刪除",
    "dialog.delete_account.consequence.3": "提醒、通知與上傳圖片都會清除",
    "dialog.delete_account.consequence.4": "離開你加入的共同帳戶（別人資料保留）",
    "dialog.delete_account.consequence.5": "若仍是共同帳戶擁有者，需先解散或請成員離開",
    "dialog.delete_account.cancel": "取消",
    "dialog.delete_account.confirm": "我了解，繼續",
    "dialog.delete_account.second.title": "二次確認",
    "dialog.delete_account.second.confirm_desc": "刪除後無法透過匯出或客服復原。",
    "dialog.delete_account.second.warning": "請再次確認您真的要刪除帳號。",
    "dialog.delete_account.second.consequence.1": "帳號與個人財務資料會永久消失",
    "dialog.delete_account.second.consequence.2": "其他人共同帳戶中的資料不會被刪除",
    "dialog.delete_account.second.consequence.3": "相同 Email 之後需重新註冊才能使用",
    "dialog.delete_account.second.cancel": "取消",
    "dialog.delete_account.second.confirm": "仍要刪除",
    "dialog.delete_account.final.title": "最後確認：永久刪除",
    "dialog.delete_account.final.confirm_desc": "按下確認後將立即刪除帳號並登出。",
    "dialog.delete_account.final.warning": "此操作無法復原。",
    "dialog.delete_account.final.consequence.1": "登入身分與所有個人資料立刻銷毀",
    "dialog.delete_account.final.consequence.2": "刪除完成後無法再使用目前帳號登入",
    "dialog.delete_account.final.cancel": "取消",
    "dialog.delete_account.final.confirm": "確認刪除帳號",
    "dialog.delete_account.final.confirming": "刪除中...",

    "toast.delete_account.success": "帳號已刪除",
    "toast.delete_account.error": "刪除帳號失敗",
    // Toasts
    "toast.export.title": "匯出中",
    "toast.export.desc": "您的資料正在準備中...",
    "toast.clear.error": "清除失敗",
    "toast.update.error": "更新失敗",
    "toast.logout.error": "登出失敗",
    "toast.name.required": "請輸入暱稱",
    
    // Currencies
    "currency.twd": "新台幣 (TWD)",
    "currency.usd": "美元 (USD)",
    "currency.jpy": "日圓 (JPY)",
    "currency.TWD": "新台幣",
    "currency.USD": "美元",
    "currency.JPY": "日圓",
    "currency.EUR": "歐元",
    "currency.GBP": "英鎊",
    "currency.CNY": "人民幣",
    "currency.HKD": "港幣",
    "currency.KRW": "韓元",
    "currency.AUD": "澳幣",
    "currency.SGD": "新加坡幣",
    "currency.CAD": "加幣",

    // Navigation
    "nav.overview": "總覽",
    "nav.budget": "預算",
    "nav.ledger": "記帳",
    "ledger.empty.title": "目前沒有任何交易",
    "ledger.empty.desc": "點擊右下角的按鈕來新增第一筆記帳",
    "ledger.section.pending_list": "待確認清單",
    "ledger.section.entries": "記帳明細",
    "ledger.empty.day_today_title": "今天還沒記帳呢！",
    "ledger.empty.day_title": "這天沒有交易紀錄",
    "ledger.empty.day_today_desc": "紀錄一下今天的開銷吧 ✨",
    "ledger.empty.day_desc": "享受美好的無消費時光 📝",
    "ledger.empty.day_add": "補記一筆",
    "budget.status.budget_exhausted": "預算已用完",
    "tasks.title": "財務待辦",
    "tasks.add": "新增",
    "tasks.add_dialog": "新增待辦",
    "tasks.edit_dialog": "編輯待辦事項",
    "tasks.delete_confirm": "確定要刪除此待辦嗎？",
    "tasks.title_placeholder": "輸入事項內容...",
    "tasks.recurrence": "重複週期",
    "tasks.recurrence.once": "僅此一次",
    "tasks.recurrence.daily": "每天",
    "tasks.recurrence.weekly": "每週",
    "tasks.recurrence.monthly": "每月",
    "tasks.recurrence.yearly": "每年",
    "tasks.recurrence.none": "不重複",
    "tasks.recurrence.weekly_on": "每週{day}",
    "tasks.recurrence.monthly_on": "每月{day}日",
    "tasks.recurrence.yearly_on": "每年{month}/{day}",
    "tasks.notify.enable": "開啟提醒",
    "tasks.notify.at": "將於 {time} 發送通知",
    "tasks.notify.time": "推播時間",
    "tasks.auto_ledger": "自動記帳",
    "tasks.auto_ledger.configured": "已設定記帳資訊",
    "tasks.auto_ledger.configure": "請設定記帳資訊",
    "tasks.auto_ledger.split": "(分帳)",
    "tasks.auto_ledger.skip_confirm": "略過確認，直接記帳",
    "tasks.auto_ledger.setup": "設定詳細資訊...",
    "tasks.save": "儲存待辦變更",
    "tasks.create": "確認新增待辦",
    "tasks.empty": "尚無待辦事項",
    "tasks.badge.repeat": "重複",
    "tasks.badge.auto": "自動記帳",
    "tasks.badge.ledger": "記帳",
    "tasks.weekday.0": "週日",
    "tasks.weekday.1": "週一",
    "tasks.weekday.2": "週二",
    "tasks.weekday.3": "週三",
    "tasks.weekday.4": "週四",
    "tasks.weekday.5": "週五",
    "tasks.weekday.6": "週六",
    "tasks.create_failed": "新增失敗",
    "tasks.update_failed": "更新失敗",
    "tasks.auto_failed": "自動記帳失敗",
    "tasks.title_required": "請輸入事項標題",
    "tasks.uncomplete_confirm": "要將此事項標記為未完成嗎？",
    "tasks.notify_title": "待辦事項提醒",
    "tasks.swipe_delete_confirm": "確認刪除此待辦嗎？",
    "nav.investment": "投資",
    "nav.settings": "設定",

    // Common Units
    "common.unit.ten_thousand": "萬",
    "common.today": "回到今天",
    "common.year": "年",
    "common.month": "月",
    "common.unit.hundred_million": "億",

    // Asset Overview
    "overview.title": "資產總覽",
    "overview.total_assets": "總資產",
    "overview.net_assets": "淨資產",
    "overview.liabilities": "負債",
    "overview.chart.trend.title": "資產淨值走勢", // Added
    "overview.chart.breakdown.title": "資金分佈", // Added
    "overview.assets": "資產", // Added for toggle
    "overview.tab.trend": "趨勢",
    "overview.tab.composition": "分佈",
    "overview.tab.details": "明細", 
    "overview.button.add_account": "新增帳戶",

    "overview.menu.title": "功能選單",
    "overview.menu.rates": "獲取真實匯率",
    "overview.menu.sync": "同步股價",
    "overview.menu.syncing": "同步中...",
    "overview.net_worth": "總資產淨值",
    "overview.vs_yesterday": "相較昨日",
    "overview.vs_yesterday.cash": "記帳",
    "overview.vs_yesterday.invest": "投資",
    "overview.vs_yesterday.empty": "-",
    "overview.vs_yesterday.flat": "持平",
    "overview.vs_yesterday.analysis.title": "相較昨日變化",
    "overview.vs_yesterday.analysis.desc": "拆解今日資產淨值相對昨天的來源",
    "overview.vs_yesterday.analysis.range": "{from} → {to}",
    "overview.vs_yesterday.analysis.net_change": "淨值變化",
    "overview.vs_yesterday.analysis.split": "變化來源",
    "overview.vs_yesterday.analysis.breakdown": "明細拆解",
    "overview.vs_yesterday.analysis.invest_hint": "市值漲跌（各標的較昨日合計）",
    "overview.vs_yesterday.analysis.other_hint": "記帳淨額（僅計納入總資產帳戶）",
    "overview.vs_yesterday.analysis.other_diff": "其他差異",
    "overview.vs_yesterday.analysis.other_diff_hint": "淨值與（記帳＋個股加總）尚未對上的部分",
    "overview.vs_yesterday.analysis.invest_detail": "投資明細",
    "overview.vs_yesterday.analysis.invest_detail_hint": "市值漲跌（各標的較昨日合計）",
    "overview.vs_yesterday.analysis.other_detail": "記帳明細",
    "overview.vs_yesterday.analysis.other_detail_hint": "記帳淨額（僅計納入總資產帳戶）",
    "overview.vs_yesterday.analysis.loading": "載入明細中",
    "overview.vs_yesterday.analysis.no_investment": "目前沒有投資持倉",
    "overview.vs_yesterday.analysis.no_invest_detail": "暫時無法拆解投資明細，請稍後再試",
    "overview.vs_yesterday.analysis.detail_error": "明細載入失敗，請再試一次",
    "overview.vs_yesterday.analysis.retry": "重試",
    "overview.vs_yesterday.analysis.rounding_note": "細項加總與合計可能有微小進位差異",
    "overview.vs_yesterday.analysis.baseline_note": "昨日淨值基準不完整，已依今日資料重建；明日起會更準確。",
    "overview.vs_yesterday.analysis.holding.qty": "股數",
    "overview.vs_yesterday.analysis.holding.yesterday_mv": "昨日市值",
    "overview.vs_yesterday.analysis.holding.today_mv": "今日市值",
    "overview.vs_yesterday.analysis.holding.formula": "今日市值 − 昨日市值",
    "overview.vs_yesterday.analysis.holding.swipe": "算法",
    "overview.vs_yesterday.analysis.holding.no_prior": "尚無基準收盤價，這一檔暫不計算漲跌。",
    "overview.vs_yesterday.analysis.holding.y": "昨",
    "overview.vs_yesterday.analysis.holding.t": "今",
    "overview.vs_yesterday.analysis.holding.shares_unit": "股",
    "overview.vs_yesterday.debug.button": "計算明細",
    "overview.vs_yesterday.debug.title": "相較昨日 · 計算除錯",
    "overview.vs_yesterday.debug.loading": "載入計算明細中…",
    "overview.vs_yesterday.debug.error": "除錯資料載入失敗",
    "overview.vs_yesterday.debug.desc": "顯示伺服器實際用來計算的中間值與公式（僅除錯用）",
    "overview.vs_yesterday.debug.partial_ready": "記帳／總覽已就緒；投資個股明細仍在抓昨收，完成後會自動補上。",
    "overview.vs_yesterday.debug.loading_invest": "投資個股明細載入中（昨收）…",
    "overview.vs_yesterday.debug.loading_prior_close": "載入計算明細中…（投資昨收抓取中）",
    "overview.vs_yesterday.debug.section.dates": "日期／時區",
    "overview.vs_yesterday.debug.section.overview": "總覽公式",
    "overview.vs_yesterday.debug.section.ledger": "記帳明細（分類 → 桶）",
    "overview.vs_yesterday.debug.section.invest_formulas": "投資個股公式",
    "overview.vs_yesterday.debug.section.invest_detail": "投資明細 · {market}（變化 {change}）",
    "overview.vs_yesterday.debug.no_holdings": "（無持倉列）",
    "overview.vs_yesterday.debug.label.timezone": "時區",
    "overview.vs_yesterday.debug.timezone.taipei": "台北時間（Asia/Taipei）",
    "overview.vs_yesterday.debug.label.today_iso": "今日日期（計算截止）",
    "overview.vs_yesterday.debug.label.yesterday_iso": "昨日日期",
    "overview.vs_yesterday.debug.label.formula": "說明",
    "overview.vs_yesterday.debug.label.today_net_worth": "今日淨值",
    "overview.vs_yesterday.debug.label.yesterday_net_worth": "昨日淨值",
    "overview.vs_yesterday.debug.label.net_worth_change": "淨值變化",
    "overview.vs_yesterday.debug.label.today_invest": "今日投資市值",
    "overview.vs_yesterday.debug.label.yesterday_invest": "昨日投資市值",
    "overview.vs_yesterday.debug.label.invest_net_inflow": "投資買賣淨流入",
    "overview.vs_yesterday.debug.label.invest_change": "投資變化",
    "overview.vs_yesterday.debug.label.ledger_change": "記帳變化",
    "overview.vs_yesterday.debug.label.other_diff": "其他差異",
    "overview.vs_yesterday.debug.label.loan_deduction": "貸款扣除額",
    "overview.vs_yesterday.debug.label.baseline": "昨日基準來源",
    "overview.vs_yesterday.debug.label.ledger_net": "記帳淨額合計",
    "overview.vs_yesterday.debug.label.residual_formula": "殘差公式",
    "overview.vs_yesterday.debug.label.holding_change_formula": "個股市值變化公式",
    "overview.vs_yesterday.debug.label.today_value_formula": "今日市值公式",
    "overview.vs_yesterday.debug.label.yesterday_value_formula": "昨日市值公式",
    "overview.vs_yesterday.debug.label.residual_invest_formula": "投資殘差公式",
    "overview.vs_yesterday.debug.label.historical_sum": "有昨收個股漲跌加總",
    "overview.vs_yesterday.debug.label.price_source": "價格來源",
    "overview.vs_yesterday.debug.label.broker": "券商帳戶",
    "overview.vs_yesterday.debug.label.fx_rate": "匯率（→台幣）",
    "overview.vs_yesterday.debug.label.qty_price": "股數 × 現價",
    "overview.vs_yesterday.debug.label.yqty_yprice": "昨股數 × 昨收",
    "overview.vs_yesterday.debug.label.today_value_twd": "今日市值（台幣）",
    "overview.vs_yesterday.debug.label.yesterday_value_twd": "昨日市值（台幣）",
    "overview.vs_yesterday.debug.label.day_net_inflow": "當日買賣淨流入（參考）",
    "overview.vs_yesterday.debug.label.verify": "驗算",
    "overview.vs_yesterday.debug.label.company": "公司／標的",
    "overview.vs_yesterday.debug.label.ticker": "代號",
    "overview.vs_yesterday.debug.label.explain": "說明",
    "overview.vs_yesterday.debug.no_prior_close": "無昨收",
    "overview.vs_yesterday.debug.baseline.snapshot": "快照",
    "overview.vs_yesterday.debug.baseline.reconstructed": "推算重建",
    "overview.vs_yesterday.debug.baseline.no_row": "（無快照列）",
    "overview.vs_yesterday.debug.price.historical": "歷史昨收",
    "overview.vs_yesterday.debug.price.allocated": "分攤估算",
    "overview.vs_yesterday.debug.price.unavailable": "無昨收",
    "overview.vs_yesterday.debug.price.residual": "殘差分攤",
    "overview.vs_yesterday.debug.formula.timezone": "今日／昨日以台北日曆日切分（台北時間午夜）",
    "overview.vs_yesterday.debug.formula.net_worth_change": "記帳變化 ＋ 投資變化",
    "overview.vs_yesterday.debug.formula.snapshot_net_worth_change": "今日淨值 − 昨日淨值（快照，僅除錯）",
    "overview.vs_yesterday.debug.label.snapshot_net_worth_change": "快照淨值變化（除錯）",
    "overview.vs_yesterday.debug.formula.investment_change": "Σ 各標的市值漲跌（較昨日收盤）",
    "overview.vs_yesterday.debug.formula.cash_and_other": "今日記帳各桶合計",
    "overview.vs_yesterday.debug.formula.other_diff": "淨值變化 − 投資變化 − 記帳變化",
    "overview.vs_yesterday.debug.formula.cash_residual": "記帳變化 − 各記帳桶合計（不含殘差）",
    "overview.vs_yesterday.debug.formula.holding_change": "今日市值 − 基準收盤市值（美股休市非落地日≈0）",
    "overview.vs_yesterday.debug.formula.today_value": "股數 × 現價 × 匯率（券商幣別→台幣）",
    "overview.vs_yesterday.debug.formula.yesterday_value": "昨股數 × 昨收／上一收盤 × 匯率",
    "overview.vs_yesterday.debug.formula.residual_invest": "投資變化 − 有昨收個股漲跌加總",
    "overview.vs_yesterday.debug.residual_explain": "投資總變化 − 各有昨收個股漲跌加總（多半來自匯率或基準差異）",
    "overview.vs_yesterday.debug.broker_line": "{account} · 幣別 {currency} · 匯率 {fx}",
    "overview.vs_yesterday.debug.verify_line": "{today} − {yesterday} = {change}",
    "overview.vs_yesterday.debug.holding_title": "{name}（{ticker}）",
    "overview.vs_yesterday.debug.formula.holdings_sum": "各標的（今日市值 − 上一收盤市值）加總",
    "overview.vs_yesterday.debug.label.holdings_sum": "個股加總（明細）",
    "overview.vs_yesterday.debug.label.invest_snapshot": "投資變化（快照／總覽）",
    "overview.vs_yesterday.analysis.price_allocated": "估算",
    "overview.vs_yesterday.analysis.price_unavailable": "無昨收",
    "overview.vs_yesterday.bucket.ledger_income": "記帳收入",
    "overview.vs_yesterday.bucket.ledger_expense": "記帳支出",
    "overview.vs_yesterday.bucket.transfer_income": "轉帳收入",
    "overview.vs_yesterday.bucket.transfer_expense": "轉帳支出",
    "overview.vs_yesterday.bucket.lending_income": "借貸收入",
    "overview.vs_yesterday.bucket.lending_expense": "借貸支出",
    "overview.vs_yesterday.bucket.balance_adjustment": "餘額調整",
    "overview.vs_yesterday.bucket.fee": "手續費",
    "overview.vs_yesterday.bucket.lending": "借貸相關",
    "overview.vs_yesterday.bucket.residual": "未分類調整",
    "overview.vs_yesterday.bucket.residual_invest": "匯率／基準差異",
    "overview.vs_yesterday.market.tw": "台股",
    "overview.vs_yesterday.market.us": "美股",
    "overview.vs_yesterday.market.crypto": "加密貨幣",
    "overview.vs_yesterday.market.other": "其他",
    "overview.tabs.accounts": "我的帳戶",
    "overview.tabs.analysis": "資產分析",

    // Account Types & Icons
    "account.type.twd": "台幣",
    "account.type.usd": "美元",
    "account.type.jpy": "日幣",
    "account.type.custodian": "交割戶",
    "account.type.bank": "銀行",
    "account.type.cash": "現金",
    "account.type.stock_tw": "台股",
    "account.type.stock_us": "美股",
    "account.type.crypto": "加密貨幣",
    "account.type.real_estate": "房地產",
    "account.type.credit_card": "信用卡",
    "account.type.virtual": "共同帳戶",
    "account.type.custom": "自訂類型",
    "account.type.other": "其他",

    "asset.details.title": "資產明細",
    "asset.details.loans": "借貸",
    "asset.details.transfer": "轉帳",
    "asset.details.add": "新增",
    "asset.details.empty.title": "尚未新增任何帳戶",
    "asset.details.empty.desc": "開始記錄您的第一筆資產",
    "asset.details.empty.btn": "立即新增",
    "asset.details.rate": "匯率",
    "asset.details.jar_reserve": "存錢罐",
    "asset.details.excluded_from_assets": "未入資產",
    "asset.details.section_meta": "{categories} 個類別・{accounts} 個帳戶",
    "asset.details.theme_color": "代表顏色",
    "asset.details.theme_presets": "精選主題色",
    "asset.details.change_theme": "更換主題色",
    "asset.details.info_expand": "展開用途說明",
    "asset.details.info_collapse": "收起用途說明",
    "overview.chart.trend.net_worth": "資產淨值",
    "overview.chart.trend.empty": "暫無資產歷史數據",
    "overview.chart.trend.load_error": "載入數據失敗，請稍後再試",
    "overview.chart.trend.retry": "重試",
    "overview.chart.trend.relogin": "重新登入",
    "overview.chart.breakdown.empty_assets": "尚無資產資料",
    "overview.chart.breakdown.empty_liabilities": "尚無負債資料",
    "account.detail.jar_disposable": "可支配",
    "account.detail.jar_breakdown_title": "存錢罐明細",
    "account.detail.jar_reserve_total": "保留合計",
    "account.detail.jar_deposited": "存入",
    "account.detail.jar_spent": "花費",
    "account.detail.jar_remaining": "餘額",
    "account.detail.jar_breakdown_empty": "此帳戶尚無存錢罐存入或花費紀錄",
    "account.detail.jar_filter_active": "篩選：{name}",
    "account.detail.jar_filter_clear": "顯示全部",
    "account.detail.jar_filter_empty": "此存錢罐尚無花費紀錄",

    // Investment
    "investment.holdings.empty": "尚無持倉",
    "investment.holdings.closed": "已清倉",
    "investment.holdings.closed_count": "({count})",
    "investment.holdings.closed_hint": "點擊可查看歷史分析與交易",
    "investment.holdings.closed_badge": "已清倉",
    "investment.holdings.closed_unit": "檔",
    "investment.holdings.closed_dialog_desc": "{market} · {count} 檔已清倉標的",
    "investment.holdings.closed_empty": "這個市場目前沒有已清倉標的",
    "investment.quote.unavailable": "無法獲取報價",
    "investment.shares": "股",
    "investment.avg_price": "均價",
    "investment.transactions.empty": "尚無交易記錄",
    "investment.chart.distribution": "投資組合分佈",
    "investment.chart.total_value": "總市值",
    "investment.chart.click_return": "點擊返回",
    "investment.unknown_asset": "未知標的",
    "investment.historical_tx": "歷史交易",
    "investment.current_price": "現價",
    "investment.title": "投資組合",
    "investment.sync.now": "立即同步股價",
    "investment.filter.all": "全部",
    "investment.filter.stock_tw": "台股",
    "investment.filter.stock_us": "美股",
    "investment.filter.crypto": "加密貨幣",
    "investment.total_value_est": "總市值估算",
    "investment.total_cost": "總投入成本",
    "investment.total_pl": "累積損益",
    "investment.stock.market_value": "持倉市值",
    "investment.stock.holding_cost": "持倉成本",
    "investment.stock.holding_pl": "持倉損益",
    "investment.stock.back_to_market": "返回市場",
    "investment.stock.clear_filter": "清除篩選",
    "investment.stock.filtered_hint": "點擊圓餅圖或列表可進一步篩選個股",
    "investment.tab.holdings": "持倉部位",
    "investment.tab.analysis": "分析",
    "investment.tab.transactions": "交易紀錄",
    "investment.analysis.trend": "資產趨勢",
    "investment.analysis.returns": "累積報酬率",
    "investment.analysis.period_pl": "期間損益",
    
    // Investment Dialog
    "investment.dialog.title.add": "新增交易",
    "investment.dialog.title.edit": "編輯交易",
    "investment.dialog.delete.tooltip": "刪除交易",
    "investment.dialog.delete.confirm": "確定要刪除這筆交易紀錄嗎？刪除後將無法復原，且會還原帳戶餘額。",
    "investment.dialog.delete.error": "刪除失敗",
    "investment.dialog.submit.error.update": "更新失敗",
    "investment.dialog.submit.error.add": "新增失敗",
    "investment.dialog.submit.error.insufficient_balance": "付款帳戶餘額不足，請確認帳戶中有足夠的資金再進行買入。",
    "investment.dialog.required": "請填寫所有必填欄位",
    "investment.action.buy": "買入",
    "investment.action.sell": "賣出",
    "investment.field.ticker": "股票代號",
    "investment.field.ticker.placeholder": "例如: 2330",
    "investment.field.name": "名稱 (選填)",
    "investment.field.quantity": "股數",
    "investment.field.price": "成交價",
    "investment.field.fees": "手續費",
    "investment.field.date": "交易日期",
    "investment.field.date.clear": "清除日期 (設為歷史部位)",
    "investment.field.history_note": "歷史部位：不顯示於價格走勢圖",
    "investment.status.searching": "查詢中...",
    "investment.status.found": "已找到",
    "investment.status.processing": "處理中...",
    "investment.flow.title": "資金流向",
    "investment.account.payment": "付款帳戶",
    "investment.account.deposit": "入帳帳戶",
    "investment.account.broker": "證券帳戶",
    "investment.account.select.payment": "選擇付款帳戶",
    "investment.account.select.deposit": "選擇入帳帳戶",
    "investment.account.select.broker": "選擇證券(持倉)帳戶",
    "investment.account.select.payment_desc": "選擇資金來源或去向",
    "investment.account.select.broker_desc": "選擇交易使用的證券戶",
    "investment.summary.total_est": "總金額",
    "investment.summary.tap_to_input": "點擊金額直接輸入",
    "investment.summary.manual_total_hint": "可直接輸入總金額，系統會自動回填成交價（未填股數時會以 1 股計算）",
    "investment.summary.confirm_total": "確認總金額",
    "investment.summary.cancel_total": "取消輸入總金額",
    "investment.summary.invalid_total": "請輸入有效的總金額",
    "investment.submit.update": "更新交易",
    "investment.submit.confirm_buy": "確認買入",
    "investment.submit.confirm_sell": "確認賣出",
    "investment.period.1m": "1月",
    "investment.period.3m": "3月",
    "investment.period.6m": "6月",
    "investment.period.1y": "1年",
    "investment.period.2y": "2年",
    "investment.chart.price": "價格",
    "investment.chart.avg_cost": "均價",
    "investment.chart.no_data": "無歷史數據",
    "investment.legend.buy": "買入點",
    "investment.legend.sell": "賣出點",
    "investment.legend.avg": "均價線",
    "investment.chart.period.1m": "1個月",
    "investment.chart.period.3m": "3個月",
    "investment.chart.period.6m": "6個月",
    "investment.chart.period.1y": "1年",
    "investment.chart.period.max": "全部",
    "investment.tooltip.total_assets": "總資產",
    "investment.tooltip.total_cost": "成本",
    "investment.tooltip.profit_loss": "損益",
    "investment.status.loading": "載入中...",
    "investment.status.loading_chart": "整理圖表中",
    "investment.status.loading_chart_hint": "正在彙整走勢，稍等一下",
    "investment.status.load_failed": "載入失敗",
    "investment.status.retry": "請重試",
    "investment.chart.no_history": "尚無投資記錄",
    "investment.chart.start_asset": "期初資產",
    "investment.chart.current_asset": "現在資產",
    "investment.chart.period_return": "期間報酬",
    "investment.chart.return_comparison": "累積報酬比較",
    "investment.label.cumulative_return": "累積報酬",
    "investment.stats.max_return": "最高報酬",
    "investment.stats.max_drawdown": "最大回撤",
    "investment.tooltip.invested": "投入",
    "investment.tooltip.current_value": "現值",
    "investment.tooltip.return": "報酬",
    "investment.legend.my_return": "我的報酬率",
    "investment.chart.period_profit": "期間損益",
    "investment.period_chart.segment": "這段期間",
    "investment.period_chart.segment_max_profit": "區間最高獲利",
    "investment.period_chart.segment_max_loss": "區間最大虧損",
    "investment.period_chart.month_max_profit": "單月最高獲利",
    "investment.period_chart.month_max_loss": "單月最大虧損",
    "investment.period_chart.total_formula": "期間總損益 = 各區間投資損益加總",
    "investment.period_chart.net_flow_desc": "該區間內買入／賣出的本金進出，不代表投資獲利。",
    "investment.period_chart.return_desc": "扣除本金進出後，該區間市場真正幫你賺或賠的金額。",
    "investment.tooltip.net_flow": "淨流入",
    "investment.tooltip.investment_return": "投資收益",
    "investment.stats.total_return": "總收益",
    "investment.stats.max_profit": "最大獲利",
    "investment.stats.max_loss": "最大虧損",
    "investment.action.show_investment_only": "只顯示投資損益",

    // Ledger
    "ledger.title": "記帳本",
    "ledger.balance.monthly": "本月結餘",
    "ledger.ai.smart_import": "AI 智慧匯入",
    "ledger.ai.new_records_found": "發現新紀錄",
    "ledger.ai.pending_count": "筆待確認",
    "ledger.ai.pending_capsule": "待確認",
    "fab.create.mode_hint": "左右滑可切換記帳、轉帳、借貸",
    "fab.create.mode.entry": "記帳",
    "fab.create.mode.transfer": "轉帳",
    "fab.create.mode.loan": "借貸",
    "ledger.filter.active": "篩選中：",
    "ledger.filter.system": "計入月收支",
    "ledger.filter.monthly_stats_only": "計入月收支",
    "ledger.filter.all_entries": "全部明細",
    "ledger.badge.duplicate": "疑似重複",
    "ledger.badge.check": "需檢查",
    "ledger.pending.category": "待確認交易",
    "ledger.pending.account": "待確認帳戶",

    // Voice
    "voice.title": "AI 語音記帳",
    "voice.mic.hold": "按住說話", // Though UI logic is toggle or hold, text usually static
    "voice.mic.release": "放開結束",
    "voice.status.listening": "正在聆聽...",
    "voice.status.processing": "正在分析...",
    "voice.status.heard": "我聽到了...",
    "voice.status.prompt_native": "請說話...",
    "voice.status.prompt_web": "請說話",
    "voice.action.retry": "重說",
    "voice.action.analyze": "分析",
    "voice.error.no_speech": "沒有偵測到語音",
    "voice.error.no_speech.desc": "請重試並確保麥克風收音正常",
    "voice.error.parse_failed": "分析失敗",
    "voice.error.ai_unclear": "AI 無法理解您的語音內容，請重試",
    "voice.error.login_required": "請先登入才能使用此功能",
    "voice.error.permission": "權限不足",
    "voice.error.permission.desc": "請允許麥克風與語音辨識權限",
    "voice.error.unsupported": "不支援語音輸入",
    "voice.error.unsupported.desc": "您的瀏覽器不支援語音辨識功能",

    // Import Review
    "import.review.title": "確認交易",
    "import.review.desc": "請確認 AI 解析的內容是否正確",
    "import.review.desc_merchant": "描述 / 商店",
    "import.review.amount": "金額",
    "import.review.date": "日期",
    "import.review.category": "分類",
    "import.review.category_placeholder": "選擇分類",
    "import.review.account": "帳戶",
    "import.review.account_placeholder": "選擇帳戶",
    "import.review.ai_suggestion": "AI 建議",
    "import.review.confirm": "確認加入",
    "import.review.delete": "刪除",
    "import.review.toast.confirmed": "已確認",
    "import.review.toast.added": "交易已加入帳本",
    "import.review.toast.deleted": "已刪除",
    "import.review.toast.removed": "交易已移除",
    "import.review.pending_title": "待確認交易 ({count})",
    "import.review.pending_desc": "請確認 AI 解析的交易內容",
    "import.review.group": "轉帳交易群組 ({count} 筆) - 將同時處理",
    "import.review.duplicate": "偵測到這筆交易可能已存在 (重複)",
    "import.review.confirm_all": "確認全部 ({count})",
    "import.review.confirm_single": "確認加入",
    "import.review.reject_all": "全部刪除",
    "import.review.reject_single": "刪除",
    "import.review.toast.group_confirmed": "{count} 筆關聯交易已加入",
    "import.review.toast.group_rejected": "已忽略關聯交易",
    "import.review.toast.failed": "失敗",
    "import.review.toast.delete_failed": "刪除失敗",
    "import.review.original_text": "原始文字",

    // AI Text Import
    "ai.paste.title": "AI 智慧匯入",
    "ai.paste.desc": "貼上交易文字，AI 自動識別日期與金額",
    "ai.paste.placeholder": "例：昨天午餐吃麥當勞花了 149 元",
    "ai.paste.example": "快帶範例:",
    "ai.paste.example.lunch": "午餐麥當勞",
    "ai.paste.example.phone": "電話費",
    "ai.paste.analyze": "開始分析",
    "ai.paste.analyzing": "分析中...",
    "ai.paste.cancel": "取消",
    "ai.paste.success": "分析完成",
    "ai.paste.success_desc": "已成功解析並加入待確認項目",
    "ai.paste.fail": "分析失敗",
    "ai.paste.fail_desc": "請重試或檢查網路連線",
    "common.loading": "載入中...",
    "common.all": "全部",
    "common.others": "其他",
    "common.view": "檢視",
    "common.save": "儲存",
    "common.delete": "刪除",
    "common.cancel": "取消",
    "common.delete_confirm_title": "確認刪除「{name}」？",
    "common.delete_confirm_desc": "此操作無法復原。",
    "common.delete_confirm_action": "確認刪除",
    "common.success": "成功",
    "common.error": "錯誤",
    "common.confirm": "確認",
    "common.edit": "編輯",
    "common.back": "返回",
    "common.next": "下一步",
    "common.done": "完成",
    "common.processing": "處理中...",
    "common.updating": "更新中...",
    "common.confirm_selection": "確認選取",
    "common.back_edit": "返回修改",

    // Budget Status Dialog
    "budget.status.title": "本月預算",
    "budget.status.total_available": "總可支配",
    "budget.status.remaining": "剩餘",
    "budget.status.expenses": "支出",
    "budget.status.daily_avg": "日均 (扣除固定支出)",
    "budget.status.view_daily_gross": "日均預算",
    "budget.status.view_daily_net": "日均 (扣除固定支出)",
    "budget.status.view_weekly_gross": "週預算",
    "budget.status.view_weekly_net": "週預算 (扣除固定支出)",
    "budget.status.spendable_remaining": "剩餘可支配",
    "budget.status.net_spendable": "淨可支配",
    "budget.status.title_current": "本月預算狀況",
    "budget.status.title_history": "歷史預算結算",
    "budget.status.remaining_label_current": "本月剩餘總額",
    "budget.status.remaining_label_history": "本月最終結餘",
    "budget.status.days_remaining": "剩 {count} 天",
    "budget.status.settled": "已結算",
    "budget.status.overview": "本月總覽",
    "budget.status.used": "已用",
    "budget.status.spendable": "可支配預算",
    "budget.status.total": "總預算",
    "budget.legend.budget": "預算",
    "budget.legend.savings": "儲蓄",
    "budget.mode.suggestion": "建議進度",
    "budget.mode.toggle_display": "切換顯示",
    "budget.mode.spendable_only": "僅看預算",
    "budget.unit.day": "/天",
    "budget.unit.week": "/週",
    "budget.status.final_balance": "最終結餘",
    "budget.status.goal_rate": "目標達成率",
    "budget.status.over_budget": "已超支",
    "budget.status.no_budget": "無預算",
    "budget.status.no_savings_goal": "無目標",
    "budget.status.diff": "差 NT$ {amount}",
    "budget.status.view_transactions": "查看記帳明細",
    "budget.status.view_transactions_hint": "帶你查看 {category} 在本月的所有交易",
    "budget.status.details_short": "明細",
    "budget.list.title": "類別進度列表",
    "budget.category.fixed": "固定開銷",
    "budget.category.living": "生活費",
    "budget.category.jars": "存錢罐消費",
    "common.no_items": "尚無項目",
    
    // Income/Expense Detail Dialog
    "ledger.dashboard.income": "收入",
    "ledger.dashboard.expense": "支出",
    "ledger.dialog.month_income": "月收入",
    "ledger.dialog.month_expense": "月支出",
    "ledger.dialog.total_month": "本月總計",
    "ledger.dialog.total_3m": "近 3 個月總計",
    "ledger.dialog.total_6m": "近 6 個月總計",
    "ledger.dialog.total_1y": "近 1 年總計",
    "ledger.dialog.total_max": "近 24 個月總計",
    "ledger.dialog.trend": "趨勢",
    "ledger.dialog.categories": "分類",
    "ledger.dialog.accounts": "帳戶",
    "ledger.dialog.time_range": "時間範圍",
    "ledger.dialog.category_stats": "類別統計",
    "ledger.dialog.category_filter_hint": "點類別看趨勢",
    "ledger.dialog.filtered_trend": "{category} 本月",
    "ledger.dialog.filtered_range_total": "{category} · {range}",
    "ledger.dialog.clear_category_filter": "顯示全部",
    "ledger.dialog.no_record_income": "本月尚無收入紀錄",
    "ledger.dialog.no_record_expense": "本月尚無支出紀錄",
    "ledger.dialog.start_tracking": "開始記一筆吧！",
    "common.count_suffix": " 筆",

    "budget.display.living_budget": "生活費預算",
    "budget.display.monthly_budget": "本月預算",
    
    // 🆕 Updated Label: "可支配預算" is concise and technically correct (Disposable Income)
    "budget.display.disposable_budget": "可支配預算",
    "budget.display.fixed_living": "固定支出 + 生活費",
    "budget.display.final_balance": "最終結餘",
    "budget.display.available": "可用",
    "budget.display.unconfigured": "未配置",
    "budget.display.from_group": "預算來自群組「{group}」",
    "budget.display.group_usage": "群組已用 {used} / {total}",
    "budget.display.no_category_budget": "此類別本月無配置預算",
    "budget.action.switch_view": "切換顯示",
    "budget.action.click_restore": "點擊還原",
    "budget.legend.target_savings": "目標儲蓄",
    "budget.legend.savings_investment": "儲蓄與投資", // Updated: Savings & Investment
    "budget.chart.expense_distribution": "支出類別分布",
    "budget.chart.income_distribution": "收入類別分布",
    "common.total_income": "總收入",
    "common.total_expense": "總支出",
    "common.no_data": "無資料",
    "common.try_again_later": "請稍後再試",

    // Dialogs - Add Entry
    "dialog.add_entry": "新增記帳",
    "dialog.add_entry.desc": "輸入金額、類別與日期來新增一筆收支紀錄。",
    "common.expense": "支出",
    "common.income": "收入",
    "entry.delete.tooltip": "刪除此筆交易",
    "entry.delete.title": "確認刪除此筆交易",
    "entry.delete.irreversible": "此操作無法復原，確認要刪除嗎？",
    "entry.delete.confirm": "確認刪除",
    "entry.delete.failed": "刪除失敗",
    "entry.delete.scope.title": "要怎麼刪除這筆交易？",
    "entry.delete.scope.desc": "選擇刪除範圍，確認後無法復原",
    "entry.delete.scope.with_loan_theme": "刪除交易與借貸主題",
    "entry.delete.scope.all_related": "借貸相關交易全刪",
    "entry.delete.package_title": "刪除這筆借貸交易？",
    "entry.delete.package_desc": "將同步刪除借貸主題，以及所有相關還款／收款交易。此操作無法復原。",
    "entry.delete.package_continue": "繼續",
    "entry.delete.package_confirm_title": "確認影響",
    "entry.delete.package_confirm_desc": "相關帳戶餘額會還原，總資產可能改變。此操作無法復原。",
    "entry.delete.package_balance_warning": "這會刪除記帳紀錄並回滾餘額，不是只結束借貸追蹤。",
    "entry.delete.package_balance_note": "相關帳戶餘額會還原。",
    "entry.delete.package_related_count": "另含 {count} 筆相關還款／收款交易也會一併刪除",
    "entry.delete.package_remaining_lent": "尚有未收回 {amount}",
    "entry.delete.package_remaining_borrowed": "尚有未還清 {amount}",
    "entry.delete.package_nw_unchanged": "此筆已結清，刪除後總資產預計不變。",
    "entry.delete.package_nw_increase": "刪除後總資產預計約增加 {amount}（取消未收回扣除）。",
    "entry.delete.package_nw_stable": "往來帳戶若均計入總資產，刪除後總資產預計大致不變。",
    "entry.delete.package_confirm": "確認刪除",
    "entry.delete.warning.loan_item": "將同步刪除對應借貸借款項目。",
    "entry.delete.warning.repayment": "將同步刪除對應借貸還款紀錄，並更新剩餘金額。",
    "entry.split.title": "分帳設定",
    "entry.split.subtitle": "分配這筆款項的承擔者",
    "entry.split.toggle_hint_advance": "此為代墊帳戶 (建議設定分帳)",
    "entry.split.toggle_title": "分帳設定",
    "entry.split.partner_default": "對方",
    "entry.split.me": "我",
    "entry.split.advance_badge": "先行代墊",
    "entry.split.account_advance_fallback": "代墊帳戶",
    "entry.split.account_unselected": "未選擇帳戶",
    "entry.split.my_portion": "我的部分",
    "entry.split.partner_portion": "{name}的部分",
    "entry.split.self_absorb": "自行吸收",
    "entry.split.partner_absorb": "對方吸收",
    "entry.split.targets_section": "分帳對象",
    "entry.split.my_share": "我的分擔",
    "entry.split.partner_account": "對方帳戶",
    "entry.split.summary.partner_bears": "{name}負擔: {amount}",
    "entry.split.summary.partner_share": "{name}分擔: {amount}",
    "entry.split.summary.self_absorb": "自己吸收: {amount}",
    "entry.split.summary.joined": "{parts}",
    "entry.split.summary.partner_bears_self_absorb": "{name}負擔: {partner} | 自己吸收: {self}{loan}",
    "entry.split.summary.partner_share_self_absorb": "{name}分擔: {partner} | 自己吸收: {self}{loan}",
    "entry.split.link_partner.title": "連結分帳對象: {name}",
    "entry.split.link_partner.desc": "選擇屬於此分帳對象的真實帳戶",
    "entry.split.link_partner.action": "連結分帳對象",
    "entry.split.add.title": "選擇分帳對象",
    "entry.split.add.desc": "選擇要共同分擔這筆款項的成員",
    "entry.split.add.action": "新增分帳對象",
    "entry.split.add.disabled_public_wallet": "公費/共同錢包無法使用分帳功能",
    "entry.split.remove.locked": "必要分帳對象，無法移除",
    "entry.split.remove.action": "移除分帳對象",
    "entry.split.stats.include_mine": "計入我的月支出",
    "entry.split.stats.exclude_mine": "不計入我的月支出",
    "entry.split.stats.advance_included": "代墊對方份已計入我的月支出",
    "entry.split.stats.advance_excluded": "代墊對方份不計入我的月支出",
    "entry.split.mode.equal": "平均分配",
    "entry.split.mode.other_pays": "他人全付",
    "entry.split.mode.self_pays": "個人全付",
    "entry.split.mode.unlinked_advance_hint": "未連結代墊僅能個人全付，金額即為整筆代墊消費",
    "entry.split.mode.custom": "自訂金額",
    "entry.split.over_limit": "分帳總額 {splitTotal} 超過交易金額 {mainTotal}，請重新調整各分帳金額，或回到上一頁修改交易總額。",
    "entry.split.over_limit_btn": "分帳金額超出總額",
    "entry.split.confirm": "確認儲存分帳",
    "entry.split.loan.select_title": "選擇借貸主題",
    "entry.split.loan.no_link": "不關聯",
    "entry.split.loan.no_link_desc": "只記分帳，不連動借貸",
    "entry.split.loan.remaining": "剩餘 {amount}",
    "entry.split.loan.link": "關聯借貸",
    "entry.split.loan.link_optional": "關聯借貸（選填）",
    "entry.split.loan.summary": " | 關聯借貸: {title}",
    "entry.split.loan.clear": "清除關聯",
    "entry.split.loan.clear_locked": "借貸主題已鎖定，無法清除",
    "entry.split.category_locked_full": "無個人消費分擔，類別鎖定為轉帳",
    "entry.split.category_unlock_hint": "調整自己的分擔後即可變更類別",
    "entry.split.switch_account_hint": "改選我的帳戶",
    "entry.split.error.income_advance_title": "收入不可使用代墊分帳帳戶",
    "entry.split.error.income_advance_desc": "請改選我的帳戶後再儲存",
    "entry.split.error.missing_targets_title": "分帳設定錯誤",
    "entry.split.error.missing_targets_desc": "使用代墊帳戶必須設定分帳對象 (不能僅有自己)",
    "entry.split.saved_loan_sync_failed_title": "分帳已儲存",
    "entry.split.saved_loan_sync_failed_desc": "借貸關聯未完成，可稍後再編輯補上",
    "entry.split.with_count": "與 {count} 個人分帳",
    "entry.split.with_name": "與 {name} 分帳",
    "entry.split.partner_placeholder": "分帳對象",
    "entry.loading.title": "正在準備交易資料",
    "entry.loading.prefill_account": "正在帶入正確的付款帳戶…",
    "entry.loading.sync_categories": "正在同步類別與群組…",
    "entry.validation.select_category": "請選擇類別",
    "entry.validation.select_account": "請選擇帳戶",
    "entry.validation.enter_amount": "請輸入金額",
    "entry.validation.fixed_loading_title": "固定開銷資料載入中",
    "entry.validation.fixed_loading_desc": "請稍候再儲存",
    "entry.save.success": "記帳成功",
    "entry.save.updated": "更新成功",
    "entry.save.created": "新增成功",
    "entry.save.failed_update": "更新失敗",
    "entry.save.failed_create": "新增失敗",
    "entry.save.recorded": "已記錄 {category} {amount}",
    "entry.account.empty_title": "尚未建立帳戶",
    "entry.account.empty_desc": "先建立帳戶才能繼續記帳",
    "entry.account.empty_action": "前往建立帳戶",
    "entry.jar.create_prompt": "找不到要的存錢罐？",
    "entry.jar.create_desc": "離開此頁後前往存錢罐建立",
    "entry.fixed.budget_label": "預算: {amount}",
    "entry.fixed.create_prompt": "找不到要的固定開銷？",
    "entry.fixed.create_desc": "離開此頁後前往固定開銷建立",
    "ledger.badge.holding": "持倉",
    "ledger.badge.no_account": "未設定帳戶",
    "ledger.badge.pending_action": "待選擇處理方式",
    "ledger.balance.adjust_note_again": "再次調整帳戶餘額",
    "ledger.tasks.toggle": "財務待辦",
    "ledger.account.unknown": "未知帳戶",
    "ledger.account.unnamed": "未命名帳戶",
    "ledger.edit.not_found": "找不到可編輯的記帳項目",
    "ledger.edit.open_linked_failed": "無法開啟關聯記帳",
    "ledger.convert.failed": "轉換失敗",
    "ledger.convert.missing_data": "缺少必要的轉換資料",
    "ledger.convert.missing_fields": "缺少必要欄位：{fields}",
    "ledger.special_choice.title": "請選擇處理方式",
    "ledger.special_choice.desc": "選擇實際帳戶或轉為一般支出",
    "ledger.special_choice.pick_account": "選擇實際收款帳戶",
    "ledger.special_choice.convert_expense": "轉為一般支出",
    "ledger.special_choice.lend_land_fail_title": "無法開啟借入落地",
    "ledger.special_choice.lend_land_fail_desc": "找不到對應的借入鏡像主題。請下拉刷新借貸列表後再試；若仍沒有，代表建立借出時未成功建立對方主題。",
    "loan.toast.mirror_recipient_missing": "無法建立對方的借貸鏡像，請確認已連結對象後重試",
    "entry.manage_categories": "類別管理",
    "entry.all": "全部",
    "entry.calc_result": "計算結果",
    "entry.confirm": "確認",
    "entry.date_select": "選擇日期",
    "entry.exclude_stats": "不計入月收支",
    "entry.include_stats": "計入月收支",
    "entry.convert.title": "匯率換算",
    "entry.convert.desc": "已將金額從 {from} 換算為 {to}",
    "entry.full_note": "完整備註",
    "entry.expand_note": "展開完整編輯",
    "entry.note": "備註",
    "entry.note_details": "輸入詳細備註內容...",
    "entry.select_account": "選擇帳戶",
    "entry.savings_jar": "存錢罐",
    "entry.fixed_expense": "固定開銷",
    "entry.account.title": "選擇帳戶",
    "entry.account.desc": "選擇扣款或入帳的帳戶",
    "entry.account.search_placeholder": "搜尋帳戶...",
    "entry.account.empty": "尚未新增帳戶",
    "entry.jar.title": "選擇存錢罐",
    "entry.jar.desc": "選擇資金來源的存錢罐",
    "entry.jar.search_placeholder": "搜尋存錢罐...",
    "entry.jar.no_selection": "不使用存錢罐",
    "entry.jar.no_selection_desc": "一般帳戶支出",
    "entry.account.suggested_title": "建議帳戶",
    "entry.account.suggested_badge": "建議",
    "entry.account.suggested_for": "已選「{name}」· 建議帳戶",
    "entry.jar.suggested_badge": "建議",
    "entry.jar.suggested_for": "已選「{name}」· 建議存錢罐",
    "entry.fixed.title": "固定開銷",
    "entry.fixed.desc": "選擇專款專用的固定開銷項目",
    "entry.fixed.search_placeholder": "搜尋固定開銷...",
    "entry.fixed.no_selection": "不指定固定開銷",

    // Transfer
    "transfer.title": "轉帳",
    "transfer.edit_title": "編輯轉帳",
    "transfer.from": "轉出帳戶",
    "transfer.domain.daily": "日常帳戶",
    "transfer.domain.daily.desc": "銀行存款、現金、外幣與信用卡之間互轉",
    "transfer.domain.shared": "共同帳戶",
    "transfer.domain.shared.desc": "公費存提，或跟對方收款、還款",
    "transfer.intent.pool": "公費調撥",
    "transfer.intent.pool.desc": "把錢存進或轉出共同帳戶",
    "transfer.intent.collect": "收款",
    "transfer.intent.collect.desc": "對方還你",
    "transfer.intent.repay": "還款",
    "transfer.intent.repay.desc": "你還對方",
    "transfer.kind.normal": "一般轉帳",
    "transfer.kind.lend": "借出",
    "transfer.kind.borrow": "借入",
    "transfer.kind.repay": "還款",
    "transfer.kind.collect": "收款",
    "transfer.detail.normal": "在自己的日常帳戶之間搬移資金，例如活存互轉、現金存提、外幣轉換，或用存款繳信用卡。可選計入月支出或月收入（擇一），預設不計入。",
    "transfer.detail.lend": "第一次借錢給對方。轉出：活存或信用卡；轉入：對方代墊帳戶。若勾選計月支出，會反映在本月花費。",
    "transfer.detail.borrow": "第一次向對方借錢。轉出：對方代墊帳戶；轉入：活存或信用卡（例如借來還卡）。若勾選計月收入，會列入本月收入。",
    "transfer.detail.repay": "你還對方欠款。轉出：你的日常帳戶；轉入：代墊帳戶或共同帳戶。可選計入月支出，用來反映這筆還款。",
    "transfer.detail.collect": "對方還你欠款。轉出：對方的代墊帳戶；轉入：你的日常帳戶。可選計入月收入，用來反映這筆收款。",
    "transfer.detail.pool": "在你的日常帳戶與共同帳戶（公費）之間互轉：一邊必須是共同帳戶，另一邊必須是私人日常帳戶，兩個共同帳戶不能互轉。可選計入月支出或月收入（擇一），預設不計入。",
    "transfer.count_monthly_expense": "計入月支出",
    "transfer.count_monthly_income": "計入月收入",
    "transfer.info.open": "查看說明",
    "transfer.info.close": "關閉說明",
    "transfer.loan.link": "關聯借貸",
    "transfer.loan.link_optional": "關聯借貸（選填）",
    "transfer.loan.none": "不關聯",
    "transfer.loan.none_desc": "只記轉帳，不連動借貸",
    "transfer.loan.pick_title": "選擇借貸主題",
    "transfer.loan.remaining": "剩餘 NT$ {amount}",
    "transfer.loan.prefix": "借貸：{title}",
    "transfer.loan.clear": "清除關聯",
    "transfer.loan.locked_clear": "借貸主題已鎖定，無法清除",
    "transfer.label.transferor": "轉出人",
    "transfer.label.payer_account": "付款帳戶",
    "transfer.label.collect_account": "收款帳戶",
    "transfer.label.recipient": "轉入對象",
    "transfer.label.advance_account": "代墊帳戶",
    "transfer.label.repay_account": "還款帳戶",
    "transfer.label.via_advance": "透過代墊",
    "transfer.member_fallback": "成員",
    "transfer.pick_from": "請選擇轉出帳戶",
    "transfer.pick_from_first": "請先選擇轉出帳戶",
    "transfer.swap_accounts": "對調轉出與轉入帳戶",
    "transfer.fee_readonly_hint": "手續費由付款方設定，僅供檢視",
    "transfer.fee_readonly_unlinked_hint": "未連結成員無法負擔手續費",
    "transfer.mismatch.both": "轉出與轉入帳戶不符合「{kind}」類別，請重新選擇",
    "transfer.mismatch.from": "轉出帳戶不符合「{kind}」類別，請重新選擇",
    "transfer.mismatch.to": "轉入帳戶不符合「{kind}」類別，請重新選擇",
    "transfer.success_title": "轉帳成功",
    "transfer.to": "轉入帳戶",
    "transfer.amount": "金額",
    "transfer.fee": "手續費",
    "transfer.date": "日期",
    "transfer.note": "備註",
    "transfer.submit": "確認轉帳",
    "transfer.confirm_transfer": "確認轉帳",

    // Loans
    "loans.page.title": "借貸紀錄",
    "loans.action.add": "新增借貸項目",
    "loans.empty.title": "還沒有任何借貸紀錄",
    "loans.empty.desc": "先建立代墊分帳帳戶，或點擊右上角「新增借貸項目」開始記錄。",
    "loans.empty.cta": "建立第一筆借貸",
    "loans.empty.no_themes": "這位對象目前尚無借款主題，僅顯示代墊分帳帳戶餘額。",
    "loans.empty.no_lent": "目前沒有借出紀錄",
    "loans.empty.no_borrowed": "目前沒有借入紀錄",
    "loans.list.title": "所有借貸",
    "loans.list.all_borrowings": "所有借款",
    "loans.overview.title": "借貸總覽",
    "loans.overview.calc_hint": "依代墊分帳帳戶餘額計算（點擊查看組成）",
    "loans.net.they_owe": "別人欠你",
    "loans.net.you_owe": "你欠別人",
    "loans.net.even": "持平",
    "loans.registered.lent": "已登記借出",
    "loans.registered.borrowed": "已登記借入",
    "loans.theme_count": "{count} 筆主題",
    "loans.account_count": "{count} 個帳戶",
    "loans.person.even": "雙方持平",
    "loans.person.they_owe": "對方欠你錢",
    "loans.person.you_owe": "你欠對方錢",
    "loans.unallocated.hint": "尚未分配到借款主題",
    "loans.cleared_count": "已完成 {count} 筆",
    "loans.hidden_count": "已隱藏 {count} 筆",
    "loans.composition.subtitle": "依對象查看往來餘額與帳戶細節",
    "loans.composition.empty": "目前沒有可計算的代墊分帳帳戶。",
    "loans.composition.total": "加總結果",
    "loans.composition.title_person": "{person} 的帳戶組成",
    "loans.composition.title_overview": "借貸總覽組成",
    "loans.composition.net_position": "淨往來",
    "loans.composition.breakdown": "借貸明細",
    "loans.composition.lent": "對方欠你",
    "loans.composition.borrowed": "你欠對方",
    "loans.composition.account_count": "{count} 個帳戶",
    "loans.composition.person_net": "小計",
    "loans.settings.label": "借貸記錄",
    "loans.settings.desc": "借款還款管理",
    "loan.status.recovered": "已收回",
    "loan.status.cleared": "已還清",
    "loan.status.active": "進行中",
    "loan.status.hidden": "已隱藏",
    "loan.badge.deducted": "已扣資產",
    "loan.badge.not_deducted": "未扣資產",
    "loan.badge.included": "已入資產",
    "loan.badge.not_included": "未入資產",
    "loan.badge.deduct_short": "扣資產",
    "loan.badge.include_short": "納入資產",
    "loan.badge.initial_transfer": "初始轉帳",
    "loan.badge.receipt": "收款",
    "loan.direction.lent_to": "借出給",
    "loan.direction.borrowed_from": "借入自",
    "loan.original_amount": "原始 {amount}",
    "loan.linked_account": "連動帳戶：{name}",
    "loan.mode.lend": "借出",
    "loan.mode.borrow": "借入",
    "loan.dialog.edit_title": "編輯借貸",
    "loan.dialog.create_title": "新增借貸",
    "loan.action.save_changes": "儲存變更",
    "loan.action.create_lend": "建立借出項目",
    "loan.action.create_borrow": "建立借入項目",
    "loan.action.saving": "儲存中…",
    "loan.action.creating": "建立中…",
    "loan.action.create_now": "立即建立",
    "loan.action.quick_create_split": "找不到對象？快速建立分帳帳戶 →",
    "loan.action.allocate": "分配到此借款",
    "loan.action.register_receipt": "登記收款",
    "loan.action.register_repayment": "登記還款",
    "loan.action.go_edit": "前往編輯",
    "loan.action.edit": "編輯",
    "loan.swipe.edit": "編輯",
    "loan.swipe.hide": "隱藏",
    "loan.swipe.delete": "刪除",
    "loan.field.counterparty": "借貸對象",
    "loan.field.linked_advance": "連動代墊帳戶",
    "loan.field.title": "借款主題",
    "loan.field.title_placeholder": "例：機票墊付、便當錢",
    "loan.field.note": "備註（選填）",
    "loan.field.note_placeholder": "補充說明（可略過）",
    "loan.field.receipt_account": "收款帳戶",
    "loan.field.payment_account": "付款帳戶",
    "loan.select.counterparty": "選擇借貸對象",
    "loan.select.linked_advance": "選擇連動代墊帳戶",
    "loan.select.linked_account": "請選擇連動帳戶",
    "loan.select.receipt_account": "選擇收款帳戶",
    "loan.select.payment_account": "選擇付款帳戶",
    "loan.select.cash_out_account": "選擇借出帳戶",
    "loan.select.receipt_account.desc": "選擇收款的現金帳戶",
    "loan.select.payment_account.desc": "選擇付款的現金帳戶",
    "loan.select.cash_out_account.desc": "選擇借出資金的帳戶",
    "loan.select.linked_advance.for_person": "為「{name}」選擇連動代墊帳戶",
    "loan.select.linked_advance.desc": "用於追蹤雙方往來餘額",
    "loan.hint.select_counterparty_first": "請先選擇借貸對象",
    "loan.empty.no_counterparties": "尚未建立可借貸對象",
    "loan.empty.no_advance_for_person": "此對象尚無可用代墊帳戶",
    "loan.empty.receipt_accounts": "沒有可用的收款帳戶",
    "loan.empty.payment_accounts": "沒有可用的付款帳戶",
    "loan.empty.receipts": "尚無收款紀錄",
    "loan.empty.repayments": "尚無還款紀錄",
    "loan.person.unlinked": "尚未連結成員",
    "loan.person.advance_count": "{count} 個代墊帳戶",
    "loan.section.standalone_advance": "獨立代墊帳戶",
    "loan.section.origin": "借貸建立",
    "loan.section.origin_hint": "本金從哪裡轉出／轉入",
    "loan.section.receipts": "收款紀錄",
    "loan.section.repayments": "還款紀錄",
    "loan.section.settlement_hint_receipts": "由近到遠",
    "loan.section.settlement_hint_repayments": "由近到遠",
    "loan.account.selected": "已選帳戶",
    "loan.account.advance_fallback": "代墊帳戶",
    "loan.option.deduct_networth": "扣除總資產",
    "loan.option.include_networth": "納入總資產",
    "loan.option.count_monthly_expense": "計入月支出",
    "loan.option.count_monthly_income": "計入月收入",
    "loan.networth.disabled_hint": "此連動帳戶未計入總資產，無需額外扣除",
    "loan.fee.readonly_hint": "手續費由付款方設定，僅供檢視",
    "loan.fee.readonly_unlinked_hint": "未連結成員無法負擔手續費",
    "loan.progress.recovered": "已收回",
    "loan.progress.repaid": "已還款",
    "loan.progress.pending_recover": "待收回",
    "loan.progress.outstanding": "尚欠",
    "loan.progress.footer": "原始 {amount} · {pct}% {verb}",
    "loan.unallocated.banner": "{name} 有 {count} 筆未分配款項",
    "loan.transfer.from_out": "從 {name} 轉出",
    "loan.transfer.from_in": "從 {name} 轉入",
    "loan.initial_transfer": "建立借貸時的初始轉帳",
    "loan.preview.title": "交易明細",
    "loan.preview.date": "日期：{date}",
    "loan.preview.note": "備註：{note}",
    "loan.preview.empty": "此筆交易沒有可顯示的分錄明細。",
    "loan.delete.title": "刪除借貸？",
    "loan.delete.desc": "可選擇是否一併刪除相關交易紀錄。",
    "loan.delete.keep_tx": "只刪借貸主題，保留交易",
    "loan.delete.with_tx": "刪除借貸並刪除相關交易",
    "loan.delete.package_title": "刪除整包借貸？",
    "loan.delete.package_desc": "將刪除借貸主題、建立交易，以及所有還款／收款交易。此操作無法復原。",
    "loan.delete.package_continue": "繼續",
    "loan.delete.package_confirm_title": "確認影響",
    "loan.delete.package_confirm_desc": "相關帳戶餘額會還原，總資產數字可能明顯改變。",
    "loan.delete.package_balance_warning": "這會刪除記帳紀錄並回滾帳戶餘額，不是只從借貸列表拿掉。請確認你真的要當作這段借貸沒發生過。",
    "loan.delete.package_balance_note": "相關帳戶餘額會還原。",
    "loan.delete.package_remaining_lent": "尚有未收回 {amount}",
    "loan.delete.package_remaining_borrowed": "尚有未還清 {amount}",
    "loan.delete.package_nw_unchanged": "此筆已結清，刪除後總資產預計不變。",
    "loan.delete.package_nw_increase": "刪除後總資產預計約增加 {amount}（取消未收回扣除）。",
    "loan.delete.package_nw_stable": "往來帳戶若均計入總資產，刪除後總資產預計大致不變。",
    "loan.delete.package_repayments_count": "另含 {count} 筆還款紀錄也會一併刪除",
    "loan.delete.package_receipts_count": "另含 {count} 筆收款紀錄也會一併刪除",
    "loan.delete.package_confirm": "確認刪除",
    "loan.hide.title": "隱藏此借貸？",
    "loan.hide.desc": "會從進行中列表拿掉，記帳紀錄仍保留。之後可在「已隱藏」找回。",
    "loan.action.hide": "隱藏",
    "loan.action.unhide": "取消隱藏",
    "loan.action.delete": "刪除",
    "loan.toast.edit_origin_missing": "找不到初始借貸交易，無法開啟編輯",
    "loan.delete.repayment_title": "刪除還款紀錄？",
    "loan.delete.receipt_title": "刪除收款紀錄？",
    "loan.delete.repayment_desc": "此操作無法復原。",
    "loan.delete.repayment_warning": "將同步刪除記帳頁面的對應交易，並更新剩餘金額。",
    "loan.delete.receipt_warning": "將同步刪除記帳頁面的對應交易，並更新剩餘金額。",
    "common.unnamed_account": "未命名帳戶",
    "common.no_note": "無備註",
    "common.collapse": "收合",
    "common.expand": "展開",
    "common.expand_full": "展開全文",
    "loan.toast.select_counterparty": "請選擇借貸對象",
    "loan.toast.select_title": "請輸入借款主題",
    "loan.toast.select_account": "請選擇帳戶",
    "loan.toast.select_amount": "請輸入金額",
    "loan.toast.select_receipt": "請選擇收款帳戶",
    "loan.toast.select_payment": "請選擇付款帳戶",
    "loan.toast.transfer_group_missing": "找不到對應轉帳群組，無法更新",
    "loan.toast.update_ok": "更新成功",
    "loan.toast.lend_created": "借出成功",
    "loan.toast.borrow_created": "借入項目已建立 ✓",
    "loan.toast.operation_failed": "操作失敗，請稍後再試",
    "loan.toast.deleted_keep_tx": "已刪除借貸主題（交易保留）",
    "loan.toast.deleted_with_tx": "已刪除借貸與相關交易",
    "loan.toast.hidden": "已隱藏借貸主題",
    "loan.toast.unhidden": "已取消隱藏",
    "loan.toast.allocated": "已分配為還款紀錄 ✓",
    "loan.toast.allocate_failed": "分配失敗",
    "loan.toast.record_deleted": "紀錄已刪除",
    "loan.toast.networth_on": "已改為扣除總資產",
    "loan.toast.networth_off": "已取消扣除總資產",
    "loan.toast.networth_include_on": "已改為納入總資產",
    "loan.toast.networth_include_off": "已取消納入總資產",
    "loan.summary.converted_expense": "已轉為 {name} 支出",
    "loan.summary.converted_income": "已轉為 {name} 收入",
    "loan.summary.transferred_in": "已轉入 {name}",
    "loan.summary.transfer_adjust": "轉帳調整",
    "loan.summary.repayment": "還款",
    "loan.summary.receipt": "收款",

    // Category Management
    "category.manage.title": "類別管理",
    "category.manage.desc": "拖曳類別至群組進行分類",
    "category.system.transfer": "轉帳",
    "category.system.transfer_normal": "一般轉帳",
    "category.system.fee": "手續費",
    "category.system.balance_adjustment": "餘額調整",
    "category.system.credit_card_payment": "信用卡還款",
    "category.system.position_increase": "建倉",
    "category.system.position_decrease": "平倉",
    "category.system.stock_buy": "股票買入",
    "category.system.stock_sell": "股票賣出",
    "category.system.group": "系統",
    "category.select.allocation_subtitle": "選擇要加入分配的類別或群組",
    "account.picker.empty_title": "沒有可選帳戶",
    "account.picker.empty_desc": "請先建立帳戶後再繼續",
    "account.picker.no_partners": "沒有分帳對象",
    "account.picker.no_partners_desc": "當您被加入代墊群組時會顯示於此",
    "account.picker.linked_partners": "已連結對象",
    "account.picker.advance_count": "{count} 個代墊帳戶",
    "account.detail.balance_after": "結餘",
    "category.type.expense": "支出類別",
    "category.type.income": "收入類別",
    "category.add": "新增類別",
    "category.create_group": "新增群組",
    "category.edit_group": "編輯群組",
    "category.group_name": "群組名稱",
    "category.group_color": "代表色",
    "category.uncategorized": "未分類",
    "category.empty.drag": "拖曳至此加入群組",
    "category.empty.list": "尚無{type}類別",
    "category.hidden.title": "已隱藏類別",
    "category.hidden.restore": "還原",
    "category.hidden.restore_success": "恢復成功",
    "category.hidden.restore_success_desc": "類別「{name}」已恢復顯示",
    "category.hidden.restore_failed": "恢復失敗",
    "category.hidden.description": "這些類別不會出現在選單中，但保留歷史記錄",
    "category.hidden.empty": "目前沒有隱藏的類別",
    "category.hidden.records_count": "{count} 筆記錄",
    "common.close": "關閉",
    "category.dialog.title.add": "新增類別",
    "category.dialog.title.edit": "編輯類別",
    "category.dialog.name.label": "類別名稱",
    "category.dialog.name.placeholder": "輸入類別名稱 (例如: 早餐)",
    "category.dialog.type": "收支類型",
    "category.dialog.group": "所屬群組",
    "category.dialog.group.select": "選擇群組 (選填)",
    "category.dialog.color": "代表顏色",
    "category.dialog.palette": "調色盤",
    "category.dialog.fine_tune": "微調",
    "category.dialog.saturation": "飽和度",
    "category.dialog.lightness": "亮度",
    "category.dialog.variants": "變化",
    "category.dialog.icon": "圖標",
    "category.dialog.icon.all": "全部",
    "category.dialog.icon.swipe_hint": "左右滑動選擇",
    "icon.category.transport": "交通",
    "icon.category.food": "飲食",
    "icon.category.shopping": "購物",
    "icon.category.housing": "居住",
    "icon.category.entertainment": "娛樂",
    "icon.category.medical": "醫療",
    "icon.category.work": "工作",
    "icon.category.finance": "金融",
    "icon.category.comms": "通訊",
    "icon.category.education": "教育",
    "icon.category.social": "社交",
    "icon.category.animals": "動物",
    "icon.category.services": "服務",
    "icon.category.festival": "節慶",
    "icon.category.nature": "自然",
    "icon.category.other": "其他",
    "category.color.family.red": "紅粉色系",
    "category.color.family.orange": "橘黃色系",
    "category.color.family.green": "綠色系",
    "category.color.family.cyan": "青藍色系",
    "category.color.family.blue": "深藍色系",
    "category.color.family.purple": "紫羅蘭色系",
    "category.color.family.gray": "中性/其他",
    "category.dialog.error.name_required": "請輸入類別名稱",
    "category.dialog.error.name_conflict": "名稱衝突",
    "category.dialog.error.system_reserved": "「{name}」為系統保留類別名稱，請使用其他名稱",
    "category.dialog.error.budget_not_found": "錯誤: 找不到預算資料",
    "category.delete.title": "刪除類別",
    "category.hide.title": "隱藏類別",
    "category.delete.confirm": "確定要刪除「{name}」嗎？",
    "category.delete.warning": "此動作無法復原，且將永久移除該類別。",
    "category.hide.confirm": "「{name}」已有 {count} 筆記錄",
    "category.hide.warning": "為了保留歷史記帳資料，此類別將被移至「已隱藏」清單。",
    "category.action.delete": "確認刪除",
    "category.action.hide": "確認隱藏",
    "category.toast.update_success": "已更新分類",
    "category.toast.moved": "已將 {name} 移動至群組",

    // Category Groups & Defaults
    "category.group.food": "餐飲",
    "category.group.transport": "交通",
    "category.group.shopping": "購物",
    "category.group.home": "居家",
    "category.group.entertainment": "娛樂",
    "category.group.medical": "醫療",
    "category.group.life": "生活",
    "category.group.work": "工作",
    "category.group.investment": "投資",
    "category.group.income": "收入",
    
    "category.default.food": "餐飲",
    "category.default.transport": "交通",
    "category.default.shopping": "購物",
    "category.default.gift": "禮物",
    "category.default.home": "家庭",
    "category.default.rent": "房租",
    "category.default.utilities": "水電",
    "category.default.entertainment": "娛樂",
    "category.default.social": "社交",
    "category.default.travel": "旅遊",
    "category.default.medical": "醫療",
    "category.default.insurance": "保險",
    "category.default.phone": "通訊",
    "category.default.education": "教育",
    "category.default.tax": "稅務",
    "category.default.salary": "薪資",
    "category.default.bonus": "獎金",
    "category.default.red_envelope": "紅包",
    "category.default.investment": "投資",
    "category.default.savings": "儲蓄",
    "category.default.breakfast": "早餐",
    "category.default.lunch": "午餐",
    "category.default.dinner": "晚餐",
    "category.default.parking": "停車",
    "category.default.gas": "加油",
    "category.default.public_transport": "大眾運輸",
    "category.default.interest": "利息",
    "category.default.dividend": "股息",

    // Category Management Toasts & Logic
    "category.toast.db_upgraded": "資料庫升級完成",
    "category.toast.db_upgraded_desc": "已整合 {count} 個舊類別",
    "category.toast.checking_db": "檢查資料庫中...",
    "category.toast.sync_complete": "同步完成",
    "category.toast.sync_complete_desc": "已修復 {count} 個類別",
    "category.toast.no_update": "無需更新",
    "category.toast.no_update_desc": "資料庫已是最新狀態",
    "category.toast.sync_failed": "同步失敗",
    "category.toast.delete_success": "刪除成功",
    "category.toast.delete_success_desc": "類別「{name}」已刪除",
    "category.toast.delete_failed": "刪除失敗",
    "category.toast.hidden_success": "類別已隱藏",
    "category.toast.hidden_success_desc": "類別「{name}」已隱藏，保留 {count} 筆歷史記帳",
    "category.toast.update_success_generic": "更新成功",
    "category.toast.update_success_desc": "預算分配已更新",
    "category.toast.update_failed": "更新失敗",
    "category.toast.action_failed": "操作失敗",
    "category.toast.enter_group_name": "請輸入群組名稱",
    "category.toast.group_updated": "群組已更新",
    "category.toast.group_created": "群組已建立",
    "category.toast.group_deleted": "群組已刪除",
    "category.toast.save_failed": "儲存失敗",
    "category.group.delete_confirm": "確定要刪除「{name}」群組嗎？\n其下方的類別將會變為未分類。",
    "category.empty.no_available": "暫無可用類別",
    "category.empty.hint": "請點擊右上角「管理」新增類別",
    "category.empty.instruction": "請點擊右上角「管理」新增類別",
    "category.manage": "管理",
    "category.select_to_assign": "選擇要分配的類別",
    "category.tab.individual": "類別",
    "category.tab.group": "群組",
    "category.type.income_item": "收入項目",
    "category.type.fixed_expense": "固定支出項目",
    "category.type.extra_expense": "變動支出項目",
    
    // Budget
    "budget.page.title": "現金流規劃",
    "budget.daily.status": "今日預算狀況",
    "budget.monthly.income": "本月收入",
    "budget.monthly.expense": "本月支出",
    "budget.remaining": "剩餘預算",
    "budget.spent": "已支出",
    "budget.planner.title": "預算分配",
    "budget.planner.mode.conservative": "上月基準",
    "budget.planner.mode.projected": "本月預估",
    "budget.planner.card.title": "本月總預算",
    "budget.planner.card.fixed": "固定支出",
    "budget.planner.card.living": "生活開銷",
    "budget.planner.card.jars": "存錢罐",
    "budget.planner.card.savings": "儲蓄投資",
    "budget.planner.tabs.planning": "收支規劃",
    "budget.planner.tabs.planning.short": "規劃",
    "budget.planner.tabs.allocation": "分配概況",
    "budget.planner.tabs.allocation.short": "分配",
    "budget.planner.tabs.trends": "趨勢透視",
    "budget.planner.tabs.trends.short": "趨勢",
    "budget.planner.allocation.title": "預算分配概況",
    "budget.planner.allocation.detail_title": "本月分配詳情",
    "budget.planner.allocation.fixed": "固定開銷",
    "budget.planner.allocation.living": "生活費",
    "budget.planner.allocation.jars": "存錢罐",
    "budget.planner.allocation.investment": "儲蓄/投資",
    "budget.planner.allocation.total": "總預算",
    "budget.planner.allocation.spent": "已花費",
    "budget.planner.allocation.total_used": "已使用",
    "budget.planner.allocation.empty": "尚無預算數據",
    "budget.planner.allocation.desc.fixed": "房租、訂閱、定期扣款",
    "budget.planner.allocation.desc.living": "餐飲、交通、日常開銷",
    "budget.planner.allocation.desc.jars": "旅遊基金、目標儲蓄",
    "budget.planner.allocation.desc.investment": "剩餘資金、投資帳戶",
    "budget.planner.trends.structure": "預算結構",
    "budget.planner.trends.execution": "執行狀況",
    "budget.planner.trend.plan.desc": "分析每月的預算分配與儲蓄投資規劃",
    "budget.planner.trend.actual.desc": "對比每月的實際收支與結餘狀況",
    "budget.planner.trend.toggle.hide": "隱藏明細",
    "budget.planner.trend.toggle.show": "查看明細",
    "budget.planner.fixed.title": "固定收支",
    "budget.planner.fixed.income": "固定收入",
    "budget.planner.fixed.expense": "固定支出",
    "budget.planner.fixed.target": "目標",
    "budget.planner.fixed.current": "目前",
    "budget.planner.fixed.living_title": "生活費分配",
    "budget.planner.fixed.init_data": "初始化預算資料...",
    "budget.planner.dialog.error": "無法開啟對話框",
    "budget.planner.dialog.error_desc": "載入預算設定失敗，請稍後再試。",
    "budget.planner.living.title": "生活費分配",
    "budget.planner.extra.title": "額外收支",
    "budget.planner.extra.income": "額外收入",
    "budget.planner.toast.loading": "載入設定中...",
    "budget.planner.toast.init": "正在初始化預算資料", 

    // Savings Jar Edit
    "budget.planner.jar.edit.title": "編輯存錢罐",
    "budget.planner.jar.edit.name_label": "存錢罐名稱",
    "budget.planner.jar.edit.name_placeholder": "例如：旅遊基金",
    "budget.planner.jar.edit.target_label": "目標金額",
    "budget.planner.jar.edit.color_label": "主題顏色",
    "budget.planner.jar.edit.icon_label": "圖標",
    "budget.planner.jar.edit.save": "儲存變更",
    "budget.planner.jar.edit.icon_select_title": "選擇圖示",
    "budget.planner.jar.edit.icon_search_placeholder": "搜尋圖示...",
    "budget.planner.jar.edit.no_icons_found": "沒有找到相關圖示",
    "budget.planner.jar.edit.error.required": "請填寫存錢罐名稱和目標金額",
    "budget.planner.jar.edit.error.update_failed": "更新存錢罐失敗",
    "budget.planner.jar.remove_target_title": "移除目標金額？",
    "budget.planner.jar.remove_target_desc": "進度條將消失，改為累積餘額模式。你的所有存款記錄不會被刪除。",
    "budget.planner.jar.remove_target_confirm": "確認移除",

    // Savings Jar Deposit
    "budget.planner.jar.deposit.date_label": "日期",
    "budget.planner.jar.deposit.date_placeholder": "選擇日期",
    "budget.planner.jar.deposit.note_placeholder": "備註...",
    "budget.planner.jar.deposit.submit": "確認存入",

    // Savings Jar Allocation
    "budget.planner.jar.allocation.title": "本月提撥金額",
    "budget.planner.jar.allocation.subtitle": "從存錢罐提撥到本月可用預算",
    "budget.planner.jar.allocation.distributable_balance": "可分配總額",
    "budget.planner.jar.allocation.suggestion_title": "建議值區塊",
    "budget.planner.jar.allocation.month_label": "月份：{month}",
    "budget.planner.jar.allocation.month_start_balance": "月初結餘",
    "budget.planner.jar.allocation.current_balance": "目前結餘",
    "budget.planner.jar.allocation.month_end_balance": "月末結餘",
    "budget.planner.jar.allocation.current_withdrawn": "本月已提撥",
    "budget.planner.jar.allocation.suggested_limit": "建議提撥上限",
    "budget.planner.jar.allocation.withdraw_input": "本月提撥金額",
    "budget.planner.jar.allocation.limit_hint": "可分配上限：{currency}{value}",
    "budget.planner.jar.allocation.limit_formula": "計算方式：月初結餘 {currency}{start} + 本月存入 {currency}{deposit}",
    "budget.planner.jar.allocation.limit_title": "可分配上限",
    "budget.planner.jar.allocation.progress_label": "已分配 {value}%",
    "budget.planner.jar.allocation.historical_limit_hint": "歷史月硬上限（月末可動用）：NT$ {value}",
    "budget.planner.jar.allocation.deposit_hint": "本月存入累計：NT$ {value}",
    "budget.planner.jar.allocation.allocated_amount": "已分配：NT$ {value}",
    "budget.planner.jar.allocation.unallocated_amount": "未分配：NT$ {value}",
    "budget.planner.jar.allocation.categories_title": "類別預算分配",
    "budget.planner.jar.allocation.categories_subtitle": "設定每個類別的比例與金額",
    "budget.planner.jar.allocation.unallocated_title": "未分類",
    "budget.planner.jar.allocation.unallocated_subtitle": "尚未分配到任何類別的金額",
    "budget.planner.jar.allocation.confirm_withdraw": "確認提撥",
    "budget.planner.jar.allocation.cancel_withdraw": "取消提撥",
    "budget.planner.jar.allocation.over_limit_error": "分配比例不可超過 100%",
    "budget.planner.jar.allocation.total_items": "共 {count} 項",
    "budget.planner.jar.allocation.empty_title": "尚無分配類別",
    "budget.planner.jar.allocation.add_button": "選擇類別",
    "budget.planner.jar.allocation.add_new_button": "新增分配類別",
    "budget.planner.jar.allocation.unlock": "解鎖分配比例",
    "budget.planner.jar.allocation.lock": "鎖定分配比例",
    "budget.planner.jar.allocation.toast.remove_failed": "無法移除",
    "budget.planner.jar.allocation.toast.system_category_error": "系統類別「{name}」無法從存錢罐中移除",
    "budget.planner.jar.allocation.toast.removed": "類別已移除",
    "budget.planner.jar.allocation.toast.removed_desc": "類別已從存錢罐分配中移除",
    "budget.planner.jar.allocation.toast.remove_error": "移除失敗",
    "budget.planner.jar.allocation.toast.update_failed": "更新失敗",
    "budget.planner.jar.allocation.toast.created": "類別已創建",
    "budget.planner.jar.allocation.toast.created_desc": "已成功創建類別「{name}」",
    "budget.planner.jar.allocation.toast.edit_error": "無法編輯",
    "budget.planner.jar.allocation.toast.edit_error_desc": "請先選擇類別後再進行編輯",
    "budget.planner.jar.allocation.toast.delete_failed": "刪除失敗",
    "budget.planner.jar.allocation.toast.create_error": "無法創建類別",
    "budget.planner.jar.allocation.toast.no_budget_data": "預算資料尚未載入，請稍後再試", 
    "budget.planner.toast.error.open": "無法開啟對話框", 
    "budget.planner.toast.error.load": "載入預算設定失敗，請稍後再試。",
    "budget.planner.extra.balance.current": "含本月結餘",
    "budget.planner.extra.balance.last": "含上月結餘",
    "budget.planner.extra.includes_current": "含本月結餘",
    "budget.planner.extra.includes_prev": "含上月結餘",
    "budget.planner.extra.desc": "點擊查看詳情",
    "budget.planner.extra.source": "獎金、兼職、投資收益",
    "budget.planner.jars.title": "我的存錢罐",
    "budget.planner.jars.page_title": "存錢罐",
    "budget.planner.jars.add": "新增存錢罐",
    "budget.planner.jars.empty": "還沒有存錢罐",
    "budget.planner.jars.empty_title": "還沒有存錢罐",
    "budget.planner.jars.empty_desc": "建立你的第一個存錢罐，開始為目標儲蓄！",
    "budget.planner.jars.create_first": "建立第一個存錢罐",
    "budget.planner.jars.transfer": "轉到其他罐",
    "budget.planner.jars.summary_total": "總存款",
    "budget.planner.jars.summary_all": "全部存錢罐",
    "budget.planner.jars.jar_count": "共 {count} 個罐子",
    "budget.planner.jars.list_title": "存錢罐列表",
    "budget.planner.jars.trend.title": "存款走勢",
    "budget.planner.jars.trend.empty": "尚無走勢資料",
    "budget.planner.jars.trend.month_deposit": "當月存入 NT$ {amount}",
    "jar.transfer.note.edit_title": "編輯轉入備註",
    "jar.transfer.note.edit_desc": "罐間轉入僅能修改備註",
    "jar.transfer.note.save": "儲存備註",
    "budget.planner.jar.deposit.delete_confirm": "確定要刪除這筆存款嗎？",
    "budget.planner.jars.month_withdrawal": "本月存錢罐提撥",
    "budget.planner.jars.uncategorized_amount": "未分類 NT${amount}",
    "budget.planner.jars.six_pack": "快速建立六個理財存錢罐",
    "budget.planner.jars.six_pack_subtitle": "以六罐理財法快速完成初始配置",
    "budget.planner.jars.six_pack_hint": "這六個存錢罐先幫你分好用途，讓每月儲蓄更有方向，後續也可依你的習慣自由調整。",
    "amount.edit.title": "金額輸入",
    "amount.edit.desc": "請使用數字鍵盤輸入金額",
    "amount.edit.current": "目前設定金額",
    "budget.allocation.title": "預算分配",
    "common.try_later": "請稍後再試",
    "common.save_failed": "無法儲存變更，請稍後再試",
    "common.remove_failed": "移除失敗",
    "budget.planner.allocation.invested": "已投入",
    "budget.planner.allocation.to_goal": "距目標",
    "budget.planner.allocation.savings_details": "本月儲蓄明細",
    "budget.planner.allocation.investment_details": "本月投資明細",
    "budget.planner.allocation.entry_count": "{count} 筆",
    "budget.planner.allocation.no_savings_records": "本月尚無存款記錄",
    "budget.planner.allocation.no_investment_records": "本月尚無投資記錄",
    "budget.planner.allocation.transfer_from_jar": "轉入自「{name}」",
    "budget.planner.allocation.jar_transfer_in": "罐間轉入",
    "budget.planner.allocation.deposited_from_account": "{jar} (存自{account})",
    "budget.planner.allocation.count_in_savings": "計入本月儲蓄",
    "budget.planner.allocation.exclude_from_savings": "不計入本月儲蓄",
    "budget.planner.allocation.count_in_investment": "計入本月投資",
    "budget.planner.allocation.exclude_from_investment": "不計入本月投資",
    "budget.planner.allocation.category_count": "{count} 個類別",
    "budget.planner.allocation.uncategorized_yet": "尚未分類",
    "budget.planner.allocation.month_withdraw_label": "本月提撥",
    "budget.planner.jars.six_pack_success": "已建立六罐建議",
    "budget.planner.jars.six_pack_success_desc": "已幫你建立六個存錢罐，接下來可依需求調整。",
    "budget.planner.jars.six_pack_fail": "建立失敗",
    "budget.planner.jars.six_pack_fail_desc": "六罐建議建立失敗，請稍後再試。",
    "budget.planner.jars.creating": "建立中…",
    "budget.planner.jars.confirm_create": "確認建立",
    "budget.planner.jars.withdraw_chip": "提撥NT${amount}",
    "budget.planner.jars.pending_chip": "未分類NT${amount}",
    "budget.planner.jars.edit_allocation": "編輯分配",
    "budget.planner.jars.expand": "展開明細",
    "budget.planner.jars.collapse": "收合明細",
    "budget.planner.jar.card.withdrawn": "本月已提撥 {amount}",
    "budget.planner.jar.card.uncategorized": "未分類 {amount}",
    "budget.planner.jar.card.allocated": "已分配",
    "budget.planner.jar.card.withdraw_cta": "提撥到本月預算",
    "budget.planner.jar.card.edit_withdraw": "編輯提撥",
    "budget.planner.jar.card.withdraw_now": "立即提撥",
    "budget.planner.jar.card.goal_type": "目標型",
    "budget.planner.jar.card.accum_type": "累積型",
    "budget.planner.jar.card.current_balance": "當前餘額",
    "budget.planner.jar.card.reached": "已達標！",
    "budget.planner.jar.card.still_need": "尚需",
    "budget.planner.jar.card.deposited": "已存入 {amount}",
    "budget.planner.jar.card.target": "目標 {amount}",
    "budget.planner.jar.card.this_month": "本月",
    "budget.planner.jar.card.balance": "餘額",
    "budget.planner.jar.card.chart_empty": "有餘額或交易後顯示圖表",
    "budget.planner.jar.card.tooltip_balance": "餘額 {amount}",
    "budget.planner.jar.card.month_label": "{month}月",
    "budget.planner.leftover.need_amount": "請先分配金額",
    "budget.planner.leftover.need_amount_desc": "至少要新增一筆提撥並輸入金額。",
    "budget.planner.leftover.over_limit": "分配金額超過可轉存",
    "budget.planner.leftover.over_limit_desc": "目前已超過 NT${amount}，請先調整金額。",
    "budget.planner.leftover.success": "已存入存錢款",
    "budget.planner.leftover.success_desc": "{month} 剩餘的 NT${amount} 已完成轉存。",
    "budget.planner.leftover.fail": "轉存失敗",
    "budget.planner.leftover.fail_desc": "請稍後再試一次。",
    "budget.planner.month.loading": "月份資料載入中",
    "budget.planner.month.load_fail": "載入失敗",
    "budget.planner.month.load_fail_desc": "無法載入該月固定收支",
    "budget.planner.leftover.card_title": "本月剩餘可轉存",
    "budget.planner.leftover.card_hint": "分配後會直接存入存錢款",
    "budget.planner.leftover.card_badge": "可轉存",
    "budget.planner.leftover.card_start": "開始分配",
    "budget.planner.leftover.card_formula_aria": "查看可轉存計算方式",
    "budget.planner.leftover.card_formula": "可轉存 =（固定開銷 + 生活費 + 儲蓄投資）預算 −（固定開銷 + 生活費 + 儲蓄投資）已花費",
    "budget.planner.leftover.card_formula_month": "本月：({fixed} + {living} + {savings}) − ({fixedSpent} + {livingSpent} + {savingsSpent}) = {result}",
    "budget.planner.leftover.dialog_title": "把剩下的錢存起來",
    "budget.planner.leftover.dialog_subtitle": "{month} 還有 NT$ {amount} 可分配",
    "budget.planner.leftover.allocated": "已分配",
    "budget.planner.leftover.over": "超出可分配",
    "budget.planner.leftover.unallocated": "尚未分配",
    "budget.planner.leftover.lines_title": "分配明細",
    "budget.planner.leftover.lines_count": "{count} 筆提撥",
    "budget.planner.leftover.lines_empty": "尚未新增提撥，可從下方存錢罐輸入金額後新增",
    "budget.planner.leftover.swipe_hint": "左滑可刪除單筆提撥",
    "budget.planner.leftover.deduct": "扣帳 {amount}",
    "budget.planner.leftover.deposit_to": "存入 {amount}",
    "budget.planner.leftover.pick_account": "選擇來源帳戶",
    "budget.planner.leftover.pick_account_desc": "可選填，不選則記為虛擬存款",
    "budget.planner.leftover.no_account": "沒有找到符合的帳戶",
    "budget.planner.leftover.virtual_deposit": "虛擬存款",
    "budget.planner.leftover.unknown_account": "未知帳戶",
    "budget.planner.leftover.split_even": "平均分配",
    "budget.planner.leftover.clear": "清空",
    "budget.planner.leftover.give_all": "全部給它",
    "budget.planner.leftover.current": "目前 {amount}",
    "budget.planner.leftover.progress": " · 達成 {pct}%",
    "budget.planner.leftover.jar_allocated": "本次已分配 {amount}",
    "budget.planner.leftover.amount_label": "要存入的金額",
    "budget.planner.leftover.add_line": "新增提撥",
    "budget.planner.leftover.switch_jar": "切換到 {name}",
    "budget.planner.leftover.submitting": "存入中…",
    "budget.planner.leftover.submit": "存入 NT$ {amount}",
    "budget.planner.jars.no_category_alloc": "尚未設定類別分配",
    "budget.planner.jars.template.needs": "生活必需罐",
    "budget.planner.jars.template.needs_desc": "固定生活開銷與日常支出",
    "budget.planner.jars.template.freedom": "財務自由罐",
    "budget.planner.jars.template.freedom_desc": "長期投資與資產累積",
    "budget.planner.jars.template.education": "教育成長罐",
    "budget.planner.jars.template.education_desc": "學習、進修與技能成長",
    "budget.planner.jars.template.long_fun": "長期玩樂罐",
    "budget.planner.jars.template.long_fun_desc": "旅行與大目標娛樂計畫",
    "budget.planner.jars.template.short_fun": "短期享樂罐",
    "budget.planner.jars.template.short_fun_desc": "小確幸與即時快樂消費",
    "budget.planner.jars.template.give": "公益分享罐",
    "budget.planner.jars.template.give_desc": "回饋、捐款與分享用途",
    "budget.planner.copy.title": "複製月份設定",
    "budget.planner.copy.preview_title": "預覽即將變更的內容",
    "budget.planner.copy.prev_month": "上個月",
    "budget.planner.copy.next_month": "下個月",
    "budget.planner.copy.from_aria": "從其他月份複製設定",
    "budget.planner.copy.pick_source": "選擇來源月份",
    "budget.planner.copy.pick_content": "選擇複製內容",
    "budget.planner.copy.mode": "預算模式設定",
    "budget.planner.copy.mode_desc": "「上月基準／本月預估」",
    "budget.planner.copy.items": "收支明細項目",
    "budget.planner.copy.items_desc": "固定收支、額外收入的明細和金額",
    "budget.planner.copy.alloc": "生活費與儲蓄分配",
    "budget.planner.copy.alloc_desc": "各分類拉桿比例與投資儲蓄設定",
    "budget.planner.copy.about_to": "即將從 {year} 年 {month} 複製以下內容：",
    "budget.planner.copy.calc_mode": "模式",
    "budget.planner.copy.mode_conservative": "上月基準",
    "budget.planner.copy.mode_estimate": "本月預估",
    "budget.planner.copy.badge_new": "新",
    "budget.planner.copy.badge_edit": "改",
    "budget.planner.copy.badge_del": "刪",
    "budget.planner.copy.type_fixed_income": "固定收入",
    "budget.planner.copy.type_fixed_expense": "固定支出",
    "budget.planner.copy.type_extra": "額外收入",
    "budget.planner.copy.type_fixed_alloc": "固定收支分配",
    "budget.planner.copy.type_extra_alloc": "額外收支分配",
    "budget.planner.copy.preview_fail": "載入預覽失敗",
    "budget.planner.copy.preview_fail_desc": "後端未返回預期的預覽數據。請確認來源月份是否存在預算設定，或稍後再試。",
    "budget.planner.copy.preview_fail_retry": "請確認來源月份存在預算設定，或稍後再試。",
    "budget.planner.copy.preview_loading": "載入中…",
    "budget.planner.copy.preview_action": "預覽變更",
    "budget.planner.copy.done": "複製完成",
    "budget.planner.copy.done_desc": "已將 {year} 年 {month} 的設定套用",
    "budget.planner.copy.fail": "複製失敗",
    "budget.planner.copy.copying": "複製中…",
    "budget.planner.copy.apply": "確認套用",
    "budget.planner.copy.quick": "快速從其他月份複製設定",
    "budget.planner.copy.start": "開始複製",
    "budget.planner.copy.items_changed": "收支項目異動 ({count})",
    "budget.planner.copy.cats_changed": "分配類別變更 ({count})",
    "budget.planner.copy.remove_category": "移除類別",
    "budget.planner.copy.no_changes": "沒有偵測到任何需要更新的內容",
    "budget.planner.copy.blank_title": "還沒有預算設定",
    "budget.planner.copy.apply_to": "套用到",
    "budget.planner.copy.back": "上一步",
    "budget.planner.copy.onboard_title": "開始建立你的預算",
    "budget.planner.copy.onboard_desc": "設定固定收支和生活費分配",
    "budget.planner.copy.onboard_income": "固定收入",
    "budget.planner.copy.onboard_expense": "固定支出",
    "jar.transfer.swap": "對調來源與目標存錢罐",

    "jar.transfer.title": "轉到其他存錢罐",
    "jar.transfer.desc": "罐與罐之間調撥，不動銀行帳戶。",
    "jar.transfer.from": "從",
    "jar.transfer.to": "到",
    "jar.transfer.route_label": "轉移路徑",
    "jar.transfer.pick_from": "選擇來源罐",
    "jar.transfer.pick_to": "選擇目標罐",
    "jar.transfer.pick_from_desc": "選擇要轉出資金的存錢罐",
    "jar.transfer.pick_to_desc": "選擇要接收資金的存錢罐",
    "jar.transfer.amount_label": "轉移金額",
    "jar.transfer.amount_hint": "（最多 {max}）",
    "jar.transfer.account_split": "帳戶分配",
    "jar.transfer.account_split_hint": "（建議指定帳戶）",
    "jar.transfer.account_max": "最多可配 {amount}",
    "jar.transfer.allocated": "已指定帳戶",
    "jar.transfer.unassigned": "純存錢罐轉移",
    "jar.transfer.unassigned_account": "未分配（不指定帳戶）",
    "jar.transfer.unassigned_hint": "可分配至上方帳戶，或維持純存錢罐轉移",
    "jar.transfer.unassigned_done": "已全部配至帳戶",
    "jar.transfer.unassigned_short": "未分配 {amount}",
    "jar.transfer.allocation_progress": "已分配 {allocated} / {total}",
    "jar.transfer.allocation_complete": "已全部分配",
    "jar.transfer.unassigned_only": "全部金額將以純存錢罐轉移處理",
    "jar.transfer.no_accounts": "此罐沒有可分配的帳戶紀錄",
    "jar.transfer.available": "可轉",
    "jar.transfer.fill_all": "自動分配",
    "jar.transfer.no_available": "此存錢罐目前沒有可依帳戶轉出的餘額",
    "jar.transfer.no_jars": "找不到符合的存錢罐",
    "jar.transfer.note": "備註（選填）",
    "jar.transfer.note_placeholder": "例如：旅遊罐轉到緊急預備金",
    "jar.transfer.total": "轉移合計",
    "jar.transfer.cancel": "取消",
    "jar.transfer.submit": "確認轉移",
    "jar.transfer.submit_with_amount": "轉移 {amount}",
    "jar.transfer.submitting": "處理中…",
    "jar.transfer.success_title": "轉移完成",
    "jar.transfer.success_desc": "資金已在存錢罐之間重新分配",
    "jar.transfer.error_title": "轉移失敗",
    "jar.transfer.error_desc": "請稍後再試",
    "jar.transfer.unknown_account": "未知帳戶",
    "jar.transfer.fx_preview": "約 {from} → {to}",
    "jar.transfer.post_adjust_title": "轉移後調整帳戶結餘（選填）",
    "jar.transfer.post_adjust_desc": "各帳戶結餘加總 {accounts}，但此罐只剩 {jar}。若先前用其他帳戶消費，可在此順便修正。",
    "jar.transfer.post_adjust_to": "調整為",
    "jar.transfer.history.out_title": "轉至 {name}",
    "jar.transfer.history.out_desc": "罐間轉出",
    "jar.transfer.history.in_pure": "罐間轉入",
    "jar.transfer.history.in_from_jar": "自「{name}」轉入",
    "jar.transfer.history.in_from_account": "自 {account} 轉入",
    "jar.transfer.history.load_error": "無法載入轉帳紀錄",
    "jar.transfer.cancel.action": "撤銷轉移",
    "jar.transfer.cancel.insufficient_hint": "目標罐餘額不足，無法撤銷",
    "jar.transfer.cancel.title": "撤銷這次轉移？",
    "jar.transfer.cancel.desc": "將從「{to}」扣回 {amount}，並加回「{from}」。紀錄會完全移除。",
    "jar.transfer.cancel.desc_lines": "本次轉移共有 {count} 筆轉入明細，將一併撤銷。",
    "jar.transfer.cancel.confirm": "確認撤銷",
    "jar.transfer.cancel.success_title": "已撤銷轉移",
    "jar.transfer.cancel.success_desc": "資金已還原至來源存錢罐",
    "jar.transfer.cancel.error_title": "撤銷失敗",
    "jar.transfer.cancel.error_desc": "請稍後再試",

    "budget.planner.jar.deposit.manual": "手動存入",
    "budget.planner.jar.deposit.rollover": "月結轉存",
    "budget.planner.jar.deposit.rollover_leftover": "月結剩餘金額轉入",
    "budget.planner.jar.deposit.count_in_short": "計入存款統計",
    "budget.planner.jar.deposit.count_out_short": "不計入存款統計",
    "budget.planner.jar.deposit.entry_count": "{count} 筆",
    "budget.planner.jar.delete.title": "確認刪除「{name}」？",
    "budget.planner.jar.delete.body": "刪除後，此存錢罐在歷史月份的預算與累積金額記錄將被一併移除。",
    "budget.planner.jar.delete.warn": "可能影響過去月份預算分析數據。",
    "budget.planner.jar.delete.irreversible": "此操作無法復原。",
    "budget.planner.jar.delete.confirm": "確認刪除",
    "account.picker.my_accounts": "我的帳戶",
    "account.picker.split_partners": "分帳對象",
    "account.picker.unlinked": "未連結成員",
    "investment.account.filter.payment": "這裡會顯示一般付款用帳戶（不包含投資帳戶）",
    "investment.account.filter.broker_all": "這裡會顯示投資帳戶（包含你建立的投資類別）",
    "investment.account.filter.broker_type": "已篩選 {type} 券商帳戶",
    "investment.account.filter.match_first": "相符優先",
    "investment.account.filter.all_accounts": "全部帳戶",
    "investment.account.empty.payment": "尚未建立付款帳戶",
    "investment.account.empty.broker_type": "尚無{type}券商帳戶",
    "investment.account.empty.broker": "尚未建立持倉帳戶",
    "investment.account.empty.payment_desc": "先建立付款帳戶才能完成投資交易",
    "investment.account.empty.broker_type_desc": "建立一個{type}券商帳戶，就能繼續這筆交易",
    "investment.account.empty.broker_desc": "先建立持倉帳戶才能記錄投資部位",
    "investment.account.empty.payment_cta": "前往建立付款帳戶",
    "investment.account.empty.broker_type_cta": "建立{type}券商帳戶",
    "investment.account.empty.broker_cta": "前往建立持倉帳戶",
    "investment.jar.select_title": "選擇存錢罐",
    "investment.jar.select_desc": "選擇本次投資要扣款的存錢罐（可選）",
    "investment.jar.label": "存錢罐（可選）",
    "investment.jar.none": "不指定（僅記錄投資交易）",
    "investment.jar.none_title": "不指定存錢罐",
    "investment.jar.none_desc": "僅記錄投資交易，不連動扣除存錢罐",
    "investment.jar.not_found_title": "找不到要的存錢罐？",
    "investment.jar.not_found_desc": "離開此頁後前往存錢罐建立",

    "jar.hide.confirm_title": "隱藏「{name}」？",
    "jar.hide.confirm_desc": "隱藏後不會刪除資料，只是不再出現於列表與選單。之後可再恢復。",
    "jar.hide.confirm_balance_warn": "此罐尚有餘額 {amount}，隱藏後將無法存款、提撥或轉移。",
    "jar.hide.confirm_action": "確認隱藏",
    "jar.hide.success_title": "已隱藏存錢罐",
    "jar.hide.success_desc": "「{name}」已從列表中隱藏",
    "jar.hide.error_title": "隱藏失敗",
    "jar.hide.error_desc": "請稍後再試",
    "jar.hide.tip_goal_done": "已達標且餘額已用完，可隱藏此罐保持列表清爽。",
    "jar.hide.manage_title": "已隱藏的存錢罐",
    "jar.hide.manage_desc": "點擊卡片可查看紀錄；也可取消隱藏讓罐子回到列表。",
    "jar.hide.manage_empty": "目前沒有已隱藏的存錢罐",
    "jar.hide.has_balance": "尚有餘額",
    "jar.hide.view": "查看",
    "jar.hide.unhide": "取消隱藏",
    "jar.hide.unhide_success_title": "已恢復顯示",
    "jar.hide.unhide_success_desc": "「{name}」已回到存錢罐列表",
    "jar.hide.unhide_error_title": "取消失敗",
    "jar.hide.unhide_error_desc": "請稍後再試",
    "jar.hide.manage_entry_aria": "管理已隱藏的存錢罐",
    "jar.hide.manage_entry": "已隱藏",
    "jar.hide.readonly_deposit": "此存錢罐已隱藏，無法新增存款（仍可查看紀錄）",
    "jar.hide.readonly_withdraw": "此存錢罐已隱藏，無法提撥預算（仍可查看配置）",
    "jar.swipe.edit": "編輯",
    "jar.swipe.hide": "隱藏",
    "jar.swipe.delete": "刪除",
    "jar.swipe.delete_desc": "刪除後，此存錢罐在歷史月份的預算與累積金額記錄將被一併移除。",
    "jar.swipe.delete_irreversible": "此操作無法復原。",
    "jar.swipe.delete_confirm": "確認刪除",

    "jar.balance.section_title": "各帳戶在此罐的結餘",
    "jar.balance.info_title": "結餘說明",
    "jar.balance.section_desc": "記錄各帳戶當初從哪裡存進此罐。各帳戶結餘加總有時會與存錢罐餘額不一致（例如有從其他帳戶消費時）。",
    "jar.balance.mismatch_hint": "各帳戶結餘加總 {accounts}，但此罐只剩 {jar}。你可以調整各帳戶的結餘，讓數字更貼近實際。",
    "jar.balance.mismatch_status": "結餘跟餘額不一致，你可以調整各帳戶的結餘，讓數字更貼近實際。",
    "jar.balance.mismatch_dot_hint": "各帳戶結餘加總與此罐餘額不一致",
    "jar.balance.adjust": "調整",
    "jar.balance.adjust_to": "調整結餘為",
    "jar.balance.adjust_note": "不會改變存錢罐總餘額，也不會動銀行帳戶，僅修正此帳戶在此罐的結餘",
    "jar.balance.current_label": "目前結餘",
    "jar.balance.confirm": "確認",
    "jar.balance.cancel": "取消",
    "jar.balance.computed_was": "原計算",
    "jar.balance.success_title": "結餘已更新",
    "jar.balance.success_desc": "已更新「{name}」在此罐的結餘",
    "jar.balance.already_at_target": "「{name}」在此罐的結餘已是此金額，已同步最新資料",
    "jar.balance.error_title": "無法調整",
    "jar.balance.error_desc": "請稍後再試",
    "jar.balance.error_over": "不能高於原計算結餘",
    "jar.balance.error_over_max": "不可超過此罐尚可分配的上限 {max}",
    "jar.balance.adjust_max_inline": "此罐尚可分配 {max}",
    "jar.balance.adjust_max_hint": "此帳戶在此罐最多可設為 {max}",
    "jar.balance.unknown_account": "未知帳戶",
    "jar.balance.formula_title": "結餘計算",
    "jar.balance.formula_deposited": "存入",
    "jar.balance.formula_spent": "支出",
    "jar.balance.formula_adjusted": "手動調整",
    "jar.balance.formula_result": "結餘",
    "jar.balance.summary_accounts_total": "各帳戶結餘加總",
    "jar.balance.summary_jar_balance": "此罐目前餘額",
    "jar.balance.tap_amount_hint": "點擊金額查看計算方式",

    // Savings Jar Detail
    "budget.planner.jar.progress": "達成率",
    "budget.planner.jar.include_budget": "納入每月預算",
    "budget.planner.jar.tab.deposit": "新增存款",
    "budget.planner.jar.tab.allocation": "提撥預算",
    "budget.planner.jar.tab.history": "歷史紀錄",
    "budget.planner.jar.tab.chart": "支出分析",
    "budget.planner.jar.tabs.deposits": "存款",
    "budget.planner.jar.tabs.expenses": "支出",
    "budget.planner.jar.deposit.new": "新增存款",
    "budget.planner.jar.deposit.history_tab": "存款紀錄",
    "budget.planner.jar.deposit.optional": "(選填)",
    "budget.planner.jar.deposit.virtual": "虛擬存款",
    "budget.planner.jar.deposit.count_in": "計入本月存款統計",
    "budget.planner.jar.deposit.count_out": "不計入本月存款統計",
    "budget.planner.jar.deposit.convert_preview": "轉換後將存入 {amount}",
    "budget.planner.jar.deposit.amount_required": "請輸入存入金額",
    "budget.planner.jar.deposit.amount_invalid": "請輸入有效的存入金額",
    "budget.planner.jar.expense.history_tab": "支出歷史",
    "budget.planner.jar.expense.analysis_tab": "支出分析",
    "budget.planner.jar.expense.all_months": "全部月份",
    "budget.planner.jar.expense.all": "全部",
    "budget.planner.jar.stats.deposited": "已存入",
    "budget.planner.jar.stats.spent_pct": "已花費 {amount} ({pct}%)",
    "budget.planner.jar.stats.monthly_avg": "月均存入 {amount}",
    "budget.planner.jar.stats.this_month_net": "{sign}{amount} 本月",
    "budget.planner.jar.deposit.edit_title": "編輯存款",
    "budget.planner.jar.deposit.edit_desc": "修改金額、帳戶、日期或備註",
    "budget.planner.leftover.rollover_note": "{month} 月結轉存",
    "budget.planner.jar.delete_confirm": "確定要刪除「{name}」存錢罐嗎？",
    "budget.planner.jar.stats.allocation_status": "資金運用狀況",
    "budget.planner.jar.stats.overspend": "已透支",
    "budget.planner.jar.stats.spent": "已支出",
    "budget.planner.jar.stats.saved": "已存入",
    "budget.planner.jar.stats.target": "目標",
    "budget.planner.jar.stats.historical_spent": "歷史支出",
    "budget.planner.jar.stats.monthly_spent": "本月支出",
    "budget.planner.jar.stats.current_balance": "現有餘額",
    "budget.planner.jar.stats.remaining_target": "尚需",
    "budget.planner.jar.deposit.amount_label": "存入金額",
    "budget.planner.jar.deposit.account_select": "選擇帳戶",
    "budget.planner.jar.deposit.account_source": "來源帳戶",
    "budget.planner.jar.deposit.select_account_title": "選擇來源帳戶",
    "budget.planner.jar.deposit.select_placeholder": "請選擇來源帳戶",
    "budget.planner.jar.deposit.unknown_account": "未知帳戶",
    "budget.planner.jar.deposit.account_search": "搜尋帳戶...",
    "budget.planner.jar.deposit.no_account_found": "沒有找到符合的帳戶",
    "budget.planner.jar.deposit.account_balance": "餘額: ",
    "budget.planner.jar.deposit.note_label": "備註",
    "budget.planner.jar.deposit.success": "存款記錄已新增",
    "budget.planner.jar.deposit.error": "新增存款失敗",
    "budget.planner.jar.deposit.validate_error": "請填寫存款金額和選擇帳戶",
    "budget.planner.jar.delete.success": "存錢罐已刪除",
    "budget.planner.jar.delete.error": "刪除存錢罐失敗",

    "budget.planner.allocation.mode.priority": "優先分配",
    "budget.planner.allocation.mode.set_priority": "點擊設為優先",
    "budget.planner.allocation.remaining": "剩餘可分配:",
    "budget.planner.allocation.remaining_available": "剩餘可用金額:",
    "budget.planner.allocation.available_total": "可分配總額:",
    "budget.planner.allocation.allocated": "已分配:",
    "budget.planner.allocation.living_budget": "剩餘可分配金額:",
    "budget.planner.allocation.unallocated": "未分配:",
    "budget.planner.allocation.over_spent": "超支:",
    "budget.planner.allocation.over": "超支",
    "budget.planner.allocation.over_budget_pct": "超過預算 {pct}%",
    "budget.planner.allocation.unallocated_pct": "還有 {pct}% 未分配",
    "budget.planner.allocation.no_categories": "尚未選擇分配類別",
    "budget.planner.allocation.select_category": "選擇類別",
    "budget.planner.allocation.loading": "載入預算中...",
    "budget.planner.allocation.add_category": "新增分配類別",
    "budget.planner.allocation.savings_investment": "儲蓄/投資額",
    "budget.planner.allocation.savings_investment_dist": "儲蓄/投資分配",
    "budget.planner.allocation.savings_only": "儲蓄",
    "budget.planner.allocation.investment_only": "投資",
    "budget.planner.allocation.auto_savings_desc": "未分配的金額將自動歸類為儲蓄/投資",
    "common.locked": "鎖定中",
    "common.editing": "編輯中",
    "common.remaining": "剩餘",
    "budget.planner.dialog.add_error_required": "請填寫項目名稱和金額",
    "budget.planner.dialog.add_failed": "新增項目失敗",
    "budget.planner.dialog.delete_auto_error": "無法刪除自動計算的項目",
    "budget.planner.dialog.delete_failed": "刪除項目失敗",
    "budget.planner.dialog.delete_fixed_income_desc": "將從固定收入移除，金額 {amount}。",
    "budget.planner.dialog.delete_fixed_expense_desc": "將從固定支出移除，金額 {amount}。",
    "budget.planner.allocation.delete_desc": "將從生活費分配移除，金額 {amount}。",
    "budget.planner.jar.allocation.delete_desc": "將從預算提撥分配移除，金額 {amount}。",
    "budget.planner.dialog.fixed_income": "固定收入項目",
    "budget.planner.dialog.fixed_expense": "固定支出項目",
    "budget.planner.dialog.category_select": "選擇類別",
    "budget.planner.dialog.uncategorized": "未分類",
    "budget.planner.dialog.category_group": "類別群組",
    "budget.planner.dialog.item_name": "項目名稱",
    "budget.planner.dialog.item_amount": "金額",
    "budget.planner.dialog.name_placeholder": "輸入名稱",
    "budget.planner.dialog.cancel": "取消",
    "budget.planner.dialog.update": "更新項目",
    "budget.planner.dialog.add": "新增項目",
    "budget.planner.dialog.extra_title": "額外收入項目",
    "budget.planner.dialog.extra_explain": "賺超過固定收入，多的就能拿來分配！",
    "budget.planner.dialog.extra_formula": "額外收入 = max(0, 實際收入 − 固定收入)",
    "budget.planner.dialog.extra_actual_prev": "上月實際收入",
    "budget.planner.dialog.extra_actual_current": "本月實際收入",
    "budget.planner.dialog.extra_fixed": "固定收入",
    "budget.planner.dialog.extra_auto_badge": "自動計算",
    "budget.planner.dialog.extra_result_sub": "系統依記帳收入自動計算",
    "budget.planner.dialog.init_budget": "正在初始化本月預算...",
    "budget.planner.dialog.init_desc": "首次使用需要建立預算資料",
    "budget.planner.dialog.current_net": "本月額外收入結餘",
    "budget.planner.dialog.prev_net": "上月額外收入結餘",
    "budget.planner.dialog.current_net_short": "本月結餘",
    "budget.planner.dialog.prev_net_short": "上月結餘",
    "budget.planner.dialog.other_items": "其他項目",
    "budget.planner.dialog.no_categories": "沒有可用的類別",
    "budget.planner.dialog.item_list": "項目列表",
    "budget.planner.dialog.total_items": "共 {count} 項",
    "budget.planner.celebration.title": "恭喜達成目標！",
    "budget.planner.celebration.desc.projected": "太棒了！您本月的預估收入已達標，\n繼續保持良好的財務規劃！",
    "budget.planner.celebration.desc.conservative": "太棒了！您上個月的收入表現優異，\n已超過原本設定的目標！",
    "budget.planner.celebration.extra_note": "💰 您有一筆額外收支可供分配運用",
    "budget.planner.celebration.btn": "太好了！", // Failed to load budget settings

    // Analysis / Trend
    "analysis.show_amount": "顯示金額",
    "analysis.show_percentage": "顯示比例",
    "analysis.monthly_net": "月收支",
    "analysis.cumulative_net": "累積結餘",
    "analysis.details": "詳細數據",
    "analysis.surplus": "結餘",
    "analysis.deficit": "透支",
    "analysis.fixed_expense": "固定支出",
    "analysis.living_expense": "生活費",
    "analysis.jars": "存錢罐",
    "analysis.savings_investment": "儲蓄/投資",
    "analysis.available": "可用金額",
    "analysis.actual_expense": "實際支出",
    "analysis.actual_net": "實際結餘",
    "analysis.cumulative_trend": "累積結餘趨勢",
    "analysis.available_budget": "可用預算",
    "analysis.loading_data": "載入數據中...",
    "analysis.no_history_data": "暫無歷史數據",

    // Asset Account
    "account.add.title": "新增帳戶",
    "account.add.form.name": "帳戶名稱",
    "account.add.form.type": "帳戶類型",
    "account.add.form.balance": "初始餘額",
    "account.add.form.currency": "幣別",
    "account.name": "帳戶名稱", // Keep for backward compatibility if needed
    "account.type": "帳戶類型", // Keep for backward compatibility if needed
    "account.balance": "期初餘額", // Keep for backward compatibility if needed
    "account.currency": "幣別", // Keep for backward compatibility if needed

    // Add Account Dialog (Extended)
    "account.add.form.note": "備註",
    "account.add.form.note_placeholder": "輸入備註資訊 (選填)",
    "account.add.form.exchange_rate": "自訂匯率 (對台幣)", // Added
    "account.add.form.rate_ref": "參考", // Added
    "account.add.form.include_total": "納入總資產統計",
    "account.add.form.include_total_desc": "開啟後金額將計入首頁統計", // Added
    "account.add.form.custom_type": "自訂類型",
    "account.add.form.select_icon": "選擇圖示",
    "account.add.form.icon_label": "代表圖示",
    "account.add.form.color": "代表顏色",
    "account.add.form.featured_colors": "精選主題色",
    "account.add.form.import_photo": "匯入照片",
    "account.add.form.remove_photo": "移除帳戶照片",
    "account.add.form.custom_icons_loading": "自訂圖片載入中...",
    "account.add.form.note_detail": "詳細備註",
    "account.add.form.note_detail_placeholder": "輸入詳細備註...",
    "account.add.form.import_photo_title": "匯入帳戶照片",
    "account.add.form.import_photo_confirm": "確認匯入",
    "account.add.form.photo_name": "照片名稱",
    "account.add.form.photo_name_placeholder": "例如：玉山主帳戶",
    "account.add.form.mode_detail_expand": "展開說明",
    "account.add.form.mode_detail_collapse": "收起說明",
    "account.add.form.search_bank": "搜尋銀行或金融機構...",
    "account.add.submit": "確認新增",
    "account.add.success": "帳戶已新增",
    "account.add.error.required": "請填寫所有必填欄位",
    "account.add.error.failed": "新增帳戶失敗",
    
    // Account Details
    "account.detail.edit_title": "編輯帳戶",
    "account.detail.view_title": "帳戶詳情",
    "account.detail.name": "帳戶名稱",
    "account.detail.type": "類型",
    "account.detail.balance": "帳戶餘額",
    "account.detail.currency": "幣別",
    "account.detail.exchange_rate": "匯率 (對台幣)",
    "account.detail.approx_twd": "約合台幣",
    "account.detail.note": "備註",
    "account.detail.n_a": "無",
    "account.detail.include_in_total": "計入總資產",
    "account.detail.include_in_total_hint": "開啟後金額將計入首頁資產統計",
    "account.detail.excluded": "不計入",
    "account.detail.save": "儲存",
    "account.detail.cancel": "取消",
    "account.detail.update_success": "帳戶資訊已更新",
    "account.detail.update_failed": "更新帳戶失敗",
    "account.detail.delete_success": "帳戶已刪除",
    "account.detail.delete_failed": "刪除帳戶失敗",
    "account.detail.transactions": "交易記錄",
    "account.detail.no_transactions": "此帳戶尚無交易記錄",
    "account.detail.current_balance": "目前餘額",
    "account.detail.section_basic": "基本資訊",
    "account.detail.section_asset": "資產設定",
    "account.detail.section_other": "其他設定",
    "account.detail.icon": "圖示",
    "account.detail.note_placeholder": "可選填...",

    // Account Actions
    "account.action.delete": "刪除帳戶",
    "account.action.transfer": "轉帳",
    "account.action.repayment": "還款",
    "account.action.adjust": "調整",
    "account.action.edit": "編輯",
    "account.action.change_icon": "更換圖示",

    // Adjustment Dialog
    "account.adjust.title": "調整餘額",
    "account.adjust.diff": "差額",
    "account.adjust.note_placeholder": "備註...",
    "account.adjust.include_stats": "計入月收支",
    "account.adjust.exclude_stats": "不計入月收支",
    "account.adjust.success": "帳戶餘額已調整",
    "account.adjust.failed": "調整餘額失敗",
    "account.adjust.confirm": "確認",
    "account.adjust.mode_absolute": "目標餘額",
    "account.adjust.mode_delta": "加減金額",
    "account.adjust.current_balance": "目前 {amount}",
    "account.adjust.delta_add": "增加",
    "account.adjust.delta_subtract": "減少",
    "account.adjust.after_preview": "調整後 {amount}",
    "account.adjust.delta_hint_add": "輸入要增加的金額",
    "account.adjust.delta_hint_subtract": "輸入要減少的金額",

    // Delete Dialog
    "account.delete.title": "確認刪除帳戶",
    "account.delete.confirm_desc": "您確定要刪除",
    "account.delete.warning": "此操作無法復原。",
    "account.delete.consequence.1": "所有相關交易記錄將失去關聯",
    "account.delete.consequence.2": "帳戶餘額資料將永久消失",
    "account.delete.confirm_btn": "確認刪除",

    "account.hide.title": "無法刪除此券商帳戶",
    "account.hide.confirm_desc": "「{name}」已有投資交易紀錄，刪除會影響銀行帳戶餘額與歷史資料。",
    "account.hide.warning": "建議改用隱藏帳戶。",
    "account.hide.consequence.1": "帳戶將從資產總覽與選單中消失，也不再計入淨資產",
    "account.hide.consequence.2": "投資交易紀錄保留；其他銀行帳戶餘額不受影響",
    "account.hide.consequence.3": "已隱藏帳戶可隨時還原",
    "account.hide.confirm_btn": "隱藏帳戶",
    "account.hide.failed": "隱藏帳戶失敗",

    "account.hidden.title": "隱藏帳戶",
    "account.hidden.description": "這些帳戶已從 App 中收起，交易紀錄與餘額仍保留",
    "account.hidden.empty": "目前沒有隱藏的帳戶",
    "account.hidden.restore": "還原",
    "account.hidden.restore_success": "還原成功",
    "account.hidden.restore_success_desc": "帳戶「{name}」已恢復顯示",
    "account.hidden.restore_failed": "還原失敗",
    "account.hidden.delete": "永久刪除",
    "account.hidden.delete.title": "永久刪除此帳戶？",
    "account.hidden.delete.confirm_desc": "確定要永久刪除「{name}」嗎？",
    "account.hidden.delete.warning": "此操作無法復原。",
    "account.hidden.delete.confirm_btn": "永久刪除",
    "account.hidden.delete.success": "已永久刪除",
    "account.hidden.delete.success_desc": "帳戶「{name}」與相關紀錄已刪除",
    "account.hidden.delete.failed": "刪除失敗",
    "account.hidden.delete.impact_failed": "無法載入刪除影響，請稍後再試",
    "account.hidden.delete.impact_heading": "對總資產的影響",
    "account.hidden.delete.impact.net_worth": "畫面上總資產預計變化：{delta}",
    "account.hidden.delete.impact.net_worth_hidden": "此帳戶目前已隱藏，畫面上總資產預計不變",
    "account.hidden.delete.impact.balance": "將一併移除帳戶餘額 {balance}（約 {twd}）",
    "account.hidden.delete.impact.balance_short": "帳面餘額 {balance}（約 {twd}）將一併移除",
    "account.hidden.delete.impact.investments": "將刪除 {count} 筆持股／投資部位（市值約 {value}）",
    "account.hidden.delete.impact.ledger": "將刪除約 {count} 筆相關記帳（含 {groups} 組轉帳）",
    "account.hidden.delete.impact.jars": "存錢罐「{names}」的存款來源關聯會解除，罐內金額不變",
    "account.hidden.delete.impact.loans": "將解除 {count} 筆借貸的往來帳戶連結",
    "account.hidden.delete.impact.irreversible": "刪除後無法還原，請確認資料已不再需要",

    "overview.menu.hidden_accounts": "隱藏帳戶",

    "account.wallet.leave.action": "離開公費錢包",
    "account.wallet.leave.title": "確認離開此公費錢包？",
    "account.wallet.leave.confirm_desc": "您確定要離開「{name}」嗎？",
    "account.wallet.leave.consequence.1": "您將無法再在此公費錢包記帳或查看共用餘額",
    "account.wallet.leave.consequence.2": "其他成員仍可繼續使用此公費錢包",
    "account.wallet.leave.consequence.3": "您個人帳戶上的記帳紀錄不會被刪除",
    "account.wallet.leave.confirm_btn": "離開公費錢包",

    "account.wallet.delete.title": "確認刪除此公費錢包？",
    "account.wallet.delete.confirm_desc": "您確定要刪除「{name}」嗎？",
    "account.wallet.delete.member_count": "目前另有 {count} 位成員正在使用此公費錢包",
    "account.wallet.delete.member_count_zero": "目前尚無其他成員加入",
    "account.wallet.delete.warning": "此操作無法復原。",
    "account.wallet.delete.consequence.1": "所有成員將無法再使用此公費錢包記帳",
    "account.wallet.delete.consequence.2": "系統將通知所有成員此公費錢包已被刪除",
    "account.wallet.delete.consequence.3": "此錢包上的交易紀錄將失去帳戶關聯；各成員在自己帳戶的紀錄仍保留",
    "account.wallet.delete.confirm_btn": "刪除公費錢包",

    "account.advance.leave.action": "離開分帳",
    "account.advance.leave.title": "確認離開此代墊分帳？",
    "account.advance.leave.confirm_desc": "您確定要離開「{name}」嗎？",
    "account.advance.leave.outstanding": "尚有未結清 NT$ {amount}",
    "account.advance.leave.consequence.1": "分帳將封存，您與對方都無法再新增記帳",
    "account.advance.leave.consequence.2": "記帳頁的歷史紀錄完整保留，不會被刪除",
    "account.advance.leave.consequence.3": "對方會收到通知；之後可在「已封存分帳」查看",
    "account.advance.leave.confirm_btn": "離開並封存",

    "account.advance.close.action": "關閉分帳",
    "account.advance.close.title": "確認關閉此代墊分帳？",
    "account.advance.close.confirm_desc": "您確定要關閉「{name}」嗎？",
    "account.advance.close.outstanding": "目前餘額 NT$ {amount}",
    "account.advance.close.consequence.1": "分帳將封存，雙方都無法再新增記帳或代墊",
    "account.advance.close.consequence.2": "記帳頁歷史完整保留，不會影響既有顯示與編輯（備註／分類）",
    "account.advance.close.consequence.3": "成員會收到通知；帳戶不會被硬刪除",
    "account.advance.close.confirm_btn": "關閉並封存",

    "account.advance.hide.action": "隱藏分帳",
    "account.advance.hide.title": "隱藏已封存的分帳？",
    "account.advance.hide.confirm_desc": "「{name}」將從資產總覽收起。",
    "account.advance.hide.consequence.1": "記帳頁歷史仍正常顯示，不受影響",
    "account.advance.hide.consequence.2": "可隨時在「隱藏帳戶」還原查看",
    "account.advance.hide.consequence.3": "此操作僅影響您的介面，不通知對方",
    "account.advance.hide.confirm_btn": "隱藏分帳",

    "account.advance.banner.archived_owner": "此分帳已封存，無法新增記帳",
    "account.advance.banner.archived_member_left": "您已離開此分帳，目前為封存狀態",
    "account.advance.banner.archived_owner_closed": "創建者已關閉此分帳",
    "account.advance.banner.outstanding": "尚有未結清 NT$ {amount}",
    "account.advance.banner.reopen_wait_member": "已請求重新開啟，等待對方確認餘額",
    "account.advance.banner.reopen_wait_owner": "創建者請求重新開啟，請確認目前餘額 NT$ {amount}",
    "account.advance.reopen.request_btn": "重新開啟分帳",
    "account.advance.reopen.confirm_btn": "確認餘額並重新加入",
    "account.advance.member.left": "已離開",
    "account.advance.section.title": "已封存分帳",
    "account.advance.badge.archived": "已封存",

    "account.icon.wallet": "錢包",
    "account.icon.cash": "現金",
    "account.icon.piggy": "存錢筒",
    "account.icon.card": "信用卡",
    "account.icon.bank": "銀行",
    "account.icon.stock": "股票",
    "account.icon.crypto": "加密貨幣",
    "account.icon.house": "房產",
    "account.icon.coin": "零錢",
    "account.icon.target": "目標",
    "account.icon.briefcase": "公務",
    "account.icon.calc": "計算",
    "account.icon.receipt": "收據",
    "account.icon.dollar": "貨幣",
    "account.icon.percent": "利息",
    "account.icon.scale": "平衡",
    "account.icon.gem": "貴重物品",
    "account.icon.gift": "禮物",
    "account.icon.users": "共用",
    "account.icon.user": "個人",
    "account.icon.handshake": "借貸",

    // Theme Icons (Generic Finance)
    "theme.wallet": "錢包",
    "theme.cash": "現金",
    "theme.piggy": "存錢筒",
    "theme.card": "信用卡",
    "theme.bank": "銀行",
    "theme.stock": "股票",
    "theme.crypto": "加密貨幣",
    "theme.house": "房產",
    "theme.coin": "零錢",
    "theme.target": "目標",
    "theme.briefcase": "公務",
    "theme.calc": "計算",
    "theme.receipt": "收據",
    "theme.dollar": "貨幣",
    "theme.percent": "利息",
    "theme.scale": "平衡",
    "theme.gem": "貴重物品",
    "theme.gift": "禮物",
    "theme.users": "共用",
    "theme.user": "個人",
    "theme.handshake": "借貸",
    
    // Shared Account
    "shared.account.title": "共同帳戶",
    "shared.account.start.title": "您想要如何開始？",
    "shared.account.create.title": "建立新共同帳戶",
    "shared.account.create.desc": "開始一個新的共同記帳本",
    "shared.account.join.title": "加入現有帳戶",
    "shared.account.join.desc": "輸入邀請碼加入夥伴的帳戶",
    "shared.account.create.subtitle": "建立共同帳戶",
    "shared.account.create.name.label": "帳戶名稱",
    "shared.account.create.name.placeholder": "例如：我們的旅遊基金",
    "shared.account.create.button": "建立並產生邀請碼",
    "shared.account.invite.scan": "掃描或分享此代碼給您的夥伴",
    "shared.account.invite.share_hint": "分享此代碼給夥伴，輸入後即可加入。",
    "shared.account.invite.expire_hint": "代碼將在 24 小時後失效。",
    "shared.account.invite.copy": "複製連結",
    "shared.account.invite.copy_code": "複製代碼",
    "shared.account.invite.code_copied": "已複製代碼",
    "shared.account.invite.code_copied.desc": "代碼已複製到剪貼簿",
    "shared.account.invite.copied": "連結已複製",
    "shared.account.invite.copied.desc": "邀請連結已複製到剪貼簿",
    "shared.account.invite.done": "完成",
    "shared.account.join.subtitle": "加入共同帳戶",
    "shared.account.join.code.label": "邀請碼",
    "shared.account.join.code.placeholder": "請輸入邀請碼",
    "shared.account.join.button": "加入帳戶",
    "shared.account.join.check_code": "檢查代碼",
    "shared.account.join.scan_qr": "掃描 QR Code",
    "shared.account.join.scan_hint": "將 QR Code 置於框內",
    "shared.account.join.error.invalid": "邀請代碼無效，請確認代碼是否正確。",
    "shared.account.join.error.expired": "此邀請代碼已過期。",
    "shared.account.join.error.already": "您已經是此共同帳戶的成員。",
    "shared.account.join.error.not_found": "找不到此邀請代碼，請確認代碼正確。",
    "shared.account.join.error.check_failed": "檢查失敗",
    "shared.account.scan.error": "掃描錯誤",
    "shared.account.scan.error.desc": "無法啟動相機，請檢查權限。",
    "shared.account.join.success": "成功加入",
    "shared.account.join.success.desc": "您現在是 {accountName} 的成員",
    "shared.account.type.wallet.desc": "共同持有資金",
    "shared.account.type.personal.desc": "自動計算債務",
    "shared.confirm.title": "邀請函",
    "shared.confirm.wallet": "公費錢包",
    "shared.confirm.project": "代墊分帳",
    "shared.confirm.invited_by": "邀請人",
    "shared.confirm.balance": "目前餘額",
    "shared.confirm.total_assets": "計入總資產",
    "shared.confirm.total_assets.off": "不計入總資產",
    "shared.confirm.total_assets.desc": "點擊切換是否計入您的總資產",
    "shared.confirm.button": "確認加入",
    "shared.confirm.joining": "加入中...",
    "shared.confirm.cancel": "取消",
    "account.mode.individual": "日常帳戶",
    "account.mode.individual.tab": "日常",
    "account.mode.individual.desc": "日常收支與資金管理",
    "account.mode.individual.desc_full": "管理每天會用到的資金與支付工具，例如現金、銀行存款、外幣與信用卡；可用來記錄生活收支與資金流向。",
    "account.mode.broker": "投資帳戶",
    "account.mode.broker.tab": "投資",
    "account.mode.broker.desc": "記錄投資資產與持倉變化",
    "account.mode.broker.desc_full": "用於管理投資資產與持倉變化，例如股票、ETF、基金與加密資產；可追蹤部位、市值與配置。為避免投資成本與持倉失真，投資帳戶不支援直接「調整餘額」與一般「轉帳」，請透過買賣、入金或出金紀錄反映資金變動。",
    "account.details.title": "詳細資訊",
    "shared.account.setup.balance": "初始餘額",
    "shared.account.setup.currency": "幣別",
    "account.mode.shared": "共同帳戶",
    "account.mode.shared.tab": "共同",
    "account.mode.shared.desc": "與他人共享收支、分攤與結算",
    "account.mode.shared.desc_full": "適合與家人、伴侶或團隊共同管理資金，可用於共享收支、費用分攤與後續結算。建立後帳戶類型不可再變更（例如公費錢包/代墊分帳），因為會影響成員關係、邀請機制與分帳規則，建議建立前先確認用途。",
    "account.type.shared": "共同帳戶",
  },
  "en": {
    "settings.title": "Settings",
    "settings.profile.edit": "Edit Profile",
    "settings.profile.vip": "VIP Plan (In Dev)",
    "settings.appearance.title": "Appearance & Display",
    "settings.appearance.darkMode": "Dark Mode",
    "settings.appearance.themeColor": "Theme Color",
    "settings.appearance.theme_preview": "Theme preview",
    "settings.theme.blue": "Classic Blue",
    "settings.theme.sapphire": "Sapphire",
    "settings.theme.sky": "Sky Blue",
    "settings.theme.cyan": "Ocean Cyan",
    "settings.theme.seafoam": "Seafoam",
    "settings.theme.teal": "Teal",
    "settings.theme.mint": "Mint",
    "settings.theme.green": "Emerald",
    "settings.theme.forest": "Forest",
    "settings.theme.lime": "Lime",
    "settings.theme.money": "Gold",
    "settings.theme.amber": "Amber",
    "settings.theme.orange": "Sunset",
    "settings.theme.copper": "Copper",
    "settings.theme.coral": "Coral",
    "settings.theme.peach": "Peach",
    "settings.theme.red": "Crimson",
    "settings.theme.wine": "Wine",
    "settings.theme.pink": "Cherry",
    "settings.theme.fuchsia": "Fuchsia",
    "settings.theme.lavender": "Lavender",
    "settings.theme.violet": "Violet",
    "settings.theme.grape": "Grape",
    "settings.theme.indigo": "Indigo",
    "settings.theme.navy": "Navy",
    "settings.theme.midnight": "Midnight",
    "settings.theme.slate": "Slate",
    "settings.theme.stone": "Stone",
    "settings.general.title": "General & Preferences",
    "settings.general.categories": "Categories",
    "settings.general.categories.desc": "Manage",
    "settings.general.water_gyro": "Water Tilt Effect",
    "settings.general.reminder": "Daily Reminder",
    "settings.general.reminder_desc": "Sends a daily reminder at your chosen time to log the day's spending",
    "settings.general.reminder_time": "Time",
    "settings.general.reminder_time_title": "Set reminder time",
    "settings.general.smart_budget": "Smart Budget Alerts",
    "settings.general.smart_budget_desc": "After each entry, checks this month's remaining budget and usage ratio, then alerts you near your threshold",
    "settings.general.smart_budget_threshold": "Threshold",
    "settings.general.smart_budget_threshold_title": "Set alert threshold",
    "settings.general.language": "Language",
    "settings.general.currency": "Default Currency",
    "settings.data.title": "Data Management",
    "settings.data.export": "Export Data (Excel)",
    "settings.data.clear": "Clear All Data",
    "settings.data.delete_account": "Delete Account",
    "settings.other.title": "Other",
    "settings.other.help": "Help & Feedback",
    "settings.other.privacy": "Privacy Policy",
    "settings.other.terms": "Terms of Service",
    "settings.other.version": "Version Info",
    "settings.feedback.title": "Help & Feedback",
    "settings.feedback.desc": "Leave a review or email us — it helps MoneyTrack improve.",
    "settings.feedback.app_store": "Rate & review on the App Store",
    "settings.feedback.app_store_hint": "Opens the App Store page for ratings and reviews",
    "settings.feedback.app_store_pending": "Available after the App is published",
    "settings.feedback.email": "Email support",
    "settings.feedback.store_soon_title": "App Store page not ready yet",
    "settings.feedback.store_soon_desc": "Once published, you can rate and review from here. Please email us for now.",
    "settings.logout": "Logout",
    "settings.logout.confirm": "Are you sure you want to logout?",

    // Dialogs - Edit Profile
    "dialog.profile.title": "Edit Profile",
    "dialog.profile.desc": "Sets the name shown across all pages",
    "dialog.profile.name": "Display Name",
    "dialog.profile.namePlaceholder": "Enter your nickname",
    "dialog.profile.email": "Email",
    "dialog.profile.emailDesc": "Read-only",
    "dialog.profile.cancel": "Cancel",
    "dialog.profile.save": "Save Changes",
    "dialog.profile.saving": "Saving...",

    // Dialogs - Clear Data 1
    "dialog.clear.title": "Clear All Data",
    "dialog.clear.confirm_desc": "Are you sure you want to clear all financial data in your account?",
    "dialog.clear.warning": "This action cannot be undone.",
    "dialog.clear.consequence.1": "Ledger, budgets, assets, investments, and savings jars will be permanently deleted",
    "dialog.clear.consequence.2": "Your login account will be kept and you can continue using the app",
    "dialog.clear.consequence.3": "After clearing finishes, you’ll return to the Assets home",
    "dialog.clear.cancel": "Cancel",
    "dialog.clear.confirm": "Confirm Clear",

    // Dialogs - Clear Data 2
    "dialog.final.title": "Final Confirmation",
    "dialog.final.confirm_desc": "Are you sure you want to clear everything now?",
    "dialog.final.warning": "All data will be irreversible after clearing.",
    "dialog.final.consequence.1": "Financial data will be wiped immediately",
    "dialog.final.consequence.2": "Your login account itself will not be deleted",
    "dialog.final.cancel": "Cancel",
    "dialog.final.confirm": "Confirm Clear",
    "dialog.final.confirming": "Clearing...",

    "dialog.delete_account.title": "Delete Account",
    "dialog.delete_account.confirm_desc": "This is different from “Clear All Data” — your sign-in identity will also be removed.",
    "dialog.delete_account.warning": "This action cannot be undone.",
    "dialog.delete_account.consequence.1": "Permanently delete your sign-in identity and profile",
    "dialog.delete_account.consequence.2": "Ledger, budgets, assets, investments, savings jars, and loans are deleted",
    "dialog.delete_account.consequence.3": "Reminders, notifications, and uploaded images are cleared",
    "dialog.delete_account.consequence.4": "You leave shared accounts you joined (others’ data is kept)",
    "dialog.delete_account.consequence.5": "If you still own shared accounts, dissolve them or ask members to leave first",
    "dialog.delete_account.cancel": "Cancel",
    "dialog.delete_account.confirm": "I understand, continue",
    "dialog.delete_account.second.title": "Second Confirmation",
    "dialog.delete_account.second.confirm_desc": "Deletion cannot be restored via export or support.",
    "dialog.delete_account.second.warning": "Please confirm again that you really want to delete your account.",
    "dialog.delete_account.second.consequence.1": "Your account and personal financial data will be permanently gone",
    "dialog.delete_account.second.consequence.2": "Other people’s shared-account data will not be deleted",
    "dialog.delete_account.second.consequence.3": "Using the same email later requires signing up again",
    "dialog.delete_account.second.cancel": "Cancel",
    "dialog.delete_account.second.confirm": "Still delete",
    "dialog.delete_account.final.title": "Final Confirmation: Permanent Delete",
    "dialog.delete_account.final.confirm_desc": "Confirming will delete your account immediately and sign you out.",
    "dialog.delete_account.final.warning": "This action cannot be undone.",
    "dialog.delete_account.final.consequence.1": "Your identity and all personal data are destroyed immediately",
    "dialog.delete_account.final.consequence.2": "You will no longer be able to sign in with this account",
    "dialog.delete_account.final.cancel": "Cancel",
    "dialog.delete_account.final.confirm": "Delete Account",
    "dialog.delete_account.final.confirming": "Deleting...",

    "toast.delete_account.success": "Account deleted",
    "toast.delete_account.error": "Failed to delete account",

    // Toasts
    "toast.export.title": "Exporting",
    "toast.export.desc": "Your data is being prepared...",
    "toast.clear.error": "Clear Failed",
    "toast.update.error": "Update Failed",
    "toast.logout.error": "Logout Failed",
    "toast.name.required": "Please enter a nickname",

    // Currencies
    "currency.twd": "New Taiwan Dollar (TWD)",
    "currency.usd": "US Dollar (USD)",
    "currency.jpy": "Japanese Yen (JPY)",
    "currency.TWD": "New Taiwan Dollar",
    "currency.USD": "US Dollar",
    "currency.JPY": "Japanese Yen",
    "currency.EUR": "Euro",
    "currency.GBP": "British Pound",
    "currency.CNY": "Chinese Yuan",
    "currency.HKD": "Hong Kong Dollar",
    "currency.KRW": "South Korean Won",
    "currency.AUD": "Australian Dollar",
    "currency.SGD": "Singapore Dollar",
    "currency.CAD": "Canadian Dollar",

    // Navigation
    "nav.overview": "Overview",
    "nav.budget": "Budget",
    "nav.ledger": "Ledger",
    "nav.investment": "Invest",
    "nav.settings": "Settings",
    // Common Units
    "common.unit.ten_thousand": "0k",
    "common.today": "Back to Today",
    "common.year": "Year",
    "common.month": "Month",
    "common.unit.hundred_million": "00m",
    // Asset Overview
    "overview.title": "Asset Overview",
    "overview.total_assets": "Total Assets",
    "overview.net_assets": "Net Assets",
    "overview.liabilities": "Liabilities",
    "overview.chart.trend.title": "Net Worth Trend", // Added
    "overview.chart.breakdown.title": "Asset Distribution", // Added
    "overview.assets": "Assets", // Added for toggle
    "overview.tab.trend": "Trend",
    "overview.tab.composition": "Breakdown",
    "overview.tab.details": "Details",
    "overview.button.add_account": "Add Account",

    "overview.menu.title": "Menu",
    "overview.menu.rates": "Get Real Rates",
    "overview.menu.sync": "Sync Prices",
    "overview.menu.syncing": "Syncing...",
    "overview.net_worth": "Total Net Worth",
    "overview.vs_yesterday": "vs Yesterday",
    "overview.vs_yesterday.cash": "Ledger",
    "overview.vs_yesterday.invest": "Invest",
    "overview.vs_yesterday.empty": "-",
    "overview.vs_yesterday.flat": "Flat",
    "overview.vs_yesterday.analysis.title": "vs Yesterday",
    "overview.vs_yesterday.analysis.desc": "How today's net worth moved versus yesterday",
    "overview.vs_yesterday.analysis.range": "{from} → {to}",
    "overview.vs_yesterday.analysis.net_change": "Net worth change",
    "overview.vs_yesterday.analysis.split": "Where it came from",
    "overview.vs_yesterday.analysis.breakdown": "Breakdown",
    "overview.vs_yesterday.analysis.invest_hint": "MV change (sum of holdings vs yesterday)",
    "overview.vs_yesterday.analysis.other_hint": "Ledger net (included-in-total accounts only)",
    "overview.vs_yesterday.analysis.other_diff": "Other difference",
    "overview.vs_yesterday.analysis.other_diff_hint": "Gap between net worth and (ledger + holdings sum)",
    "overview.vs_yesterday.analysis.invest_detail": "Investment detail",
    "overview.vs_yesterday.analysis.invest_detail_hint": "MV change (sum of holdings vs yesterday)",
    "overview.vs_yesterday.analysis.other_detail": "Ledger detail",
    "overview.vs_yesterday.analysis.other_detail_hint": "Ledger net (included-in-total accounts only)",
    "overview.vs_yesterday.analysis.loading": "Loading details",
    "overview.vs_yesterday.analysis.no_investment": "No investment holdings",
    "overview.vs_yesterday.analysis.no_invest_detail": "Investment breakdown is temporarily unavailable. Try again shortly.",
    "overview.vs_yesterday.analysis.detail_error": "Failed to load details. Please try again.",
    "overview.vs_yesterday.analysis.retry": "Retry",
    "overview.vs_yesterday.analysis.rounding_note": "Small rounding differences may appear in the totals",
    "overview.vs_yesterday.analysis.baseline_note": "Yesterday's baseline was incomplete, so it was rebuilt from today's data. Numbers will be more accurate from tomorrow.",
    "overview.vs_yesterday.analysis.holding.qty": "Shares",
    "overview.vs_yesterday.analysis.holding.yesterday_mv": "Yday value",
    "overview.vs_yesterday.analysis.holding.today_mv": "Today value",
    "overview.vs_yesterday.analysis.holding.formula": "Today − yesterday value",
    "overview.vs_yesterday.analysis.holding.swipe": "How",
    "overview.vs_yesterday.analysis.holding.no_prior": "No prior close yet — this name is excluded from the day change.",
    "overview.vs_yesterday.analysis.holding.y": "Y",
    "overview.vs_yesterday.analysis.holding.t": "T",
    "overview.vs_yesterday.analysis.holding.shares_unit": "sh",
    "overview.vs_yesterday.debug.button": "Calc debug",
    "overview.vs_yesterday.debug.title": "vs Yesterday · Calc debug",
    "overview.vs_yesterday.debug.loading": "Loading calc details…",
    "overview.vs_yesterday.debug.error": "Failed to load debug data",
    "overview.vs_yesterday.debug.desc": "Intermediate values and formulas used by the server (debug only)",
    "overview.vs_yesterday.debug.partial_ready": "Ledger/overview ready; investment prior closes still loading and will appear when done.",
    "overview.vs_yesterday.debug.loading_invest": "Loading investment holdings (prior close)…",
    "overview.vs_yesterday.debug.loading_prior_close": "Loading calc details… (fetching prior closes)",
    "overview.vs_yesterday.debug.section.dates": "Date / timezone",
    "overview.vs_yesterday.debug.section.overview": "Overview formulas",
    "overview.vs_yesterday.debug.section.ledger": "Ledger detail (parts → buckets)",
    "overview.vs_yesterday.debug.section.invest_formulas": "Holding formulas",
    "overview.vs_yesterday.debug.section.invest_detail": "Invest detail · {market} ({change})",
    "overview.vs_yesterday.debug.no_holdings": "(No holdings)",
    "overview.vs_yesterday.debug.label.timezone": "Timezone",
    "overview.vs_yesterday.debug.timezone.taipei": "Taipei time (Asia/Taipei)",
    "overview.vs_yesterday.debug.label.today_iso": "Today (as-of)",
    "overview.vs_yesterday.debug.label.yesterday_iso": "Yesterday",
    "overview.vs_yesterday.debug.label.formula": "Note",
    "overview.vs_yesterday.debug.label.today_net_worth": "Today net worth",
    "overview.vs_yesterday.debug.label.yesterday_net_worth": "Yesterday net worth",
    "overview.vs_yesterday.debug.label.net_worth_change": "Net worth change",
    "overview.vs_yesterday.debug.label.today_invest": "Today investment value",
    "overview.vs_yesterday.debug.label.yesterday_invest": "Yesterday investment value",
    "overview.vs_yesterday.debug.label.invest_net_inflow": "Investment net inflow",
    "overview.vs_yesterday.debug.label.invest_change": "Investment change",
    "overview.vs_yesterday.debug.label.ledger_change": "Ledger change",
    "overview.vs_yesterday.debug.label.other_diff": "Other difference",
    "overview.vs_yesterday.debug.label.loan_deduction": "Loan deduction",
    "overview.vs_yesterday.debug.label.baseline": "Yesterday baseline",
    "overview.vs_yesterday.debug.label.ledger_net": "Ledger net total",
    "overview.vs_yesterday.debug.label.residual_formula": "Residual formula",
    "overview.vs_yesterday.debug.label.holding_change_formula": "Holding MV Δ formula",
    "overview.vs_yesterday.debug.label.today_value_formula": "Today value formula",
    "overview.vs_yesterday.debug.label.yesterday_value_formula": "Yesterday value formula",
    "overview.vs_yesterday.debug.label.residual_invest_formula": "Invest residual formula",
    "overview.vs_yesterday.debug.label.historical_sum": "Sum of historical holding Δ",
    "overview.vs_yesterday.debug.label.price_source": "Price source",
    "overview.vs_yesterday.debug.label.broker": "Broker account",
    "overview.vs_yesterday.debug.label.fx_rate": "FX rate (→ TWD)",
    "overview.vs_yesterday.debug.label.qty_price": "Qty × last price",
    "overview.vs_yesterday.debug.label.yqty_yprice": "Yday qty × prior close",
    "overview.vs_yesterday.debug.label.today_value_twd": "Today value (TWD)",
    "overview.vs_yesterday.debug.label.yesterday_value_twd": "Yesterday value (TWD)",
    "overview.vs_yesterday.debug.label.day_net_inflow": "Same-day net inflow (reference)",
    "overview.vs_yesterday.debug.label.verify": "Check",
    "overview.vs_yesterday.debug.label.company": "Company / name",
    "overview.vs_yesterday.debug.label.ticker": "Ticker",
    "overview.vs_yesterday.debug.label.explain": "Explain",
    "overview.vs_yesterday.debug.no_prior_close": "No prior close",
    "overview.vs_yesterday.debug.baseline.snapshot": "Snapshot",
    "overview.vs_yesterday.debug.baseline.reconstructed": "Reconstructed",
    "overview.vs_yesterday.debug.baseline.no_row": "(no snapshot row)",
    "overview.vs_yesterday.debug.price.historical": "Historical prior close",
    "overview.vs_yesterday.debug.price.allocated": "Allocated estimate",
    "overview.vs_yesterday.debug.price.unavailable": "Unavailable",
    "overview.vs_yesterday.debug.price.residual": "Residual",
    "overview.vs_yesterday.debug.formula.timezone": "Today/yesterday cut by Asia/Taipei calendar day (midnight Taipei)",
    "overview.vs_yesterday.debug.formula.net_worth_change": "ledger change + investment change",
    "overview.vs_yesterday.debug.formula.snapshot_net_worth_change": "todayNetWorth − yesterdayNetWorth (snapshot, debug only)",
    "overview.vs_yesterday.debug.label.snapshot_net_worth_change": "Snapshot NW change (debug)",
    "overview.vs_yesterday.debug.formula.investment_change": "Σ holding MVΔ (prior close; badge)",
    "overview.vs_yesterday.debug.formula.cash_and_other": "sum(today ledger buckets)",
    "overview.vs_yesterday.debug.formula.other_diff": "netWorthChange − investmentChange − cashAndOtherChange",
    "overview.vs_yesterday.debug.formula.cash_residual": "cashAndOtherChange − sum(ledger buckets except residual)",
    "overview.vs_yesterday.debug.formula.holding_change": "todayValue − prior close (US flat off landing day)",
    "overview.vs_yesterday.debug.formula.today_value": "qty × currentPrice × fx(broker→TWD)",
    "overview.vs_yesterday.debug.formula.yesterday_value": "yesterdayQty × priorClose × fx",
    "overview.vs_yesterday.debug.formula.residual_invest": "investmentChange − sum(historical holding changes)",
    "overview.vs_yesterday.debug.residual_explain": "investmentChange − sum of holdings with prior close (often FX / baseline gap)",
    "overview.vs_yesterday.debug.broker_line": "{account} · {currency} · FX {fx}",
    "overview.vs_yesterday.debug.verify_line": "{today} − {yesterday} = {change}",
    "overview.vs_yesterday.debug.holding_title": "{name} ({ticker})",
    "overview.vs_yesterday.debug.formula.holdings_sum": "sum of (todayValue − priorCloseValue) per holding",
    "overview.vs_yesterday.debug.label.holdings_sum": "Holdings sum (detail)",
    "overview.vs_yesterday.debug.label.invest_snapshot": "Investment change (snapshot / badge)",
    "overview.vs_yesterday.analysis.price_allocated": "Est.",
    "overview.vs_yesterday.analysis.price_unavailable": "No prior close",
    "overview.vs_yesterday.bucket.ledger_income": "Ledger income",
    "overview.vs_yesterday.bucket.ledger_expense": "Ledger expense",
    "overview.vs_yesterday.bucket.transfer_income": "Transfer in",
    "overview.vs_yesterday.bucket.transfer_expense": "Transfer out",
    "overview.vs_yesterday.bucket.lending_income": "Lending in",
    "overview.vs_yesterday.bucket.lending_expense": "Lending out",
    "overview.vs_yesterday.bucket.balance_adjustment": "Balance adjustment",
    "overview.vs_yesterday.bucket.fee": "Fees",
    "overview.vs_yesterday.bucket.lending": "Lending / repayment",
    "overview.vs_yesterday.bucket.residual": "Unclassified adjustment",
    "overview.vs_yesterday.bucket.residual_invest": "FX / baseline gap",
    "overview.vs_yesterday.market.tw": "TW stocks",
    "overview.vs_yesterday.market.us": "US stocks",
    "overview.vs_yesterday.market.crypto": "Crypto",
    "overview.vs_yesterday.market.other": "Other",
    "overview.tabs.accounts": "My Accounts",
    "overview.tabs.analysis": "Analysis",

    // Asset Detail Table
    "asset.details.title": "Accounts",
    "asset.details.loans": "Loans",
    "asset.details.transfer": "Transfer",
    "asset.details.add": "Add",
    "asset.details.empty.title": "No accounts added yet",
    "asset.details.empty.desc": "Start tracking your first asset",
    "asset.details.empty.btn": "Add Now",
    "asset.details.rate": "Rate",
    "asset.details.jar_reserve": "Jar",
    "asset.details.excluded_from_assets": "Off assets",
    "asset.details.section_meta": "{categories} types · {accounts} accounts",
    "asset.details.theme_color": "Accent Color",
    "asset.details.theme_presets": "Presets",
    "asset.details.change_theme": "Change accent color",
    "asset.details.info_expand": "Show section info",
    "asset.details.info_collapse": "Hide section info",
    "overview.chart.trend.net_worth": "Net Worth",
    "overview.chart.trend.empty": "No net worth history yet",
    "overview.chart.trend.load_error": "Couldn't load data. Please try again.",
    "overview.chart.trend.retry": "Retry",
    "overview.chart.trend.relogin": "Sign in again",
    "overview.chart.breakdown.empty_assets": "No assets yet",
    "overview.chart.breakdown.empty_liabilities": "No liabilities yet",
    "account.detail.jar_disposable": "Available",
    "account.detail.jar_breakdown_title": "Jar details",
    "account.detail.jar_reserve_total": "Total reserved",
    "account.detail.jar_deposited": "Deposited",
    "account.detail.jar_spent": "Spent",
    "account.detail.jar_remaining": "Balance",
    "account.detail.jar_breakdown_empty": "No jar deposits or spending from this account yet",
    "account.detail.jar_filter_active": "Filter: {name}",
    "account.detail.jar_filter_clear": "Show all",
    "account.detail.jar_filter_empty": "No spending for this jar yet",

    // Investment
    "investment.holdings.empty": "No Holdings",
    "investment.holdings.closed": "Closed",
    "investment.holdings.closed_count": "({count})",
    "investment.holdings.closed_hint": "Tap to view history and analysis",
    "investment.holdings.closed_badge": "Closed",
    "investment.holdings.closed_unit": "pos.",
    "investment.holdings.closed_dialog_desc": "{market} · {count} closed position(s)",
    "investment.holdings.closed_empty": "No closed positions in this market",
    "investment.quote.unavailable": "Quote Unavailable",
    "investment.shares": "shares",
    "investment.avg_price": "Avg Cost",
    "investment.transactions.empty": "No Transactions",
    "investment.chart.distribution": "Portfolio Distribution",
    "investment.chart.total_value": "Total Value",
    "investment.chart.click_return": "Click Return",
    "investment.unknown_asset": "Unknown Asset",
    "investment.historical_tx": "Historical",
    "investment.current_price": "Price",
    "investment.title": "Portfolio",
    "investment.sync.now": "Sync Prices",
    "investment.filter.all": "All",
    "investment.filter.stock_tw": "TW",
    "investment.filter.stock_us": "US",
    "investment.filter.crypto": "Crypto",
    "investment.total_value_est": "Total Value",
    "investment.total_cost": "Total Cost",
    "investment.total_pl": "Total P/L",
    "investment.stock.market_value": "Position Value",
    "investment.stock.holding_cost": "Cost Basis",
    "investment.stock.holding_pl": "Position P/L",
    "investment.stock.back_to_market": "Back to Market",
    "investment.stock.clear_filter": "Clear Filter",
    "investment.stock.filtered_hint": "Tap chart or list to filter by stock",
    "investment.tab.holdings": "Holdings",
    "investment.tab.analysis": "Analysis",
    "investment.tab.transactions": "History",
    "investment.analysis.trend": "Asset Trend",
    "investment.analysis.returns": "Returns",
    "investment.analysis.period_pl": "Period P/L",

    // Investment Dialog
    "investment.dialog.title.add": "Add Transaction",
    "investment.dialog.title.edit": "Edit Transaction",
    "investment.dialog.delete.tooltip": "Delete Transaction",
    "investment.dialog.delete.confirm": "Are you sure you want to delete this transaction? This action cannot be undone and will revert the account balance.",
    "investment.dialog.delete.error": "Delete Failed",
    "investment.dialog.submit.error.update": "Update Failed",
    "investment.dialog.submit.error.add": "Add Failed",
    "investment.dialog.submit.error.insufficient_balance": "Insufficient balance in the payment account. Please ensure you have enough funds before buying.",
    "investment.dialog.required": "Please fill in all required fields",
    "investment.action.buy": "Buy",
    "investment.action.sell": "Sell",
    "investment.field.ticker": "Ticker Symbol",
    "investment.field.ticker.placeholder": "e.g., 2330",
    "investment.field.name": "Name (Optional)",
    "investment.field.quantity": "Quantity",
    "investment.field.price": "Price",
    "investment.field.fees": "Fees",
    "investment.field.date": "Date",
    "investment.field.date.clear": "Clear Date (Set as Historical)",
    "investment.field.history_note": "Historical: Not shown in charts",
    "investment.status.searching": "Searching...",
    "investment.status.found": "Found",
    "investment.status.processing": "Processing...",
    "investment.flow.title": "Fund Flow",
    "investment.account.payment": "Payment Account",
    "investment.account.deposit": "Deposit Account",
    "investment.account.broker": "Brokerage Account",
    "investment.account.select.payment": "Select Payment Account",
    "investment.account.select.deposit": "Select Deposit Account",
    "investment.account.select.broker": "Select Brokerage Account",
    "investment.account.select.payment_desc": "Select source/destination of funds",
    "investment.account.select.broker_desc": "Select brokerage account for this transaction",
    "investment.summary.total_est": "Total Amount",
    "investment.summary.tap_to_input": "Tap amount to enter total",
    "investment.summary.manual_total_hint": "You can enter total amount directly. Price is auto-filled (uses quantity = 1 when empty).",
    "investment.summary.confirm_total": "Confirm total amount",
    "investment.summary.cancel_total": "Cancel total amount input",
    "investment.summary.invalid_total": "Please enter a valid total amount",
    "investment.submit.update": "Update Transaction",
    "investment.submit.confirm_buy": "Confirm Buy",
    "investment.submit.confirm_sell": "Confirm Sell",
    "investment.period.1m": "1M",
    "investment.period.3m": "3M",
    "investment.period.6m": "6M",
    "investment.period.1y": "1Y",
    "investment.period.2y": "2Y",
    "investment.chart.price": "Price",
    "investment.chart.avg_cost": "Avg Cost",
    "investment.chart.no_data": "No Data",
    "investment.legend.buy": "Buy",
    "investment.legend.sell": "Sell",
    "investment.legend.avg": "Avg Line",
    "investment.chart.period.1m": "1M",
    "investment.chart.period.3m": "3M",
    "investment.chart.period.6m": "6M",
    "investment.chart.period.1y": "1Y",
    "investment.chart.period.max": "Max",
    "investment.tooltip.total_assets": "Total Value",
    "investment.tooltip.total_cost": "Total Cost",
    "investment.tooltip.profit_loss": "Profit/Loss",
    "investment.status.loading": "Loading...",
    "investment.status.loading_chart": "Preparing chart",
    "investment.status.loading_chart_hint": "Gathering price history…",
    "investment.status.load_failed": "Load Failed",
    "investment.status.retry": "Please retry",
    "investment.chart.no_history": "No investment history",
    "investment.chart.start_asset": "Starting Asset",
    "investment.chart.current_asset": "Current Asset",
    "investment.chart.period_return": "Period Return",
    "investment.chart.return_comparison": "Return Comparison",
    "investment.label.cumulative_return": "Cumulative Return",
    "investment.stats.max_return": "Max Return",
    "investment.stats.max_drawdown": "Max Drawdown",
    "investment.tooltip.invested": "Invested",
    "investment.tooltip.current_value": "Current Value",
    "investment.tooltip.return": "Return",
    "investment.legend.my_return": "My Return",
    "investment.chart.period_profit": "Period P/L",
    "investment.period_chart.segment": "This period",
    "investment.period_chart.segment_max_profit": "Best segment",
    "investment.period_chart.segment_max_loss": "Worst segment",
    "investment.period_chart.month_max_profit": "Best month",
    "investment.period_chart.month_max_loss": "Worst month",
    "investment.period_chart.total_formula": "Total P/L = sum of each segment",
    "investment.period_chart.net_flow_desc": "Capital in/out from buys and sells in this segment - not market profit.",
    "investment.period_chart.return_desc": "Market P/L for this segment after excluding capital flows.",
    "investment.tooltip.net_flow": "Net Flow",
    "investment.tooltip.investment_return": "Investment Return",
    "investment.stats.total_return": "Total Return",
    "investment.stats.max_profit": "Max Profit",
    "investment.stats.max_loss": "Max Loss",
    "investment.action.show_investment_only": "Show Investment P/L Only",

    // Ledger
    "ledger.title": "Ledgers",
    "ledger.balance.monthly": "Monthly Balance",
    
    // Import Review
    "import.review.title": "Review Transaction",
    "import.review.desc": "Confirm AI parsed details",
    "import.review.desc_merchant": "Desc / Merchant",
    "import.review.amount": "Amount",
    "import.review.date": "Date",
    "import.review.category": "Category",
    "import.review.category_placeholder": "Select Category",
    "import.review.account": "Account",
    "import.review.account_placeholder": "Select Account",
    "import.review.ai_suggestion": "AI Suggestion",
    "import.review.confirm": "Add to Ledger",
    "import.review.delete": "Delete",
    "import.review.toast.confirmed": "Confirmed",
    "import.review.toast.added": "Added to ledger",
    "import.review.toast.deleted": "Deleted",
    "import.review.toast.removed": "Transaction removed",
    "import.review.pending_title": "Pending Review ({count})",
    "import.review.pending_desc": "Confirm AI parsed transactions",
    "import.review.group": "Transfer Group ({count}) - Process Together",
    "import.review.duplicate": "Duplicate Detected",
    "import.review.confirm_all": "Confirm All ({count})",
    "import.review.confirm_single": "Confirm Add",
    "import.review.reject_all": "Delete All",
    "import.review.reject_single": "Delete",
    "import.review.toast.group_confirmed": "{count} related transactions added",
    "import.review.toast.group_rejected": "Related transactions ignored",
    "import.review.toast.failed": "Failed",
    "import.review.toast.delete_failed": "Delete Failed",
    "import.review.original_text": "Original Text",

    // AI Text Import
    "ai.paste.title": "AI Smart Import",
    "ai.paste.desc": "Paste text, AI detects date & amount",
    "ai.paste.placeholder": "e.g., Lunch at McDonald's $149 yesterday",
    "ai.paste.example": "Examples:",
    "ai.paste.example.lunch": "Lunch $149",
    "ai.paste.example.phone": "Phone Bill",
    "ai.paste.analyze": "Analyze",
    "ai.paste.analyzing": "Analyzing...",
    "ai.paste.cancel": "Cancel",
    "ai.paste.success": "Analysis Complete",
    "ai.paste.success_desc": "Added to pending items",
    "ai.paste.fail": "Analysis Failed",
    "ai.paste.fail_desc": "Please check connection and retry",
    
    "ledger.ai.smart_import": "Smart Import",
    "ledger.ai.new_records_found": "New Records",
    "ledger.ai.pending_count": "Pending",
    "ledger.ai.pending_capsule": "Pending",
    "fab.create.mode_hint": "Swipe left or right to switch Entry, Transfer, or Loan",
    "fab.create.mode.entry": "Entry",
    "fab.create.mode.transfer": "Transfer",
    "fab.create.mode.loan": "Loan",
    "ledger.filter.active": "Filtering:",
    "ledger.filter.system": "Monthly stats",
    "ledger.filter.monthly_stats_only": "Monthly stats",
    "ledger.filter.all_entries": "All entries",
    "ledger.empty.title": "No Transactions",
    "ledger.empty.desc": "Tap the button below to add your first entry",
    "ledger.section.pending_list": "Pending list",
    "ledger.section.entries": "Ledger",
    "ledger.empty.day_today_title": "Nothing logged today!",
    "ledger.empty.day_title": "No transactions this day",
    "ledger.empty.day_today_desc": "Log today's spending ✨",
    "ledger.empty.day_desc": "Enjoy a no-spend day 📝",
    "ledger.empty.day_add": "Add entry",
    "budget.status.budget_exhausted": "Budget Exhausted",
    "tasks.title": "Tasks",
    "tasks.add": "Add",
    "tasks.add_dialog": "New Task",
    "tasks.edit_dialog": "Edit Task",
    "tasks.delete_confirm": "Delete this task?",
    "tasks.title_placeholder": "Task title…",
    "tasks.recurrence": "Repeat",
    "tasks.recurrence.once": "One-time",
    "tasks.recurrence.daily": "Daily",
    "tasks.recurrence.weekly": "Weekly",
    "tasks.recurrence.monthly": "Monthly",
    "tasks.recurrence.yearly": "Yearly",
    "tasks.recurrence.none": "None",
    "tasks.recurrence.weekly_on": "Every {day}",
    "tasks.recurrence.monthly_on": "Monthly on {day}",
    "tasks.recurrence.yearly_on": "Yearly on {month}/{day}",
    "tasks.notify.enable": "Reminder",
    "tasks.notify.at": "Notify at {time}",
    "tasks.notify.time": "Notify time",
    "tasks.auto_ledger": "Auto entry",
    "tasks.auto_ledger.configured": "Entry details set",
    "tasks.auto_ledger.configure": "Set entry details",
    "tasks.auto_ledger.split": "(split)",
    "tasks.auto_ledger.skip_confirm": "Skip confirm — save directly",
    "tasks.auto_ledger.setup": "Set details...",
    "tasks.save": "Save changes",
    "tasks.create": "Add task",
    "tasks.empty": "No tasks yet",
    "tasks.badge.repeat": "Repeat",
    "tasks.badge.auto": "Auto",
    "tasks.badge.ledger": "Entry",
    "tasks.weekday.0": "Sun",
    "tasks.weekday.1": "Mon",
    "tasks.weekday.2": "Tue",
    "tasks.weekday.3": "Wed",
    "tasks.weekday.4": "Thu",
    "tasks.weekday.5": "Fri",
    "tasks.weekday.6": "Sat",
    "tasks.create_failed": "Couldn't create",
    "tasks.update_failed": "Couldn't update",
    "tasks.auto_failed": "Auto entry failed",
    "tasks.title_required": "Please enter a title",
    "tasks.uncomplete_confirm": "Mark this task as incomplete?",
    "tasks.notify_title": "Task reminder",
    "tasks.swipe_delete_confirm": "Delete this task?",
    "ledger.badge.duplicate": "Duplicate?",
    "ledger.badge.check": "Check Req.",
    "ledger.pending.category": "Pending Review",
    "ledger.pending.account": "Pending Account",
    
    // Voice
    "voice.title": "Voice Entry",
    "voice.mic.hold": "Press & Hold",
    "voice.mic.release": "Release",
    "voice.status.listening": "Listening...",
    "voice.status.processing": "Thinking...",
    "voice.status.heard": "Got it...",
    "voice.status.prompt_native": "Go ahead...",
    "voice.status.prompt_web": "Go ahead",
    "voice.action.retry": "Retry",
    "voice.action.analyze": "Done",
    "voice.error.no_speech": "Didn't catch that",
    "voice.error.no_speech.desc": "Check your mic and try again",
    "voice.error.parse_failed": "Failed to analyze",
    "voice.error.ai_unclear": "Could not understand, please try again",
    "voice.error.login_required": "Please login first",
    "voice.error.permission": "Permission Needed",
    "voice.error.permission.desc": "Please allow microphone access",
    "voice.error.unsupported": "Not Supported",
    "voice.error.unsupported.desc": "Your browser does not support voice input",


    "common.loading": "Loading...",
    "common.success": "Success",
    "common.others": "Others",
    "common.all": "All",
    "common.view": "View",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.cancel": "Cancel",
    "common.delete_confirm_title": "Delete \"{name}\"?",
    "common.delete_confirm_desc": "This can't be undone.",
    "common.delete_confirm_action": "Delete",
    "common.confirm": "Confirm",
    "common.edit": "Edit",
    "common.back": "Back",
    "common.next": "Next",
    "common.done": "Done",
    "common.processing": "Processing...",
    "common.updating": "Updating...",
    "common.confirm_selection": "Confirm",
    "common.back_edit": "Back to Edit",

    // Budget Status Dialog
    "budget.status.title": "Monthly Budget",
    "budget.status.total_available": "Total Available",
    "budget.status.remaining": "Remaining",
    "budget.status.expenses": "Expenses",
    "budget.status.daily_avg": "Daily Avg",
    "budget.status.view_daily_gross": "Daily (Gross)",
    "budget.status.view_daily_net": "Daily (Net)",
    "budget.status.view_weekly_gross": "Weekly (Gross)",
    "budget.status.view_weekly_net": "Weekly (Net)",
    "budget.status.spendable_remaining": "Spendable Remaining",
    "budget.status.net_spendable": "Net Spendable",
    "budget.status.title_current": "Monthly Budget Status",
    "budget.status.title_history": "History Budget Summary",
    "budget.status.remaining_label_current": "Total Remaining",
    "budget.status.remaining_label_history": "Final Balance",
    "budget.status.days_remaining": "{count} days left",
    "budget.status.settled": "Settled",
    "budget.status.overview": "Monthly Overview",
    "budget.status.used": "Used",
    "budget.status.spendable": "Spendable",
    "budget.status.total": "Total",
    "budget.legend.budget": "Budget",
    "budget.legend.savings": "Savings",
    "budget.mode.suggestion": "Suggestion Mode",
    "budget.mode.toggle_display": "Toggle view",
    "budget.mode.spendable_only": "Budget only",
    "budget.unit.day": "/Day",
    "budget.unit.week": "/Week",
    "budget.status.final_balance": "Final Balance",
    "budget.status.goal_rate": "Goal Achievement",
    "budget.status.over_budget": "Over Budget",
    "budget.status.no_budget": "No Budget",
    "budget.status.no_savings_goal": "No goal",
    "budget.status.diff": "Short by NT$ {amount}",
    "budget.status.view_transactions": "View ledger details",
    "budget.status.view_transactions_hint": "Jump to all {category} transactions this month",
    "budget.status.details_short": "Details",
    "budget.list.title": "Category Progress",
    "budget.category.fixed": "Fixed",
    "budget.category.living": "Living",
    "budget.category.jars": "Jars",
    "common.no_items": "No items",

    // Income/Expense Detail Dialog
    "ledger.dashboard.income": "Income",
    "ledger.dashboard.expense": "Expense",
    "ledger.dialog.month_income": "Monthly Income",
    "ledger.dialog.month_expense": "Monthly Expenses",
    "ledger.dialog.total_month": "Monthly Total",
    "ledger.dialog.total_3m": "Last 3 Months Total",
    "ledger.dialog.total_6m": "Last 6 Months Total",
    "ledger.dialog.total_1y": "Last Year Total",
    "ledger.dialog.total_max": "Last 24 Months Total",
    "ledger.dialog.trend": "Trend",
    "ledger.dialog.categories": "Categories",
    "ledger.dialog.accounts": "Accounts",
    "ledger.dialog.time_range": "Time Range",
    "ledger.dialog.category_stats": "Category Statistics",
    "ledger.dialog.category_filter_hint": "Tap a category for trend",
    "ledger.dialog.filtered_trend": "{category} this month",
    "ledger.dialog.filtered_range_total": "{category} · {range}",
    "ledger.dialog.clear_category_filter": "Show all",
    "ledger.dialog.no_record_income": "No income records",
    "ledger.dialog.no_record_expense": "No expense records",
    "ledger.dialog.start_tracking": "Start tracking now!",
    "common.count_suffix": " records",

    "budget.display.living_budget": "Living Budget",
    "budget.display.monthly_budget": "Monthly Budget",
    "budget.display.disposable_budget": "Disposable Budget",
    "budget.display.fixed_living": "Fixed Exp. + Living",
    "budget.display.final_balance": "Final Balance",
    "budget.display.available": "Available",
    "budget.display.unconfigured": "Not configured",
    "budget.display.from_group": "Budget from group \"{group}\"",
    "budget.display.group_usage": "Group used {used} / {total}",
    "budget.display.no_category_budget": "No budget configured for this category",
    "budget.action.switch_view": "Switch View",
    "budget.action.click_restore": "Click to Restore",
    "budget.legend.target_savings": "Target Savings",
    "budget.legend.savings_investment": "Save / Invest",
    "budget.chart.expense_distribution": "Expense Distribution",
    "budget.chart.income_distribution": "Income Distribution",
    "common.total_income": "Total Income",
    "common.total_expense": "Total Expense",
    "common.no_data": "No Data",
    "common.try_again_later": "Please try again later",

    // Dialogs - Add Entry
    "dialog.add_entry": "Add Transaction",
    "dialog.add_entry.desc": "Enter amount, category and date to add a new record.",
    "common.expense": "Expense",
    "common.income": "Income",
    "entry.delete.tooltip": "Delete Transaction",
    "entry.delete.title": "Delete this transaction?",
    "entry.delete.irreversible": "This can't be undone. Delete anyway?",
    "entry.delete.confirm": "Delete",
    "entry.delete.failed": "Delete failed",
    "entry.delete.scope.title": "How should this be deleted?",
    "entry.delete.scope.desc": "Choose a delete scope. This can't be undone.",
    "entry.delete.scope.with_loan_theme": "Txn + loan theme",
    "entry.delete.scope.all_related": "All loan-related",
    "entry.delete.package_title": "Delete this loan transfer?",
    "entry.delete.package_desc": "This also removes the loan theme and all related repayment/collection transfers. This can't be undone.",
    "entry.delete.package_continue": "Continue",
    "entry.delete.package_confirm_title": "Confirm impact",
    "entry.delete.package_confirm_desc": "Related balances will be reverted and net worth may change. This can't be undone.",
    "entry.delete.package_balance_warning": "This deletes ledger records and rolls back balances — it does not only stop loan tracking.",
    "entry.delete.package_balance_note": "Related balances will be reverted.",
    "entry.delete.package_related_count": "Also deletes {count} related repayment/collection transfer(s)",
    "entry.delete.package_remaining_lent": "{amount} still unrecovered",
    "entry.delete.package_remaining_borrowed": "{amount} still unpaid",
    "entry.delete.package_nw_unchanged": "This loan is cleared — net worth is expected to stay the same.",
    "entry.delete.package_nw_increase": "Net worth is expected to rise by about {amount} (outstanding deduction removed).",
    "entry.delete.package_nw_stable": "If both linked accounts count toward assets, net worth should stay roughly the same.",
    "entry.delete.package_confirm": "Delete",
    "entry.delete.warning.loan_item": "The linked loan item will also be deleted.",
    "entry.delete.warning.repayment": "The linked repayment will be deleted and the remaining balance updated.",
    "entry.split.title": "Split Bill",
    "entry.split.subtitle": "Assign who covers this amount",
    "entry.split.toggle_hint_advance": "Advance account — set up a split",
    "entry.split.toggle_title": "Split Bill",
    "entry.split.partner_default": "Partner",
    "entry.split.me": "Me",
    "entry.split.advance_badge": "Paid first",
    "entry.split.account_advance_fallback": "Advance account",
    "entry.split.account_unselected": "No account selected",
    "entry.split.my_portion": "My share",
    "entry.split.partner_portion": "{name}'s share",
    "entry.split.self_absorb": "Self absorb",
    "entry.split.partner_absorb": "Partner absorb",
    "entry.split.targets_section": "Split with",
    "entry.split.my_share": "My share",
    "entry.split.partner_account": "Partner account",
    "entry.split.summary.partner_bears": "{name} covers: {amount}",
    "entry.split.summary.partner_share": "{name}'s share: {amount}",
    "entry.split.summary.self_absorb": "I absorb: {amount}",
    "entry.split.summary.joined": "{parts}",
    "entry.split.summary.partner_bears_self_absorb": "{name} covers: {partner} | I absorb: {self}{loan}",
    "entry.split.summary.partner_share_self_absorb": "{name}'s share: {partner} | I absorb: {self}{loan}",
    "entry.split.link_partner.title": "Link partner: {name}",
    "entry.split.link_partner.desc": "Pick the real account for this split partner",
    "entry.split.link_partner.action": "Link partner",
    "entry.split.add.title": "Choose split partner",
    "entry.split.add.desc": "Pick who shares this expense",
    "entry.split.add.action": "Add partner",
    "entry.split.add.disabled_public_wallet": "Shared wallets can't use split",
    "entry.split.remove.locked": "Required partner — can't remove",
    "entry.split.remove.action": "Remove partner",
    "entry.split.stats.include_mine": "Count in my monthly spend",
    "entry.split.stats.exclude_mine": "Exclude from my monthly spend",
    "entry.split.stats.advance_included": "Partner advance counted in my spend",
    "entry.split.stats.advance_excluded": "Partner advance excluded from my spend",
    "entry.split.mode.equal": "Equal",
    "entry.split.mode.other_pays": "They pay all",
    "entry.split.mode.self_pays": "I pay all",
    "entry.split.mode.unlinked_advance_hint": "Unlinked advance allows I-pay-all only; amount is the full advance consumption",
    "entry.split.mode.custom": "Custom",
    "entry.split.over_limit": "Split total {splitTotal} exceeds the bill {mainTotal}. Adjust shares or change the total.",
    "entry.split.over_limit_btn": "Split exceeds total",
    "entry.split.confirm": "Save split",
    "entry.split.loan.select_title": "Link a loan",
    "entry.split.loan.no_link": "Don't link",
    "entry.split.loan.no_link_desc": "Split only — no loan sync",
    "entry.split.loan.remaining": "Left {amount}",
    "entry.split.loan.link": "Linked loan",
    "entry.split.loan.link_optional": "Link loan (optional)",
    "entry.split.loan.summary": " | Loan: {title}",
    "entry.split.loan.clear": "Clear link",
    "entry.split.loan.clear_locked": "Loan link is locked",
    "entry.split.category_locked_full": "No personal expense share — category locked to Transfer",
    "entry.split.category_unlock_hint": "Adjust your share to change category",
    "entry.split.switch_account_hint": "Pick one of my accounts",
    "entry.split.error.income_advance_title": "Income can't use an advance split account",
    "entry.split.error.income_advance_desc": "Switch to one of my accounts, then save",
    "entry.split.error.missing_targets_title": "Split setup incomplete",
    "entry.split.error.missing_targets_desc": "Advance accounts need a split partner (not only yourself)",
    "entry.split.saved_loan_sync_failed_title": "Split saved",
    "entry.split.saved_loan_sync_failed_desc": "Loan link didn't finish — you can edit later",
    "entry.split.with_count": "Split with {count}",
    "entry.split.with_name": "Split with {name}",
    "entry.split.partner_placeholder": "Split partner",
    "entry.loading.title": "Preparing transaction…",
    "entry.loading.prefill_account": "Loading the correct payer account…",
    "entry.loading.sync_categories": "Syncing categories…",
    "entry.validation.select_category": "Please select a category",
    "entry.validation.select_account": "Please select an account",
    "entry.validation.enter_amount": "Please enter an amount",
    "entry.validation.fixed_loading_title": "Loading fixed expenses…",
    "entry.validation.fixed_loading_desc": "Please wait, then save again",
    "entry.save.success": "Saved",
    "entry.save.updated": "Updated",
    "entry.save.created": "Created",
    "entry.save.failed_update": "Update failed",
    "entry.save.failed_create": "Create failed",
    "entry.save.recorded": "Logged {category} {amount}",
    "entry.account.empty_title": "No accounts yet",
    "entry.account.empty_desc": "Create an account to continue",
    "entry.account.empty_action": "Create account",
    "entry.jar.create_prompt": "Can't find your jar?",
    "entry.jar.create_desc": "Leave this page to create a savings jar",
    "entry.fixed.budget_label": "Budget: {amount}",
    "entry.fixed.create_prompt": "Can't find the fixed expense?",
    "entry.fixed.create_desc": "Leave this page to create a fixed expense",
    "ledger.badge.holding": "Holding",
    "ledger.badge.no_account": "No account",
    "ledger.badge.pending_action": "Action needed",
    "ledger.balance.adjust_note_again": "Adjust account balance again",
    "ledger.tasks.toggle": "Tasks",
    "ledger.account.unknown": "Unknown account",
    "ledger.account.unnamed": "Unnamed account",
    "ledger.edit.not_found": "No editable entry found",
    "ledger.edit.open_linked_failed": "Couldn't open linked entry",
    "ledger.convert.failed": "Conversion failed",
    "ledger.convert.missing_data": "Missing required conversion data",
    "ledger.convert.missing_fields": "Missing fields: {fields}",
    "ledger.special_choice.title": "Choose how to proceed",
    "ledger.special_choice.desc": "Pick a real account or convert to an expense",
    "ledger.special_choice.pick_account": "Choose receiving account",
    "ledger.special_choice.convert_expense": "Convert to expense",
    "ledger.special_choice.lend_land_fail_title": "Couldn't open borrow landing",
    "ledger.special_choice.lend_land_fail_desc": "Couldn't find the borrow mirror theme. Pull to refresh loans and try again; if it's still missing, the lend create didn't create the counterpart theme.",
    "loan.toast.mirror_recipient_missing": "Couldn't create the counterpart loan mirror. Check the linked partner and try again.",
    "entry.manage_categories": "Manage Categories",
    "entry.all": "All",
    "entry.calc_result": "Result",
    "entry.confirm": "Confirm",
    "entry.date_select": "Select Date",
    "entry.exclude_stats": "Exclude from Stats",
    "entry.include_stats": "Include in Stats",
    "entry.convert.title": "Currency Conversion",
    "entry.convert.desc": "Converted amount from {from} to {to}",
    "entry.full_note": "Full Note",
    "entry.expand_note": "Expand Note",
    "entry.note": "Note",
    "entry.note_details": "Enter note details...",
    "entry.select_account": "Select Account",
    "entry.savings_jar": "Savings Jar",
    "entry.fixed_expense": "Fixed Expense",
    "entry.account.title": "Select Account",
    "entry.account.desc": "Select account for transaction",
    "entry.account.search_placeholder": "Search account...",
    "entry.account.empty": "No accounts added yet",
    "entry.jar.title": "Select Savings Jar",
    "entry.jar.desc": "Select funding source",
    "entry.jar.search_placeholder": "Search savings jar...",
    "entry.jar.no_selection": "No Savings Jar",
    "entry.jar.no_selection_desc": "General Account Expense",
    "entry.account.suggested_title": "Suggested accounts",
    "entry.account.suggested_badge": "Suggested",
    "entry.account.suggested_for": "Selected \"{name}\" · suggested accounts",
    "entry.jar.suggested_badge": "Suggested",
    "entry.jar.suggested_for": "Selected \"{name}\" · suggested jars",
    "entry.fixed.title": "Fixed Expense",
    "entry.fixed.desc": "Select fixed expense item",
    "entry.fixed.search_placeholder": "Search fixed expense...",
    "entry.fixed.no_selection": "Unspecified Fixed Expense",

    // Transfer
    "transfer.title": "Transfer",
    "transfer.edit_title": "Edit Transfer",
    "transfer.from": "From Account",
    "transfer.domain.daily": "Daily",
    "transfer.domain.daily.desc": "Move money between bank, cash, FX, and cards",
    "transfer.domain.shared": "Shared",
    "transfer.domain.shared.desc": "Fund the shared wallet, or settle with someone",
    "transfer.intent.pool": "Shared wallet",
    "transfer.intent.pool.desc": "Move money into or out of a shared wallet",
    "transfer.intent.collect": "Collect",
    "transfer.intent.collect.desc": "They pay you back",
    "transfer.intent.repay": "Repay",
    "transfer.intent.repay.desc": "You pay them back",
    "transfer.kind.normal": "Transfer",
    "transfer.kind.lend": "Lend",
    "transfer.kind.borrow": "Borrow",
    "transfer.kind.repay": "Repay",
    "transfer.kind.collect": "Collect",
    "transfer.detail.normal": "Move money between your everyday accounts-bank transfers, cash deposits, FX, or paying a credit card. Optionally count as monthly expense or income (one only); off by default.",
    "transfer.detail.lend": "First time lending to someone. From: bank or card; To: their advance account. Counting as monthly expense will show in this month's spending.",
    "transfer.detail.borrow": "First time borrowing from someone. From: their advance account; To: bank or card (e.g. to pay a card). Counting as monthly income adds it to this month's income.",
    "transfer.detail.repay": "You repay what you owe. From: your everyday account; To: an advance or shared account. Optionally count as monthly expense.",
    "transfer.detail.collect": "They repay what they owe you. From: their advance account; To: your everyday account. Optionally count as monthly income.",
    "transfer.detail.pool": "Move money between your everyday account and a shared wallet: one side must be shared, the other personal. Two shared wallets cannot transfer to each other. Optionally count as monthly expense or income (one only); off by default.",
    "transfer.count_monthly_expense": "Count as expense",
    "transfer.count_monthly_income": "Count as income",
    "transfer.info.open": "Show info",
    "transfer.info.close": "Close info",
    "transfer.loan.link": "Link loan",
    "transfer.loan.link_optional": "Link loan (optional)",
    "transfer.loan.none": "Don't link",
    "transfer.loan.none_desc": "Transfer only - no loan link",
    "transfer.loan.pick_title": "Choose a loan theme",
    "transfer.loan.remaining": "Left NT$ {amount}",
    "transfer.loan.prefix": "Loan: {title}",
    "transfer.loan.clear": "Clear link",
    "transfer.loan.locked_clear": "Loan theme is locked and can't be cleared",
    "transfer.label.transferor": "From person",
    "transfer.label.payer_account": "Paying account",
    "transfer.label.collect_account": "Receiving account",
    "transfer.label.recipient": "To",
    "transfer.label.advance_account": "Advance account",
    "transfer.label.repay_account": "Repayment account",
    "transfer.label.via_advance": "Via advance",
    "transfer.member_fallback": "Member",
    "transfer.pick_from": "Select from account",
    "transfer.pick_from_first": "Select from account first",
    "transfer.swap_accounts": "Swap from and to accounts",
    "transfer.fee_readonly_hint": "Fee is set by the payer (view only)",
    "transfer.fee_readonly_unlinked_hint": "Unlinked members cannot cover a transfer fee",
    "transfer.mismatch.both": "From and to accounts don't match \"{kind}\". Please reselect.",
    "transfer.mismatch.from": "From account doesn't match \"{kind}\". Please reselect.",
    "transfer.mismatch.to": "To account doesn't match \"{kind}\". Please reselect.",
    "transfer.success_title": "Transfer successful",
    "transfer.to": "To Account",
    "transfer.amount": "Amount",
    "transfer.fee": "Fee",
    "transfer.date": "Date",
    "transfer.note": "Note",
    "transfer.submit": "Transfer",
    "transfer.confirm_transfer": "Confirm Transfer",

    // Loans
    "loans.page.title": "Loans",
    "loans.action.add": "Add loan",
    "loans.empty.title": "No loans yet",
    "loans.empty.desc": "Create a split account first, or tap Add loan in the top right.",
    "loans.empty.cta": "Create first loan",
    "loans.empty.no_themes": "No loan themes for this person yet - showing advance account balances only.",
    "loans.empty.no_lent": "No lend records yet",
    "loans.empty.no_borrowed": "No borrow records yet",
    "loans.list.title": "All loans",
    "loans.list.all_borrowings": "All borrowings",
    "loans.overview.title": "Loan overview",
    "loans.overview.calc_hint": "Based on advance account balances (tap to see breakdown)",
    "loans.net.they_owe": "To collect",
    "loans.net.you_owe": "To pay",
    "loans.net.even": "Even",
    "loans.registered.lent": "Registered lent",
    "loans.registered.borrowed": "Registered borrowed",
    "loans.theme_count": "{count} themes",
    "loans.account_count": "{count} accounts",
    "loans.person.even": "Settled",
    "loans.person.they_owe": "They owe",
    "loans.person.you_owe": "You owe",
    "loans.unallocated.hint": "Not assigned to a loan theme",
    "loans.cleared_count": "{count} cleared",
    "loans.hidden_count": "{count} hidden",
    "loans.composition.subtitle": "Balances and accounts by person",
    "loans.composition.empty": "No advance accounts to calculate.",
    "loans.composition.total": "Total",
    "loans.composition.title_person": "{person}'s accounts",
    "loans.composition.title_overview": "Loan overview breakdown",
    "loans.composition.net_position": "Net position",
    "loans.composition.breakdown": "Loan details",
    "loans.composition.lent": "They owe you",
    "loans.composition.borrowed": "You owe them",
    "loans.composition.account_count": "{count} accounts",
    "loans.composition.person_net": "Subtotal",
    "loans.settings.label": "Loans",
    "loans.settings.desc": "Borrow & repay tracking",
    "loan.status.recovered": "Recovered",
    "loan.status.cleared": "Cleared",
    "loan.status.active": "Active",
    "loan.status.hidden": "Hidden",
    "loan.badge.deducted": "Deducted",
    "loan.badge.not_deducted": "Not deducted",
    "loan.badge.included": "In assets",
    "loan.badge.not_included": "Off assets",
    "loan.badge.deduct_short": "Deduct",
    "loan.badge.include_short": "Include",
    "loan.badge.initial_transfer": "Initial transfer",
    "loan.badge.receipt": "Collect",
    "loan.direction.lent_to": "Lent to",
    "loan.direction.borrowed_from": "Borrowed from",
    "loan.original_amount": "Original {amount}",
    "loan.linked_account": "Linked: {name}",
    "loan.mode.lend": "Lend",
    "loan.mode.borrow": "Borrow",
    "loan.dialog.edit_title": "Edit loan",
    "loan.dialog.create_title": "New loan",
    "loan.action.save_changes": "Save changes",
    "loan.action.create_lend": "Create lend",
    "loan.action.create_borrow": "Create borrow",
    "loan.action.saving": "Saving…",
    "loan.action.creating": "Creating…",
    "loan.action.create_now": "Create now",
    "loan.action.quick_create_split": "Missing someone? Create a split account →",
    "loan.action.allocate": "Assign to this loan",
    "loan.action.register_receipt": "Record collection",
    "loan.action.register_repayment": "Record repayment",
    "loan.action.go_edit": "Edit",
    "loan.action.edit": "Edit",
    "loan.swipe.edit": "Edit",
    "loan.swipe.hide": "Hide",
    "loan.swipe.delete": "Delete",
    "loan.field.counterparty": "Counterparty",
    "loan.field.linked_advance": "Linked advance account",
    "loan.field.title": "Loan theme",
    "loan.field.title_placeholder": "e.g. Flight, lunch money",
    "loan.field.note": "Note (optional)",
    "loan.field.note_placeholder": "Extra details (optional)",
    "loan.field.receipt_account": "Receiving account",
    "loan.field.payment_account": "Paying account",
    "loan.select.counterparty": "Select counterparty",
    "loan.select.linked_advance": "Select linked advance account",
    "loan.select.linked_account": "Select linked account",
    "loan.select.receipt_account": "Select receiving account",
    "loan.select.payment_account": "Select paying account",
    "loan.select.cash_out_account": "Select lending account",
    "loan.select.receipt_account.desc": "Cash account that receives the money",
    "loan.select.payment_account.desc": "Cash account that pays",
    "loan.select.cash_out_account.desc": "Account the funds leave from",
    "loan.select.linked_advance.for_person": "Linked advance for \"{name}\"",
    "loan.select.linked_advance.desc": "Tracks the balance between you",
    "loan.hint.select_counterparty_first": "Select a counterparty first",
    "loan.empty.no_counterparties": "No counterparties yet",
    "loan.empty.no_advance_for_person": "No advance account for this person",
    "loan.empty.receipt_accounts": "No receiving accounts available",
    "loan.empty.payment_accounts": "No paying accounts available",
    "loan.empty.receipts": "No collections yet",
    "loan.empty.repayments": "No repayments yet",
    "loan.person.unlinked": "Not linked to a member",
    "loan.person.advance_count": "{count} advance accounts",
    "loan.section.standalone_advance": "Standalone advance accounts",
    "loan.section.origin": "Loan origin",
    "loan.section.origin_hint": "Where the principal moved",
    "loan.section.receipts": "Collections",
    "loan.section.repayments": "Repayments",
    "loan.section.settlement_hint_receipts": "Newest first",
    "loan.section.settlement_hint_repayments": "Newest first",
    "loan.account.selected": "Selected account",
    "loan.account.advance_fallback": "Advance account",
    "loan.option.deduct_networth": "Deduct from net worth",
    "loan.option.include_networth": "Include in net worth",
    "loan.option.count_monthly_expense": "Count as expense",
    "loan.option.count_monthly_income": "Count as income",
    "loan.networth.disabled_hint": "This linked account is off assets - no extra deduction needed",
    "loan.fee.readonly_hint": "Fee is set by the payer (view only)",
    "loan.fee.readonly_unlinked_hint": "Unlinked members cannot cover a transfer fee",
    "loan.progress.recovered": "Recovered",
    "loan.progress.repaid": "Repaid",
    "loan.progress.pending_recover": "To recover",
    "loan.progress.outstanding": "Outstanding",
    "loan.progress.footer": "Original {amount} · {pct}% {verb}",
    "loan.unallocated.banner": "{name} has {count} unassigned payment(s)",
    "loan.transfer.from_out": "Out from {name}",
    "loan.transfer.from_in": "In from {name}",
    "loan.initial_transfer": "Initial transfer when the loan was created",
    "loan.preview.title": "Transaction detail",
    "loan.preview.date": "Date: {date}",
    "loan.preview.note": "Note: {note}",
    "loan.preview.empty": "No ledger lines to show for this transaction.",
    "loan.delete.title": "Delete loan?",
    "loan.delete.desc": "Choose whether to also delete related transactions.",
    "loan.delete.keep_tx": "Delete theme only, keep transactions",
    "loan.delete.with_tx": "Delete loan and related transactions",
    "loan.delete.package_title": "Delete entire loan package?",
    "loan.delete.package_desc": "This removes the loan theme, the origin transfer, and all repayment/collection transfers. This can't be undone.",
    "loan.delete.package_continue": "Continue",
    "loan.delete.package_confirm_title": "Confirm impact",
    "loan.delete.package_confirm_desc": "Related account balances will be reverted, so net worth may change noticeably.",
    "loan.delete.package_balance_warning": "This deletes ledger records and rolls back balances — it is not just removing the loan from the list. Confirm you want this loan history treated as if it never happened.",
    "loan.delete.package_balance_note": "Related account balances will be reverted.",
    "loan.delete.package_remaining_lent": "{amount} still unrecovered",
    "loan.delete.package_remaining_borrowed": "{amount} still unpaid",
    "loan.delete.package_nw_unchanged": "This loan is cleared — net worth is expected to stay the same.",
    "loan.delete.package_nw_increase": "Net worth is expected to rise by about {amount} (outstanding deduction removed).",
    "loan.delete.package_nw_stable": "If both linked accounts count toward assets, net worth should stay roughly the same.",
    "loan.delete.package_repayments_count": "Also deletes {count} repayment record(s)",
    "loan.delete.package_receipts_count": "Also deletes {count} collection record(s)",
    "loan.delete.package_confirm": "Delete",
    "loan.hide.title": "Hide this loan?",
    "loan.hide.desc": "It leaves the active list, but ledger records stay. You can find it again under Hidden.",
    "loan.action.hide": "Hide",
    "loan.action.unhide": "Unhide",
    "loan.action.delete": "Delete",
    "loan.toast.edit_origin_missing": "Couldn't find the origin transfer to edit",
    "loan.delete.repayment_title": "Delete repayment?",
    "loan.delete.receipt_title": "Delete collection?",
    "loan.delete.repayment_desc": "This can't be undone.",
    "loan.delete.repayment_warning": "The linked ledger transfer will also be deleted, and the remaining balance updated.",
    "loan.delete.receipt_warning": "The linked ledger transfer will also be deleted, and the remaining balance updated.",
    "common.unnamed_account": "Unnamed account",
    "common.no_note": "No note",
    "common.collapse": "Collapse",
    "common.expand": "Expand",
    "common.expand_full": "Show full",
    "loan.toast.select_counterparty": "Select a counterparty",
    "loan.toast.select_title": "Enter a loan theme",
    "loan.toast.select_account": "Select an account",
    "loan.toast.select_amount": "Enter an amount",
    "loan.toast.select_receipt": "Select a receiving account",
    "loan.toast.select_payment": "Select a paying account",
    "loan.toast.transfer_group_missing": "Transfer group not found - can't update",
    "loan.toast.update_ok": "Updated",
    "loan.toast.lend_created": "Lend created",
    "loan.toast.borrow_created": "Borrow created ✓",
    "loan.toast.operation_failed": "Something went wrong. Try again.",
    "loan.toast.deleted_keep_tx": "Loan theme deleted (transactions kept)",
    "loan.toast.deleted_with_tx": "Loan and related transactions deleted",
    "loan.toast.hidden": "Loan theme hidden",
    "loan.toast.unhidden": "Loan theme unhidden",
    "loan.toast.allocated": "Assigned as repayment ✓",
    "loan.toast.allocate_failed": "Couldn't assign",
    "loan.toast.record_deleted": "Record deleted",
    "loan.toast.networth_on": "Now deducts from net worth",
    "loan.toast.networth_off": "No longer deducts from net worth",
    "loan.toast.networth_include_on": "Now included in net worth",
    "loan.toast.networth_include_off": "No longer included in net worth",
    "loan.summary.converted_expense": "Converted to {name} expense",
    "loan.summary.converted_income": "Converted to {name} income",
    "loan.summary.transferred_in": "Transferred into {name}",
    "loan.summary.transfer_adjust": "Transfer adjustment",
    "loan.summary.repayment": "Repayment",
    "loan.summary.receipt": "Collection",

    // Category Management
    "category.manage.title": "Category Management",
    "category.manage.desc": "Drag categories to groups to organize",
    "category.system.transfer": "Transfer",
    "category.system.transfer_normal": "Transfer",
    "category.system.fee": "Fee",
    "category.system.balance_adjustment": "Balance Adj.",
    "category.system.credit_card_payment": "Card Payment",
    "category.system.position_increase": "Position Increase",
    "category.system.position_decrease": "Position Decrease",
    "category.system.stock_buy": "Stock Buy",
    "category.system.stock_sell": "Stock Sell",
    "category.system.group": "System",
    "category.select.allocation_subtitle": "Choose categories or groups to allocate",
    "account.picker.empty_title": "No accounts available",
    "account.picker.empty_desc": "Create an account first to continue",
    "account.picker.no_partners": "No split partners",
    "account.picker.no_partners_desc": "Partners appear here when you're added to a split group",
    "account.picker.linked_partners": "Linked partners",
    "account.picker.advance_count": "{count} advance accounts",
    "account.detail.balance_after": "Balance",

    // Account Types
    "account.type.twd": "TWD",
    "account.type.usd": "USD",
    "account.type.jpy": "JPY",
    "account.type.custodian": "Custodian",
    "account.type.bank": "Bank",
    "account.type.cash": "Cash",
    "account.type.stock_tw": "TW Stock",
    "account.type.stock_us": "US Stock",
    "account.type.crypto": "Crypto",
    "account.type.real_estate": "Real Estate",
    "account.type.credit_card": "Credit Card",
    "account.type.virtual": "Joint Account",
    "account.type.custom": "Custom",
    "account.type.other": "Other",
    "category.other_expense": "Other Expenses",
    "category.type.expense": "Expense Categories",
    "category.type.income": "Income Categories",
    "category.add": "Add Category",
    "category.create_group": "Create Group",
    "category.edit_group": "Edit Group",
    "category.group_name": "Group Name",
    "category.group_color": "Group Color",
    "category.uncategorized": "Uncategorized",
    "category.empty.drag": "Drag here to add to group",
    "category.empty.list": "No {type} categories yet",
    "category.hidden.title": "Hidden Categories",
    "category.hidden.restore": "Restore",
    "category.hidden.restore_success": "Restore Successful",
    "category.hidden.restore_success_desc": "Category \"{name}\" restored",
    "category.hidden.restore_failed": "Restore Failed",
    "category.hidden.description": "These categories are hidden but history is kept",
    "category.hidden.empty": "No hidden categories",
    "category.hidden.records_count": "{count} records",
    "common.close": "Close",
    "category.dialog.title.add": "Add Category",
    "category.dialog.title.edit": "Edit Category",
    "category.dialog.name.label": "Category Name",
    "category.dialog.name.placeholder": "Category Name (e.g. Breakfast)",
    "category.dialog.type": "Type",
    "category.dialog.group": "Group (Optional)",
    "category.dialog.group.select": "Select Group",
    "category.dialog.color": "Color",
    "category.dialog.palette": "Palette",
    "category.dialog.fine_tune": "Fine Tune",
    "category.dialog.saturation": "Saturation",
    "category.dialog.lightness": "Lightness",
    "category.dialog.variants": "Variants",
    "category.dialog.icon": "Icon",
    "category.dialog.icon.all": "All",
    "category.dialog.icon.swipe_hint": "Swipe to select",
    "icon.category.transport": "Transport",
    "icon.category.food": "Food",
    "icon.category.shopping": "Shopping",
    "icon.category.housing": "Home",
    "icon.category.entertainment": "Fun",
    "icon.category.medical": "Health",
    "icon.category.work": "Work",
    "icon.category.finance": "Finance",
    "icon.category.comms": "Comms",
    "icon.category.education": "Education",
    "icon.category.social": "Social",
    "icon.category.animals": "Pets",
    "icon.category.services": "Services",
    "icon.category.festival": "Festive",
    "icon.category.nature": "Nature",
    "icon.category.other": "Other",
    "category.color.family.red": "Reds & Pinks",
    "category.color.family.orange": "Oranges & Yellows",
    "category.color.family.green": "Greens",
    "category.color.family.cyan": "Cyans",
    "category.color.family.blue": "Blues",
    "category.color.family.purple": "Purples",
    "category.color.family.gray": "Neutrals",
    "category.dialog.error.name_required": "Please enter category name",
    "category.dialog.error.name_conflict": "Name Conflict",
    "category.dialog.error.system_reserved": "\"{name}\" is a reserved system name",
    "category.dialog.error.budget_not_found": "Error: Budget data not found",
    "category.delete.title": "Delete Category",
    "category.hide.title": "Hide Category",
    "category.delete.confirm": "Are you sure you want to delete {name}?",
    "category.delete.warning": "This action cannot be undone and will permanently remove this category.",
    "category.hide.confirm": "{name} has {count} records",
    "category.hide.warning": "To preserve history, this category will be moved to 'Hidden Categories'.",
    "category.action.delete": "Confirm Delete",
    "category.action.hide": "Confirm Hide",
    "category.toast.update_success": "Category Updated",
    "category.toast.moved": "Moved {name} to group",

    // Category Groups & Defaults (EN)
    "category.group.food": "Food",
    "category.group.transport": "Transport",
    "category.group.shopping": "Shopping",
    "category.group.home": "Home",
    "category.group.entertainment": "Entertainment",
    "category.group.medical": "Medical",
    "category.group.life": "Life",
    "category.group.work": "Work",
    "category.group.investment": "Investment",
    "category.group.income": "Income",
    
    "category.default.food": "Food",
    "category.default.transport": "Transport",
    "category.default.shopping": "Shopping",
    "category.default.gift": "Gift",
    "category.default.home": "Home",
    "category.default.rent": "Rent",
    "category.default.utilities": "Utilities",
    "category.default.entertainment": "Games",
    "category.default.social": "Social",
    "category.default.travel": "Travel",
    "category.default.medical": "Medical",
    "category.default.insurance": "Insurance",
    "category.default.phone": "Phone",
    "category.default.education": "Education",
    "category.default.tax": "Tax",
    "category.default.salary": "Salary",
    "category.default.bonus": "Bonus",
    "category.default.red_envelope": "Red Envelope",
    "category.default.investment": "Investment",
    "category.default.savings": "Savings",
    "category.default.breakfast": "Breakfast",
    "category.default.lunch": "Lunch",
    "category.default.dinner": "Dinner",
  "category.default.drinks": "Drinks",
    "category.default.parking": "Parking",
    "category.default.gas": "Gas",
    "category.default.public_transport": "Public Transport",
    "category.default.interest": "Interest",
    "category.default.dividend": "Dividend",

    // Category Management Toasts & Logic (EN)
    "category.toast.db_upgraded": "Database Upgraded",
    "category.toast.db_upgraded_desc": "Integrated {count} old categories",
    "category.toast.checking_db": "Checking database...",
    "category.toast.sync_complete": "Sync Complete",
    "category.toast.sync_complete_desc": "Fixed {count} categories",
    "category.toast.no_update": "No Update Needed",
    "category.toast.no_update_desc": "Database is already up to date",
    "category.toast.sync_failed": "Sync Failed",
    "category.toast.delete_success": "Deleted Successfully",
    "category.toast.delete_success_desc": "Category \"{name}\" deleted",
    "category.toast.delete_failed": "Delete Failed",
    "category.toast.hidden_success": "Category Hidden",
    "category.toast.hidden_success_desc": "Category \"{name}\" hidden, kept {count} history records",
    "category.toast.update_success_generic": "Update Successful",
    "category.toast.update_success_desc": "Budget allocation updated",
    "category.toast.update_failed": "Update Failed",
    "category.toast.action_failed": "Action Failed",
    "category.toast.enter_group_name": "Please enter group name",
    "category.toast.group_updated": "Group Updated",
    "category.toast.group_created": "Group Created",
    "category.toast.group_deleted": "Group Deleted",
    "category.toast.save_failed": "Save Failed",
    "category.group.delete_confirm": "Are you sure you want to delete group \"{name}\"?\nCategories under it will become uncategorized.",
    "category.empty.no_available": "No categories available",
    "category.empty.hint": "Click \"Manage\" on top right to add categories",
    "category.empty.instruction": "Click \"Manage\" on top right to add categories",
    "category.manage": "Manage",
    "category.select_to_assign": "Select category to assign",
    "category.tab.individual": "Category",
    "category.tab.group": "Group",
    "category.type.income_item": "Income Items",
    "category.type.fixed_expense": "Fixed Expenses",
    "category.type.extra_expense": "Variable Expenses",
    
    // Budget
    "budget.page.title": "Cash Flow Planner",
    "budget.daily.status": "Today's Budget",
    "budget.monthly.income": "Monthly Income",
    "budget.monthly.expense": "Monthly Expense",
    "budget.remaining": "Remaining",
    "budget.spent": "Spent",
    "budget.planner.title": "Budget Planner",
    "budget.planner.mode.conservative": "By History",
    "budget.planner.mode.projected": "By Plan",
    "budget.planner.card.title": "Total Monthly Budget",
    "budget.planner.card.fixed": "Fixed Exp.",
    "budget.planner.card.living": "Living",
    "budget.planner.card.jars": "Jars",
    "budget.planner.card.savings": "Save & Inv.",
    "budget.planner.tabs.planning": "Planning",
    "budget.planner.tabs.planning.short": "Plan",
    "budget.planner.tabs.allocation": "Allocation",
    "budget.planner.tabs.allocation.short": "Dist.",
    "budget.planner.tabs.trends": "Trends",
    "budget.planner.tabs.trends.short": "Trend",
    "budget.planner.allocation.title": "Allocation Overview",
    "budget.planner.allocation.detail_title": "Allocation Details",
    "budget.planner.allocation.fixed": "Fixed Expenses",
    "budget.planner.allocation.living": "Living",
    "budget.planner.allocation.jars": "Jars",
    "budget.planner.allocation.investment": "Save & Inv.",
    "budget.planner.allocation.total": "Total Budget",
    "budget.planner.allocation.spent": "Spent",
    "budget.planner.allocation.total_used": "Used",
    "budget.planner.allocation.empty": "No data",
    "budget.planner.allocation.desc.fixed": "Rent, Subscriptions",
    "budget.planner.allocation.desc.living": "Food, Transport, Daily",
    "budget.planner.allocation.desc.jars": "Travel, Goals",
    "budget.planner.allocation.desc.investment": "Surplus, Investments",
    "budget.planner.trends.structure": "Structure",
    "budget.planner.trends.execution": "Execution",
    "budget.planner.trend.plan.desc": "Analyze budget allocation and savings plan",
    "budget.planner.trend.actual.desc": "Compare actual income/expenses",
    "budget.planner.trend.toggle.hide": "Hide Details",
    "budget.planner.trend.toggle.show": "Details",
    "budget.planner.fixed.title": "Fixed Budget",
    "budget.planner.fixed.income": "Fixed Income",
    "budget.planner.fixed.expense": "Fixed Expense",
    "budget.planner.fixed.target": "Target",
    "budget.planner.fixed.current": "Current",
    "budget.planner.fixed.living_title": "Living Exp. Allocation",
    "budget.planner.fixed.init_data": "Initializing budget data...",
    "budget.planner.dialog.error": "Enable to Open",
    "budget.planner.dialog.error_desc": "Failed to load budget settings. Please try again.",
    "budget.planner.living.title": "Living Allocation",
    "budget.planner.extra.title": "Extra Budget",
    "budget.planner.extra.income": "Extra Income",
    "budget.planner.toast.loading": "Loading...",
    "budget.planner.toast.init": "Initializing budget data...",

    "budget.planner.jar.chart.title": "Expense Category Analysis",
    "budget.planner.jar.create.title": "Create New Savings Jar",
    "budget.planner.jar.create.name": "Jar Name",
    "budget.planner.jar.create.name.placeholder": "e.g., Travel Fund",
    "budget.planner.jar.create.target": "Target Amount",
    "budget.planner.jar.create.color": "Theme Color",
    "budget.planner.jar.create.submit": "Create Now",
    "budget.planner.jar.create.success": "Savings Jar Created",
    "budget.planner.jar.create.error": "Failed to create savings jar",
    "budget.planner.jar.create.validate_error": "Please enter name and target amount",
    "budget.planner.jar.history.empty": "No transactions yet",
    "budget.planner.jar.icon.select": "Select Icon",
    "budget.planner.jar.icon.search": "Search icons...",
    "budget.planner.jar.target_toggle": "Set target amount",
    "budget.planner.jar.target_placeholder": "Enter target amount",
    "budget.planner.jar.currency_select": "Choose jar currency",
    "budget.planner.jar.name_required": "Please enter a jar name",
    "budget.planner.jar.target_required": "Please enter a target amount",
    "budget.planner.jar.target_type_desc": "Goal - track progress",
    "budget.planner.jar.accum_type_desc": "∞ Open - accumulate balance",

    // Savings Jar Edit
    "budget.planner.jar.edit.title": "Edit Savings Jar",
    "budget.planner.jar.edit.name_label": "Jar Name",
    "budget.planner.jar.edit.name_placeholder": "e.g. Travel Fund",
    "budget.planner.jar.edit.target_label": "Target Amount",
    "budget.planner.jar.edit.color_label": "Theme Color",
    "budget.planner.jar.edit.icon_label": "Icon",
    "budget.planner.jar.edit.save": "Save Changes",
    "budget.planner.jar.edit.icon_select_title": "Select Icon",
    "budget.planner.jar.edit.icon_search_placeholder": "Search icons...",
    "budget.planner.jar.edit.no_icons_found": "No icons found",
    "budget.planner.jar.edit.error.required": "Name and target amount are required",
    "budget.planner.jar.edit.error.update_failed": "Failed to update jar",
    "budget.planner.jar.remove_target_title": "Remove target amount?",
    "budget.planner.jar.remove_target_desc": "The progress bar will disappear and switch to open balance mode. Your deposit history will not be deleted.",
    "budget.planner.jar.remove_target_confirm": "Confirm removal",

    // Savings Jar Deposit
    "budget.planner.jar.deposit.date_label": "Date",
    "budget.planner.jar.deposit.date_placeholder": "Select Date",
    "budget.planner.jar.deposit.note_placeholder": "Optional...",
    "budget.planner.jar.deposit.submit": "Save",

    // Savings Jar Allocation
    "budget.planner.jar.allocation.title": "Withdraw",
    "budget.planner.jar.allocation.subtitle": "Move jar funds into this month's budget",
    "budget.planner.jar.allocation.distributable_balance": "Available",
    "budget.planner.jar.allocation.suggestion_title": "Reference",
    "budget.planner.jar.allocation.month_label": "Month: {month}",
    "budget.planner.jar.allocation.month_start_balance": "Month start",
    "budget.planner.jar.allocation.current_balance": "Current",
    "budget.planner.jar.allocation.month_end_balance": "Month end",
    "budget.planner.jar.allocation.current_withdrawn": "Withdrawn",
    "budget.planner.jar.allocation.suggested_limit": "Suggested max",
    "budget.planner.jar.allocation.withdraw_input": "Amount",
    "budget.planner.jar.allocation.limit_hint": "Max: {currency}{value}",
    "budget.planner.jar.allocation.limit_formula": "Start {currency}{start} + deposits {currency}{deposit}",
    "budget.planner.jar.allocation.limit_title": "Max",
    "budget.planner.jar.allocation.progress_label": "{value}%",
    "budget.planner.jar.allocation.historical_limit_hint": "Hard limit (month-end): NT$ {value}",
    "budget.planner.jar.allocation.deposit_hint": "Deposits: NT$ {value}",
    "budget.planner.jar.allocation.allocated_amount": "Allocated: NT$ {value}",
    "budget.planner.jar.allocation.unallocated_amount": "Left: NT$ {value}",
    "budget.planner.jar.allocation.categories_title": "Categories",
    "budget.planner.jar.allocation.categories_subtitle": "Set ratio and amount",
    "budget.planner.jar.allocation.unallocated_title": "Unassigned",
    "budget.planner.jar.allocation.unallocated_subtitle": "Not assigned to a category",
    "budget.planner.jar.allocation.confirm_withdraw": "Confirm",
    "budget.planner.jar.allocation.cancel_withdraw": "Cancel",
    "budget.planner.jar.allocation.over_limit_error": "Allocation percentage cannot exceed 100%",
    "budget.planner.jar.allocation.total_items": "{count} Items",
    "budget.planner.jar.allocation.empty_title": "No Categories",
    "budget.planner.jar.allocation.add_button": "Select Categories",
    "budget.planner.jar.allocation.add_new_button": "Add Category",
    "budget.planner.jar.allocation.unlock": "Unlock",
    "budget.planner.jar.allocation.lock": "Lock",
    "budget.planner.jar.allocation.toast.remove_failed": "Remove Failed",
    "budget.planner.jar.allocation.toast.system_category_error": "System category '{name}' cannot be removed",
    "budget.planner.jar.allocation.toast.removed": "Category Removed",
    "budget.planner.jar.allocation.toast.removed_desc": "Category has been removed from allocation",
    "budget.planner.jar.allocation.toast.remove_error": "Remove Failed",
    "budget.planner.jar.allocation.toast.update_failed": "Update Failed",
    "budget.planner.jar.allocation.toast.created": "Category Created",
    "budget.planner.jar.allocation.toast.created_desc": "Category '{name}' created successfully",
    "budget.planner.jar.allocation.toast.edit_error": "Cannot Edit",
    "budget.planner.jar.allocation.toast.edit_error_desc": "Please select a category first",
    "budget.planner.jar.allocation.toast.delete_failed": "Delete Failed",
    "budget.planner.jar.allocation.toast.create_error": "Cannot Create Category",
    "budget.planner.jar.allocation.toast.no_budget_data": "Budget data not loaded yet",
    "budget.planner.toast.error.open": "Unable to Open",
    "budget.planner.toast.error.load": "Failed to load budget settings. Please try again.",
    "budget.planner.extra.balance.current": "With current balance",
    "budget.planner.extra.balance.last": "With last month balance",
    "budget.planner.extra.source": "Bonus, Side hustle, Investment",
    "budget.planner.jars.title": "Jars",
    "budget.planner.jars.page_title": "Savings Jars",
    "budget.planner.jars.add": "Add",
    "budget.planner.jars.empty": "No jars yet",
    "budget.planner.jars.empty_title": "No jars yet",
    "budget.planner.jars.empty_desc": "Create your first jar and start saving toward a goal!",
    "budget.planner.jars.create_first": "Create first jar",
    "budget.planner.jars.transfer": "Move",
    "budget.planner.jars.summary_total": "Total saved",
    "budget.planner.jars.summary_all": "All jars",
    "budget.planner.jars.jar_count": "{count} jars",
    "budget.planner.jars.list_title": "Your jars",
    "budget.planner.jars.trend.title": "Savings trend",
    "budget.planner.jars.trend.empty": "No trend data yet",
    "budget.planner.jars.trend.month_deposit": "Deposited NT$ {amount}",
    "jar.transfer.note.edit_title": "Edit transfer note",
    "jar.transfer.note.edit_desc": "Jar transfers can only edit the note",
    "jar.transfer.note.save": "Save note",
    "budget.planner.jar.deposit.delete_confirm": "Delete this deposit?",
    "budget.planner.jars.month_withdrawal": "Jar withdrawals this month",
    "budget.planner.jars.uncategorized_amount": "Unassigned NT${amount}",
    "budget.planner.jars.six_pack": "Quick-create 6 jars",
    "budget.planner.jars.six_pack_subtitle": "Start with the six-jar method",
    "budget.planner.jars.six_pack_hint": "These six jars give your savings a clear purpose. You can rename or adjust them anytime.",
    "amount.edit.title": "Enter amount",
    "amount.edit.desc": "Use the keypad to enter an amount",
    "amount.edit.current": "Current amount",
    "budget.allocation.title": "Allocation",
    "common.try_later": "Please try again later",
    "common.save_failed": "Couldn't save. Please try again.",
    "common.remove_failed": "Couldn't remove",
    "budget.planner.allocation.invested": "Invested",
    "budget.planner.allocation.to_goal": "To goal",
    "budget.planner.allocation.savings_details": "Savings details",
    "budget.planner.allocation.investment_details": "Investment details",
    "budget.planner.allocation.entry_count": "{count}",
    "budget.planner.allocation.no_savings_records": "No deposits this month",
    "budget.planner.allocation.no_investment_records": "No investments this month",
    "budget.planner.allocation.transfer_from_jar": "From \"{name}\"",
    "budget.planner.allocation.jar_transfer_in": "Jar transfer",
    "budget.planner.allocation.deposited_from_account": "{jar} (from {account})",
    "budget.planner.allocation.count_in_savings": "Count in monthly savings",
    "budget.planner.allocation.exclude_from_savings": "Exclude from monthly savings",
    "budget.planner.allocation.count_in_investment": "Count in monthly investment",
    "budget.planner.allocation.exclude_from_investment": "Exclude from monthly investment",
    "budget.planner.allocation.category_count": "{count} cats",
    "budget.planner.allocation.uncategorized_yet": "No categories",
    "budget.planner.allocation.month_withdraw_label": "Withdrawn",
    "budget.planner.jars.six_pack_success": "Six jars created",
    "budget.planner.jars.six_pack_success_desc": "Six jars are ready. Adjust them anytime.",
    "budget.planner.jars.six_pack_fail": "Couldn't create",
    "budget.planner.jars.six_pack_fail_desc": "Couldn't create the six jars. Please try again.",
    "budget.planner.jars.creating": "Creating…",
    "budget.planner.jars.confirm_create": "Create",
    "budget.planner.jars.withdraw_chip": "Out NT${amount}",
    "budget.planner.jars.pending_chip": "Open NT${amount}",
    "budget.planner.jars.edit_allocation": "Edit",
    "budget.planner.jars.expand": "Expand",
    "budget.planner.jars.collapse": "Collapse",
    "budget.planner.jar.card.withdrawn": "Out {amount}",
    "budget.planner.jar.card.uncategorized": "Unassigned {amount}",
    "budget.planner.jar.card.allocated": "Allocated",
    "budget.planner.jar.card.withdraw_cta": "To budget",
    "budget.planner.jar.card.edit_withdraw": "Edit",
    "budget.planner.jar.card.withdraw_now": "Withdraw",
    "budget.planner.jar.card.goal_type": "Goal",
    "budget.planner.jar.card.accum_type": "Open",
    "budget.planner.jar.card.current_balance": "Balance",
    "budget.planner.jar.card.reached": "Reached!",
    "budget.planner.jar.card.still_need": "Left",
    "budget.planner.jar.card.deposited": "Saved {amount}",
    "budget.planner.jar.card.target": "Goal {amount}",
    "budget.planner.jar.card.this_month": "Mo",
    "budget.planner.jar.card.balance": "Bal",
    "budget.planner.jar.card.chart_empty": "Chart appears after activity",
    "budget.planner.jar.card.tooltip_balance": "Bal {amount}",
    "budget.planner.jar.card.month_label": "{month}",
    "budget.planner.leftover.need_amount": "Add an amount first",
    "budget.planner.leftover.need_amount_desc": "Add at least one transfer with an amount.",
    "budget.planner.leftover.over_limit": "Over transferable amount",
    "budget.planner.leftover.over_limit_desc": "Over by NT${amount}. Please adjust.",
    "budget.planner.leftover.success": "Saved to jars",
    "budget.planner.leftover.success_desc": "{month} leftover NT${amount} moved to jars.",
    "budget.planner.leftover.fail": "Transfer failed",
    "budget.planner.leftover.fail_desc": "Please try again.",
    "budget.planner.month.loading": "Loading month data",
    "budget.planner.month.load_fail": "Load failed",
    "budget.planner.month.load_fail_desc": "Couldn't load fixed income/expense",
    "budget.planner.leftover.card_title": "Leftover to save",
    "budget.planner.leftover.card_hint": "Moves straight into jars",
    "budget.planner.leftover.card_badge": "Available",
    "budget.planner.leftover.card_start": "Allocate",
    "budget.planner.leftover.card_formula_aria": "How leftover is calculated",
    "budget.planner.leftover.card_formula": "Available = (Fixed + Living + Savings/Invest) budget − spent",
    "budget.planner.leftover.card_formula_month": "This month: ({fixed} + {living} + {savings}) − ({fixedSpent} + {livingSpent} + {savingsSpent}) = {result}",
    "budget.planner.leftover.dialog_title": "Save the leftover",
    "budget.planner.leftover.dialog_subtitle": "{month} has NT$ {amount} left",
    "budget.planner.leftover.allocated": "Allocated",
    "budget.planner.leftover.over": "Over limit",
    "budget.planner.leftover.unallocated": "Unallocated",
    "budget.planner.leftover.lines_title": "Transfers",
    "budget.planner.leftover.lines_count": "{count} transfers",
    "budget.planner.leftover.lines_empty": "No transfers yet. Enter an amount on a jar below.",
    "budget.planner.leftover.swipe_hint": "Swipe left to delete a transfer",
    "budget.planner.leftover.deduct": "Debit {amount}",
    "budget.planner.leftover.deposit_to": "Credit {amount}",
    "budget.planner.leftover.pick_account": "Source account",
    "budget.planner.leftover.pick_account_desc": "Optional - leave empty for virtual deposit",
    "budget.planner.leftover.no_account": "No matching accounts",
    "budget.planner.leftover.virtual_deposit": "Virtual deposit",
    "budget.planner.leftover.unknown_account": "Unknown account",
    "budget.planner.leftover.split_even": "Split evenly",
    "budget.planner.leftover.clear": "Clear",
    "budget.planner.leftover.give_all": "Give all",
    "budget.planner.leftover.current": "Now {amount}",
    "budget.planner.leftover.progress": " · {pct}%",
    "budget.planner.leftover.jar_allocated": "This round {amount}",
    "budget.planner.leftover.amount_label": "Amount to save",
    "budget.planner.leftover.add_line": "Add transfer",
    "budget.planner.leftover.switch_jar": "Switch to {name}",
    "budget.planner.leftover.submitting": "Saving…",
    "budget.planner.leftover.submit": "Save NT$ {amount}",
    "budget.planner.jars.no_category_alloc": "No category allocation yet",
    "budget.planner.jars.template.needs": "Needs",
    "budget.planner.jars.template.needs_desc": "Essentials & daily spending",
    "budget.planner.jars.template.freedom": "Freedom",
    "budget.planner.jars.template.freedom_desc": "Long-term investing",
    "budget.planner.jars.template.education": "Growth",
    "budget.planner.jars.template.education_desc": "Learning & skills",
    "budget.planner.jars.template.long_fun": "Long fun",
    "budget.planner.jars.template.long_fun_desc": "Travel & big treats",
    "budget.planner.jars.template.short_fun": "Short fun",
    "budget.planner.jars.template.short_fun_desc": "Small joys",
    "budget.planner.jars.template.give": "Give",
    "budget.planner.jars.template.give_desc": "Donations & sharing",
    "budget.planner.copy.title": "Copy month settings",
    "budget.planner.copy.preview_title": "Preview changes",
    "budget.planner.copy.prev_month": "Previous month",
    "budget.planner.copy.next_month": "Next month",
    "budget.planner.copy.from_aria": "Copy settings from another month",
    "budget.planner.copy.pick_source": "Choose source month",
    "budget.planner.copy.pick_content": "What to copy",
    "budget.planner.copy.mode": "Budget mode",
    "budget.planner.copy.mode_desc": "By History / By Plan",
    "budget.planner.copy.items": "Income & expense items",
    "budget.planner.copy.items_desc": "Fixed items, extras, and amounts",
    "budget.planner.copy.alloc": "Living & savings allocation",
    "budget.planner.copy.alloc_desc": "Category sliders and savings/invest",
    "budget.planner.copy.about_to": "Copying from {year}-{month}:",
    "budget.planner.copy.calc_mode": "Mode",
    "budget.planner.copy.mode_conservative": "By History",
    "budget.planner.copy.mode_estimate": "By Plan",
    "budget.planner.copy.badge_new": "New",
    "budget.planner.copy.badge_edit": "Edit",
    "budget.planner.copy.badge_del": "Del",
    "budget.planner.copy.type_fixed_income": "Fixed income",
    "budget.planner.copy.type_fixed_expense": "Fixed expense",
    "budget.planner.copy.type_extra": "Extra income",
    "budget.planner.copy.type_fixed_alloc": "Fixed allocation",
    "budget.planner.copy.type_extra_alloc": "Extra allocation",
    "budget.planner.copy.preview_fail": "Preview failed",
    "budget.planner.copy.preview_fail_desc": "Unexpected preview data. Check that the source month has a budget, or try again.",
    "budget.planner.copy.preview_fail_retry": "Check that the source month has a budget, or try again.",
    "budget.planner.copy.preview_loading": "Loading…",
    "budget.planner.copy.preview_action": "Preview",
    "budget.planner.copy.done": "Copied",
    "budget.planner.copy.done_desc": "Applied settings from {year}-{month}",
    "budget.planner.copy.fail": "Copy failed",
    "budget.planner.copy.copying": "Copying…",
    "budget.planner.copy.apply": "Apply",
    "budget.planner.copy.quick": "Copy from another month",
    "budget.planner.copy.start": "Start copy",
    "budget.planner.copy.items_changed": "Item changes ({count})",
    "budget.planner.copy.cats_changed": "Allocation changes ({count})",
    "budget.planner.copy.remove_category": "Remove",
    "budget.planner.copy.no_changes": "Nothing to update",
    "budget.planner.copy.blank_title": "No budget yet",
    "budget.planner.copy.apply_to": "Apply to",
    "budget.planner.copy.back": "Back",
    "budget.planner.copy.onboard_title": "Set up your budget",
    "budget.planner.copy.onboard_desc": "Add fixed income/expense and living allocation",
    "budget.planner.copy.onboard_income": "Fixed income",
    "budget.planner.copy.onboard_expense": "Fixed expense",
    "jar.transfer.swap": "Swap source and target jars",

    "jar.transfer.title": "Move to Another Jar",
    "jar.transfer.desc": "Move between jars without touching bank accounts.",
    "jar.transfer.from": "From",
    "jar.transfer.to": "To",
    "jar.transfer.route_label": "Transfer route",
    "jar.transfer.pick_from": "Source jar",
    "jar.transfer.pick_to": "Target jar",
    "jar.transfer.pick_from_desc": "Choose the jar to transfer from",
    "jar.transfer.pick_to_desc": "Choose the jar to receive funds",
    "jar.transfer.amount_label": "Transfer amount",
    "jar.transfer.amount_hint": "(Max {max})",
    "jar.transfer.account_split": "Account allocation",
    "jar.transfer.account_split_hint": "(assign if possible)",
    "jar.transfer.account_max": "Up to {amount}",
    "jar.transfer.allocated": "Assigned to accounts",
    "jar.transfer.unassigned": "Pure jar transfer",
    "jar.transfer.unassigned_account": "Unassigned (no account)",
    "jar.transfer.unassigned_hint": "Assign above or leave as pure jar transfer",
    "jar.transfer.unassigned_done": "Fully assigned to accounts",
    "jar.transfer.unassigned_short": "Unassigned {amount}",
    "jar.transfer.allocation_progress": "Assigned {allocated} / {total}",
    "jar.transfer.allocation_complete": "Fully assigned",
    "jar.transfer.unassigned_only": "Full amount will be a pure jar transfer",
    "jar.transfer.no_accounts": "No linked account records in this jar",
    "jar.transfer.available": "Available",
    "jar.transfer.fill_all": "Auto-fill",
    "jar.transfer.no_available": "No per-account balance available",
    "jar.transfer.no_jars": "No matching jars",
    "jar.transfer.note": "Note (optional)",
    "jar.transfer.note_placeholder": "e.g. Move travel fund to emergency jar",
    "jar.transfer.total": "Total transfer",
    "jar.transfer.cancel": "Cancel",
    "jar.transfer.submit": "Confirm transfer",
    "jar.transfer.submit_with_amount": "Transfer {amount}",
    "jar.transfer.submitting": "Processing…",
    "jar.transfer.success_title": "Transfer complete",
    "jar.transfer.success_desc": "Funds have been reallocated between jars",
    "jar.transfer.error_title": "Transfer failed",
    "jar.transfer.error_desc": "Please try again later",
    "jar.transfer.unknown_account": "Unknown account",
    "jar.transfer.fx_preview": "≈ {from} → {to}",
    "jar.transfer.post_adjust_title": "Adjust account balances after transfer (optional)",
    "jar.transfer.post_adjust_desc": "Account totals {accounts} exceed jar balance {jar}. Fix if you paid from other accounts.",
    "jar.transfer.post_adjust_to": "Set to",
    "jar.transfer.history.out_title": "Moved to {name}",
    "jar.transfer.history.out_desc": "Jar-to-jar transfer",
    "jar.transfer.history.in_pure": "Jar transfer in",
    "jar.transfer.history.in_from_jar": "From \"{name}\"",
    "jar.transfer.history.in_from_account": "From {account}",
    "jar.transfer.history.load_error": "Could not load transfer history",
    "jar.transfer.cancel.action": "Undo transfer",
    "jar.transfer.cancel.insufficient_hint": "Target jar balance too low to undo",
    "jar.transfer.cancel.title": "Undo this transfer?",
    "jar.transfer.cancel.desc": "Deduct {amount} from \"{to}\" and restore it to \"{from}\". The record will be removed.",
    "jar.transfer.cancel.desc_lines": "This transfer has {count} inbound entries and all will be undone together.",
    "jar.transfer.cancel.confirm": "Confirm undo",
    "jar.transfer.cancel.success_title": "Transfer undone",
    "jar.transfer.cancel.success_desc": "Funds have been restored to the source jar",
    "jar.transfer.cancel.error_title": "Undo failed",
    "jar.transfer.cancel.error_desc": "Please try again later",

    "budget.planner.jar.deposit.manual": "Manual deposit",
    "budget.planner.jar.deposit.rollover": "Month-end rollover",
    "budget.planner.jar.deposit.rollover_leftover": "Month-end leftover in",
    "budget.planner.jar.deposit.count_in_short": "Count in savings",
    "budget.planner.jar.deposit.count_out_short": "Exclude from savings",
    "budget.planner.jar.deposit.entry_count": "{count}",
    "budget.planner.jar.delete.title": "Delete \"{name}\"?",
    "budget.planner.jar.delete.body": "This jar's budget and balance history in past months will also be removed.",
    "budget.planner.jar.delete.warn": "May affect past months' budget analysis.",
    "budget.planner.jar.delete.irreversible": "This can't be undone.",
    "budget.planner.jar.delete.confirm": "Delete",
    "account.picker.my_accounts": "My accounts",
    "account.picker.split_partners": "Split partners",
    "account.picker.unlinked": "Unlinked",
    "investment.account.filter.payment": "Shows everyday payment accounts (not investment accounts)",
    "investment.account.filter.broker_all": "Shows investment accounts (including your custom types)",
    "investment.account.filter.broker_type": "Filtered to {type} broker accounts",
    "investment.account.filter.match_first": "Match first",
    "investment.account.filter.all_accounts": "All accounts",
    "investment.account.empty.payment": "No payment account yet",
    "investment.account.empty.broker_type": "No {type} broker account yet",
    "investment.account.empty.broker": "No holding account yet",
    "investment.account.empty.payment_desc": "Create a payment account to complete this trade",
    "investment.account.empty.broker_type_desc": "Create a {type} broker account to continue",
    "investment.account.empty.broker_desc": "Create a holding account to track positions",
    "investment.account.empty.payment_cta": "Create payment account",
    "investment.account.empty.broker_type_cta": "Create {type} broker",
    "investment.account.empty.broker_cta": "Create holding account",
    "investment.jar.select_title": "Select jar",
    "investment.jar.select_desc": "Optional jar to fund this investment",
    "investment.jar.label": "Jar (optional)",
    "investment.jar.none": "None (trade only)",
    "investment.jar.none_title": "No jar",
    "investment.jar.none_desc": "Record the trade without deducting a jar",
    "investment.jar.not_found_title": "Can't find your jar?",
    "investment.jar.not_found_desc": "Leave and create a jar first",

    "jar.hide.confirm_title": "Hide \"{name}\"?",
    "jar.hide.confirm_desc": "Hiding won't delete data - it just leaves lists and pickers. You can restore later.",
    "jar.hide.confirm_balance_warn": "This jar still has {amount}. After hiding you can't deposit, withdraw, or transfer.",
    "jar.hide.confirm_action": "Hide jar",
    "jar.hide.success_title": "Jar hidden",
    "jar.hide.success_desc": "\"{name}\" is hidden from your lists",
    "jar.hide.error_title": "Couldn't hide",
    "jar.hide.error_desc": "Please try again later",
    "jar.hide.tip_goal_done": "Goal reached and balance is empty - you can hide this jar to keep the list tidy.",
    "jar.hide.manage_title": "Hidden jars",
    "jar.hide.manage_desc": "Tap a card to view history, or unhide to restore it to your list.",
    "jar.hide.manage_empty": "No hidden jars",
    "jar.hide.has_balance": "Has balance",
    "jar.hide.view": "View",
    "jar.hide.unhide": "Unhide",
    "jar.hide.unhide_success_title": "Jar restored",
    "jar.hide.unhide_success_desc": "\"{name}\" is back in your jar list",
    "jar.hide.unhide_error_title": "Couldn't unhide",
    "jar.hide.unhide_error_desc": "Please try again later",
    "jar.hide.manage_entry_aria": "Manage hidden jars",
    "jar.hide.manage_entry": "Hidden",
    "jar.hide.readonly_deposit": "This jar is hidden - new deposits are disabled (history still available).",
    "jar.hide.readonly_withdraw": "This jar is hidden - withdrawals are disabled (allocation still visible).",
    "jar.swipe.edit": "Edit",
    "jar.swipe.hide": "Hide",
    "jar.swipe.delete": "Delete",
    "jar.swipe.delete_desc": "Deleting removes this jar's historical budget and accumulated balance records.",
    "jar.swipe.delete_irreversible": "This cannot be undone.",
    "jar.swipe.delete_confirm": "Delete",

    "jar.balance.section_title": "Balance by account in this jar",
    "jar.balance.info_title": "About balances",
    "jar.balance.section_desc": "Tracks which account each deposit came from. The sum of per-account balances may differ from the jar total (e.g. when spending from another account).",
    "jar.balance.mismatch_hint": "Accounts total {accounts} but jar has {jar}. Adjust per-account balances to match reality.",
    "jar.balance.mismatch_status": "Balances and jar total don't match. You can adjust per-account balances to reflect reality.",
    "jar.balance.mismatch_dot_hint": "Account totals and jar balance don't match",
    "jar.balance.adjust": "Adjust",
    "jar.balance.adjust_to": "Set balance to",
    "jar.balance.adjust_note": "Does not change jar total or real account balances-only this account's balance in this jar",
    "jar.balance.current_label": "Current",
    "jar.balance.confirm": "Confirm",
    "jar.balance.cancel": "Cancel",
    "jar.balance.computed_was": "Was",
    "jar.balance.success_title": "Balance updated",
    "jar.balance.success_desc": "Updated balance for {name} in this jar",
    "jar.balance.already_at_target": "Balance for {name} is already at this amount; refreshed latest data",
    "jar.balance.error_title": "Adjust failed",
    "jar.balance.error_desc": "Please try again",
    "jar.balance.error_over": "Cannot exceed computed balance",
    "jar.balance.error_over_max": "Cannot exceed {max} left to allocate in this jar",
    "jar.balance.adjust_max_inline": "Up to {max} left in this jar",
    "jar.balance.adjust_max_hint": "Maximum for this account in this jar: {max}",
    "jar.balance.unknown_account": "Unknown account",
    "jar.balance.formula_title": "Balance calculation",
    "jar.balance.formula_deposited": "Deposited",
    "jar.balance.formula_spent": "Spent",
    "jar.balance.formula_adjusted": "Manual adjustment",
    "jar.balance.formula_result": "Balance",
    "jar.balance.summary_accounts_total": "Total by account",
    "jar.balance.summary_jar_balance": "Jar balance",
    "jar.balance.tap_amount_hint": "Tap amount for formula",

    // Savings Jar Detail
    "budget.planner.jar.progress": "Progress",
    "budget.planner.jar.include_budget": "Include in Monthly Budget",
    "budget.planner.jar.tab.deposit": "New",
    "budget.planner.jar.tab.allocation": "Withdraw",
    "budget.planner.jar.tab.history": "History",
    "budget.planner.jar.tab.chart": "Spend",
    "budget.planner.jar.tabs.deposits": "Deposit",
    "budget.planner.jar.tabs.expenses": "Spent",
    "budget.planner.jar.deposit.new": "New",
    "budget.planner.jar.deposit.history_tab": "History",
    "budget.planner.jar.deposit.optional": "(opt.)",
    "budget.planner.jar.deposit.virtual": "Virtual",
    "budget.planner.jar.deposit.count_in": "Count in monthly savings",
    "budget.planner.jar.deposit.count_out": "Exclude from monthly savings",
    "budget.planner.jar.deposit.convert_preview": "Will deposit {amount}",
    "budget.planner.jar.deposit.amount_required": "Enter a deposit amount",
    "budget.planner.jar.deposit.amount_invalid": "Enter a valid amount",
    "budget.planner.jar.expense.history_tab": "History",
    "budget.planner.jar.expense.analysis_tab": "Chart",
    "budget.planner.jar.expense.all_months": "All months",
    "budget.planner.jar.expense.all": "All",
    "budget.planner.jar.stats.deposited": "Saved",
    "budget.planner.jar.stats.spent_pct": "Spent {amount} ({pct}%)",
    "budget.planner.jar.stats.monthly_avg": "Avg {amount}/mo",
    "budget.planner.jar.stats.this_month_net": "{sign}{amount} Mo",
    "budget.planner.jar.deposit.edit_title": "Edit deposit",
    "budget.planner.jar.deposit.edit_desc": "Change amount, account, date, or note",
    "budget.planner.leftover.rollover_note": "{month} leftover",
    "budget.planner.jar.delete_confirm": "Are you sure you want to delete 「{name}」?",
    "budget.planner.jar.stats.allocation_status": "Allocation Status",
    "budget.planner.jar.stats.overspend": "Overspent",
    "budget.planner.jar.stats.spent": "Spent",
    "budget.planner.jar.stats.saved": "Saved",
    "budget.planner.jar.stats.target": "Target",
    "budget.planner.jar.stats.historical_spent": "Hist. Spent",
    "budget.planner.jar.stats.monthly_spent": "Month Spent",
    "budget.planner.jar.stats.current_balance": "Balance",
    "budget.planner.jar.stats.remaining_target": "Remaining",
    "budget.planner.jar.deposit.amount_label": "Amount",
    "budget.planner.jar.deposit.account_select": "Select Account",
    "budget.planner.jar.deposit.account_source": "From Account",
    "budget.planner.jar.deposit.select_account_title": "Select Source Account",
    "budget.planner.jar.deposit.select_placeholder": "Select Source Account",
    "budget.planner.jar.deposit.unknown_account": "Unknown Account",
    "budget.planner.jar.deposit.account_search": "Search Account...",
    "budget.planner.jar.deposit.no_account_found": "No Account Found",
    "budget.planner.jar.deposit.account_balance": "Balance: ",
    "budget.planner.jar.deposit.note_label": "Note",
    "budget.planner.jar.deposit.success": "Deposit record added",
    "budget.planner.jar.deposit.error": "Failed to add deposit",
    "budget.planner.jar.deposit.validate_error": "Please fill in amount and account",
    "budget.planner.jar.delete.success": "Savings Jar Deleted",
    "budget.planner.jar.delete.error": "Failed to delete Savings Jar",

    "budget.planner.allocation.mode.priority": "Priority",
    "budget.planner.allocation.mode.set_priority": "Set Priority",
    "budget.planner.allocation.remaining": "Remaining:",
    "budget.planner.allocation.available_total": "Total Available:",
    "budget.planner.allocation.allocated": "Allocated:",
    "budget.planner.allocation.living_budget": "Remaining Allocatable:",
    "budget.planner.allocation.unallocated": "Unallocated:",
    "budget.planner.allocation.over_spent": "Over:",
    "budget.planner.allocation.over": "Over",
    "budget.planner.allocation.over_budget_pct": "Over budget by {pct}%",
    "budget.planner.allocation.unallocated_pct": "{pct}% unallocated",
    "budget.planner.allocation.no_categories": "No categories selected",
    "budget.planner.allocation.select_category": "Select Cat.",
    "budget.planner.allocation.loading": "Loading...",
    "budget.planner.allocation.add_category": "Add Category",
    "budget.planner.allocation.savings_investment": "Savings/Investment",
    "budget.planner.allocation.savings_investment_dist": "Savings & Inv.",
    "budget.planner.allocation.savings_only": "Savings",
    "budget.planner.allocation.investment_only": "Investment",
    "budget.planner.allocation.auto_savings_desc": "Unallocated amount will go to Savings/Investment automatically",
    "budget.planner.allocation.remaining_available": "Remaining:",
    "common.locked": "Locked",
    "common.editing": "Editing",
    "common.remaining": "Remaining",
    "common.error": "Error",
    "budget.planner.dialog.add_error_required": "Please fill in item name and amount",
    "budget.planner.dialog.add_failed": "Failed to add item",
    "budget.planner.dialog.delete_auto_error": "Cannot delete auto-calculated item",
    "budget.planner.dialog.delete_failed": "Failed to delete item",
    "budget.planner.dialog.delete_fixed_income_desc": "Remove from fixed income. Amount: {amount}.",
    "budget.planner.dialog.delete_fixed_expense_desc": "Remove from fixed expenses. Amount: {amount}.",
    "budget.planner.allocation.delete_desc": "Remove from living expense allocation. Amount: {amount}.",
    "budget.planner.jar.allocation.delete_desc": "Remove from jar budget allocation. Amount: {amount}.",
    "budget.planner.dialog.fixed_income": "Fixed Income Items",
    "budget.planner.dialog.fixed_expense": "Fixed Expense Items",
    "budget.planner.dialog.category_select": "Select Category",
    "budget.planner.dialog.uncategorized": "Uncategorized",
    "budget.planner.dialog.category_group": "Category Group",
    "budget.planner.dialog.item_name": "Item Name",
    "budget.planner.dialog.item_amount": "Amount",
    "budget.planner.dialog.name_placeholder": "Enter name",
    "budget.planner.dialog.cancel": "Cancel",
    "budget.planner.dialog.update": "Update Item",
    "budget.planner.dialog.add": "Add Item",
    "budget.planner.dialog.extra_title": "Extra Income Items",
    "budget.planner.dialog.extra_explain": "Earn more than fixed income? The surplus is yours to allocate!",
    "budget.planner.dialog.extra_formula": "Extra = max(0, actual income − fixed income)",
    "budget.planner.dialog.extra_actual_prev": "Last month actual income",
    "budget.planner.dialog.extra_actual_current": "This month actual income",
    "budget.planner.dialog.extra_fixed": "Fixed income",
    "budget.planner.dialog.extra_auto_badge": "Auto",
    "budget.planner.dialog.extra_result_sub": "Calculated from ledger income",
    "budget.planner.dialog.init_budget": "Initializing budget...",
    "budget.planner.dialog.init_desc": "Creating budget data for the first time",
    "budget.planner.dialog.current_net": "Current Month Extra Net",
    "budget.planner.dialog.prev_net": "Last Month Extra Net",
    "budget.planner.dialog.current_net_short": "Current Net",
    "budget.planner.dialog.prev_net_short": "Last Net",
    "budget.planner.dialog.other_items": "Other Items",
    "budget.planner.dialog.no_categories": "No Categories",
    "budget.planner.dialog.item_list": "Item List",
    "budget.planner.dialog.total_items": "Items: {count}",
    "budget.planner.celebration.title": "Goal Achieved!",
    "budget.planner.celebration.desc.projected": "Great! Your projected income has reached the target.\nKeep up the good work!",
    "budget.planner.celebration.desc.conservative": "Excellent! Your income last month exceeded the target!",
    "budget.planner.celebration.extra_note": "💰 You have surplus to allocate!",
    "budget.planner.celebration.btn": "Awesome!",
    "budget.planner.extra.includes_current": "Incl. current balance",
    "budget.planner.extra.includes_prev": "Incl. last month balance",
    "budget.planner.extra.desc": "Tap for details",

    // Analysis / Trend
    "analysis.show_amount": "Show Amount",
    "analysis.show_percentage": "Show %",
    "analysis.monthly_net": "Monthly Net",
    "analysis.cumulative_net": "Cumulative Net",
    "analysis.details": "Details",
    "analysis.surplus": "Surplus",
    "analysis.deficit": "Deficit",
    "analysis.fixed_expense": "Fixed",
    "analysis.living_expense": "Living",
    "analysis.jars": "Jars",
    "analysis.savings_investment": "Save/Inv",
    "analysis.available": "Available",
    "analysis.actual_expense": "Actual Exp.",
    "analysis.actual_net": "Actual Net",
    "analysis.cumulative_trend": "Cumulative Trend",
    "analysis.available_budget": "Available Budget",
    "analysis.loading_data": "Loading data...",
    "analysis.no_history_data": "No history data",

    // Asset Account
    "account.add.title": "Add Account",
    "account.add.form.name": "Account Name",
    "account.add.form.type": "Account Type", // Added missing key
    "account.add.form.balance": "Initial Balance",
    "account.add.form.currency": "Currency",
    "account.name": "Account Name",
    "account.type": "Account Type",
    "account.balance": "Initial Balance",
    "account.currency": "Currency",
    
    // Add Account Dialog (Extended)
    "account.add.form.note": "Note",
    "account.add.form.note_placeholder": "Optional note...",
    "account.add.form.exchange_rate": "Exchange Rate (to TWD)",
    "account.add.form.rate_ref": "Ref",
    "account.add.form.include_total": "Include in Net Worth",
    "account.add.form.include_total_desc": "If enabled, amount contributes to dashboard total",
    "account.add.form.custom_type": "Custom Type",
    "account.add.form.select_icon": "Select Icon",
    "account.add.form.icon_label": "Icon",
    "account.add.form.color": "Color",
    "account.add.form.featured_colors": "Theme Colors",
    "account.add.form.import_photo": "Import",
    "account.add.form.remove_photo": "Remove Photo",
    "account.add.form.custom_icons_loading": "Loading custom images...",
    "account.add.form.note_detail": "Detailed Note",
    "account.add.form.note_detail_placeholder": "Write a detailed note...",
    "account.add.form.import_photo_title": "Import Account Photo",
    "account.add.form.import_photo_confirm": "Confirm Import",
    "account.add.form.photo_name": "Photo Name",
    "account.add.form.photo_name_placeholder": "e.g. E.SUN Main Account",
    "account.add.form.mode_detail_expand": "Show details",
    "account.add.form.mode_detail_collapse": "Hide details",
    "account.add.form.search_bank": "Search bank or institution...",
    "account.add.submit": "Create Account",
    "account.add.success": "Account created successfully",
    "account.add.error.required": "Please fill in all required fields",
    "account.add.error.failed": "Failed to create account",
    
    // Account Details
    "account.detail.edit_title": "Edit Account",
    "account.detail.view_title": "Account Details",
    "account.detail.name": "Account Name",
    "account.detail.type": "Type",
    "account.detail.balance": "Balance",
    "account.detail.currency": "Currency",
    "account.detail.exchange_rate": "Exchange Rate (to TWD)",
    "account.detail.approx_twd": "Approx. TWD",
    "account.detail.note": "Note",
    "account.detail.n_a": "N/A",
    "account.detail.include_in_total": "Include in Assets",
    "account.detail.include_in_total_hint": "Include amount in total assets on dashboard",
    "account.detail.excluded": "Excluded",
    "account.detail.save": "Save",
    "account.detail.cancel": "Cancel",
    "account.detail.update_success": "Account updated successfully",
    "account.detail.update_failed": "Failed to update account",
    "account.detail.delete_success": "Account deleted successfully",
    "account.detail.delete_failed": "Failed to delete account",
    "account.detail.transactions": "Transactions",
    "account.detail.no_transactions": "No transactions found",
    "account.detail.current_balance": "Current Balance",
    "account.detail.section_basic": "Basic Info",
    "account.detail.section_asset": "Asset Settings",
    "account.detail.section_other": "Other Settings",
    "account.detail.icon": "Icon",
    "account.detail.note_placeholder": "Optional...",
    
    // Account Actions
    "account.action.delete": "Delete",
    "account.action.transfer": "Transfer",
    "account.action.repayment": "Repay",
    "account.action.adjust": "Adjust",
    "account.action.edit": "Edit",
    "account.action.change_icon": "Change Icon",
    
    // Adjustment Dialog
    "account.adjust.title": "Adjust Balance",
    "account.adjust.diff": "Diff",
    "account.adjust.note_placeholder": "Adjustment note...",
    "account.adjust.include_stats": "Include in Stats",
    "account.adjust.exclude_stats": "Exclude from Stats",
    "account.adjust.success": "Balance adjusted",
    "account.adjust.failed": "Failed to adjust balance",
    "account.adjust.confirm": "Confirm",
    "account.adjust.mode_absolute": "Set balance",
    "account.adjust.mode_delta": "Add / subtract",
    "account.adjust.current_balance": "Now {amount}",
    "account.adjust.delta_add": "Add",
    "account.adjust.delta_subtract": "Subtract",
    "account.adjust.after_preview": "After {amount}",
    "account.adjust.delta_hint_add": "Enter amount to add",
    "account.adjust.delta_hint_subtract": "Enter amount to subtract",

    // Delete Dialog
    "account.delete.title": "Delete Account",
    "account.delete.confirm_desc": "Are you sure you want to delete",
    "account.delete.warning": "This action cannot be undone.",
    "account.delete.consequence.1": "All related transaction records will be unlinked",
    "account.delete.consequence.2": "Account balance data will be permanently removed",
    "account.delete.confirm_btn": "Confirm Delete",

    "account.hide.title": "Cannot Delete This Broker Account",
    "account.hide.confirm_desc": "\"{name}\" has investment transaction history. Deleting it would affect bank balances and historical data.",
    "account.hide.warning": "We recommend hiding this account instead.",
    "account.hide.consequence.1": "The account will disappear from overview and pickers, and will be excluded from net worth",
    "account.hide.consequence.2": "Investment history is kept; other bank account balances are unaffected",
    "account.hide.consequence.3": "Hidden accounts can be restored anytime",
    "account.hide.confirm_btn": "Hide Account",
    "account.hide.failed": "Failed to hide account",

    "account.hidden.title": "Hidden Accounts",
    "account.hidden.description": "These accounts are hidden in the app; history and balances are kept",
    "account.hidden.empty": "No hidden accounts",
    "account.hidden.restore": "Restore",
    "account.hidden.restore_success": "Restored",
    "account.hidden.restore_success_desc": "Account \"{name}\" is visible again",
    "account.hidden.restore_failed": "Restore Failed",
    "account.hidden.delete": "Delete permanently",
    "account.hidden.delete.title": "Permanently delete this account?",
    "account.hidden.delete.confirm_desc": "Delete \"{name}\" permanently?",
    "account.hidden.delete.warning": "This cannot be undone.",
    "account.hidden.delete.confirm_btn": "Delete permanently",
    "account.hidden.delete.success": "Deleted",
    "account.hidden.delete.success_desc": "Account \"{name}\" and related records were deleted",
    "account.hidden.delete.failed": "Delete failed",
    "account.hidden.delete.impact_failed": "Could not load delete impact. Try again later.",
    "account.hidden.delete.impact_heading": "Impact on total assets",
    "account.hidden.delete.impact.net_worth": "Displayed net worth will change by about {delta}",
    "account.hidden.delete.impact.net_worth_hidden": "This account is already hidden, so displayed net worth should stay the same",
    "account.hidden.delete.impact.balance": "Account balance {balance} (about {twd}) will also be removed",
    "account.hidden.delete.impact.balance_short": "Book balance {balance} (about {twd}) will be removed",
    "account.hidden.delete.impact.investments": "Will delete {count} holding(s) (market value about {value})",
    "account.hidden.delete.impact.ledger": "Will delete about {count} related ledger entries ({groups} transfer groups)",
    "account.hidden.delete.impact.jars": "Savings jars \"{names}\" will unlink this account; jar balances stay unchanged",
    "account.hidden.delete.impact.loans": "Will unlink {count} loan counterparty account(s)",
    "account.hidden.delete.impact.irreversible": "This cannot be undone — only delete if you no longer need the data",

    "overview.menu.hidden_accounts": "Hidden Accounts",

    "account.wallet.leave.action": "Leave Wallet",
    "account.wallet.leave.title": "Leave This Shared Wallet?",
    "account.wallet.leave.confirm_desc": "Are you sure you want to leave \"{name}\"?",
    "account.wallet.leave.consequence.1": "You will no longer be able to record transactions or view the shared balance",
    "account.wallet.leave.consequence.2": "Other members can still use this shared wallet",
    "account.wallet.leave.consequence.3": "Your personal account records will not be deleted",
    "account.wallet.leave.confirm_btn": "Leave Wallet",

    "account.wallet.delete.title": "Delete This Shared Wallet?",
    "account.wallet.delete.confirm_desc": "Are you sure you want to delete \"{name}\"?",
    "account.wallet.delete.member_count": "{count} other member(s) are currently using this wallet",
    "account.wallet.delete.member_count_zero": "No other members have joined yet",
    "account.wallet.delete.warning": "This action cannot be undone.",
    "account.wallet.delete.consequence.1": "All members will lose access to this shared wallet",
    "account.wallet.delete.consequence.2": "All members will be notified that this wallet was deleted",
    "account.wallet.delete.consequence.3": "Records on this wallet will be unlinked; records on personal accounts are kept",
    "account.wallet.delete.confirm_btn": "Delete Wallet",

    "account.advance.leave.action": "Leave Split",
    "account.advance.leave.title": "Leave This Advance Account?",
    "account.advance.leave.confirm_desc": "Are you sure you want to leave \"{name}\"?",
    "account.advance.leave.outstanding": "Outstanding balance: NT$ {amount}",
    "account.advance.leave.consequence.1": "The split will be archived; neither side can add new entries",
    "account.advance.leave.consequence.2": "Ledger history is kept and will still display correctly",
    "account.advance.leave.consequence.3": "The other party will be notified; find it under Archived Splits",
    "account.advance.leave.confirm_btn": "Leave & Archive",

    "account.advance.close.action": "Close Split",
    "account.advance.close.title": "Close This Advance Account?",
    "account.advance.close.confirm_desc": "Are you sure you want to close \"{name}\"?",
    "account.advance.close.outstanding": "Current balance NT$ {amount}",
    "account.advance.close.consequence.1": "The split will be archived; no new entries or advances",
    "account.advance.close.consequence.2": "Ledger history stays intact; note/category edits still work",
    "account.advance.close.consequence.3": "Members are notified; the account is not hard-deleted",
    "account.advance.close.confirm_btn": "Close & Archive",

    "account.advance.hide.action": "Hide Split",
    "account.advance.hide.title": "Hide Archived Split?",
    "account.advance.hide.confirm_desc": "\"{name}\" will be removed from the overview.",
    "account.advance.hide.consequence.1": "Ledger history still displays normally",
    "account.advance.hide.consequence.2": "Restore anytime from Hidden Accounts",
    "account.advance.hide.consequence.3": "This only affects your UI; the other party is not notified",
    "account.advance.hide.confirm_btn": "Hide Split",

    "account.advance.banner.archived_owner": "This split is archived; new entries are disabled",
    "account.advance.banner.archived_member_left": "You left this split; it is now archived",
    "account.advance.banner.archived_owner_closed": "The owner closed this split",
    "account.advance.banner.outstanding": "Outstanding balance NT$ {amount}",
    "account.advance.banner.reopen_wait_member": "Reopen requested; waiting for the other party to confirm",
    "account.advance.banner.reopen_wait_owner": "The owner requested reopen; please confirm balance NT$ {amount}",
    "account.advance.reopen.request_btn": "Reopen Split",
    "account.advance.reopen.confirm_btn": "Confirm Balance & Rejoin",
    "account.advance.member.left": "Left",
    "account.advance.section.title": "Archived Splits",
    "account.advance.badge.archived": "Archived",

    "account.icon.wallet": "Wallet",
    "account.icon.cash": "Cash",
    "account.icon.piggy": "Piggy Bank",
    "account.icon.card": "Credit Card",
    "account.icon.bank": "Bank",
    "account.icon.stock": "Stock",
    "account.icon.crypto": "Crypto",
    "account.icon.house": "Real Estate",
    "account.icon.coin": "Coin",
    "account.icon.target": "Target",
    "account.icon.briefcase": "Business",
    "account.icon.calc": "Calculator",
    "account.icon.receipt": "Receipt",
    "account.icon.dollar": "Currency",
    "account.icon.percent": "Interest",
    "account.icon.scale": "Balance",
    "account.icon.gem": "Valuables",
    "account.icon.gift": "Gift",
    "account.icon.users": "Shared",
    "account.icon.user": "Personal",
    "account.icon.handshake": "Loan",

    // Theme Icons (Generic Finance)
    "theme.wallet": "Wallet",
    "theme.cash": "Cash",
    "theme.piggy": "Piggy Bank",
    "theme.card": "Credit Card",
    "theme.bank": "Bank",
    "theme.stock": "Stocks",
    "theme.crypto": "Crypto",
    "theme.house": "Real Estate",
    "theme.coin": "Coins",
    "theme.target": "Goals",
    "theme.briefcase": "Work",
    "theme.calc": "Calculate",
    "theme.receipt": "Receipt",
    "theme.dollar": "Currency",
    "theme.percent": "Interest",
    "theme.scale": "Balance",
    "theme.gem": "Valuables",
    "theme.gift": "Gift",
    "theme.users": "Shared",
    "theme.user": "Personal",
    "theme.handshake": "Loan",

    // Shared Account
    "shared.account.title": "Shared Account",
    "shared.account.start.title": "How do you want to start?",
    "shared.account.create.title": "Create New",
    "shared.account.create.desc": "Start a new shared ledger",
    "shared.account.join.title": "Join Existing",
    "shared.account.join.desc": "Enter code from partner",
    "shared.account.create.subtitle": "Create Shared Account",
    "shared.account.create.name.label": "Account Name",
    "shared.account.create.name.placeholder": "e.g., Our Joint Fund",
    "shared.account.create.button": "Create & Generate Invite",
    "shared.account.invite.scan": "Scan or share this code with your partner",
    "shared.account.invite.share_hint": "Share this code with a partner so they can join.",
    "shared.account.invite.expire_hint": "This code expires in 24 hours.",
    "shared.account.invite.copy": "Copy Link",
    "shared.account.invite.copy_code": "Copy Code",
    "shared.account.invite.code_copied": "Code Copied",
    "shared.account.invite.code_copied.desc": "Invite code copied to clipboard",
    "shared.account.invite.copied": "Copied",
    "shared.account.invite.copied.desc": "Invite link copied to clipboard",
    "shared.account.invite.done": "Done",
    "shared.account.join.subtitle": "Join Shared Account",
    "shared.account.join.code.label": "Invite Code",
    "shared.account.join.code.placeholder": "Enter invite code",
    "shared.account.join.button": "Join Account",
    "shared.account.join.check_code": "Check Code",
    "shared.account.join.scan_qr": "Scan QR",
    "shared.account.join.scan_hint": "Place the QR code in the frame",
    "shared.account.join.error.invalid": "Invalid invite code. Please check and try again.",
    "shared.account.join.error.expired": "This invite code has expired.",
    "shared.account.join.error.already": "You are already a member of this shared account.",
    "shared.account.join.error.not_found": "Invite code not found. Please check and try again.",
    "shared.account.join.error.check_failed": "Check Failed",
    "shared.account.scan.error": "Scan Error",
    "shared.account.scan.error.desc": "Unable to start the camera. Please check permissions.",
    "shared.account.join.success": "Joined Successfully",
    "shared.account.join.success.desc": "You are now a member of {accountName}",
    "shared.account.type.wallet.desc": "Shared pool of funds",
    "shared.account.type.personal.desc": "Auto-track IOUs",
    "shared.confirm.title": "Invitation",
    "shared.confirm.wallet": "Shared Wallet",
    "shared.confirm.project": "Project Account",
    "shared.confirm.invited_by": "Invited By",
    "shared.confirm.balance": "Current Balance",
    "shared.confirm.total_assets": "Include in Net Worth",
    "shared.confirm.total_assets.off": "Exclude from Net Worth",
    "shared.confirm.total_assets.desc": "Tap to toggle whether this counts toward your net worth",
    "shared.confirm.button": "Confirm Join",
    "shared.confirm.joining": "Joining...",
    "shared.confirm.cancel": "Cancel",
    "account.mode.individual": "Daily Account",
    "account.mode.individual.tab": "Daily",
    "account.mode.individual.desc": "Daily cash flow and fund management",
    "account.mode.individual.desc_full": "Best for everyday money and payment methods like cash, bank balances, foreign currency, and credit cards; great for tracking daily cash flow.",
    "account.mode.broker": "Investment Account",
    "account.mode.broker.tab": "Invest",
    "account.mode.broker.desc": "Track investment assets and position changes",
    "account.mode.broker.desc_full": "Best for investment assets and position tracking, such as stocks, ETFs, funds, and crypto. To keep cost basis and holdings accurate, investment accounts do not support direct balance adjustment or regular transfer actions. Please record changes via buy/sell and deposit/withdraw flows.",
    "account.details.title": "Account Details",
    "shared.account.setup.balance": "Initial Balance",
    "shared.account.setup.currency": "Currency",
    "account.mode.shared": "Shared Account",
    "account.mode.shared.tab": "Shared",
    "account.mode.shared.desc": "Shared income/expenses, split costs, and settlements",
    "account.mode.shared.desc_full": "Best for managing shared finances with family, partners, or teams, including shared income/expenses, cost splitting, and settlements. After creation, the shared account type cannot be changed (for example, shared wallet vs. split-bill mode) because it affects membership, invites, and split rules.",
    "account.type.shared": "Shared Account",
  }
};

// System Category Mapping (Chinese to Translation Key)
const SYSTEM_CATEGORY_MAP: Record<string, string> = {
  // Categories
  "餐飲": "category.default.food",
  "飲食": "category.default.food",
  "交通": "category.default.transport",
  "購物": "category.default.shopping",
  "禮物": "category.default.gift",
  "家庭": "category.default.home",
  "居家": "category.default.home",
  "房租": "category.default.rent",
  "水電": "category.default.utilities",
  "娛樂": "category.default.entertainment",
  "遊戲": "category.default.entertainment", 
  "社交": "category.default.social",
  "旅遊": "category.default.travel",
  "醫療": "category.default.medical",
  "保險": "category.default.insurance",
  "通訊": "category.default.phone",
  "教育": "category.default.education",
  "稅務": "category.default.tax",
  "薪資": "category.default.salary",
  "獎金": "category.default.bonus",
  "紅包": "category.default.red_envelope",
  "投資": "category.default.investment",
  "儲蓄": "category.default.savings",

  "早餐": "category.default.breakfast",
  "午餐": "category.default.lunch",
  "晚餐": "category.default.dinner",
  "飲料": "category.default.drinks",
  "停車": "category.default.parking",
  "加油": "category.default.gas",
  "大眾運輸": "category.default.public_transport",

  "利息": "category.default.interest",
  "股息": "category.default.dividend",
  "其他支出": "category.other_expense",
  "未分類": "category.uncategorized",
  "Uncategorized": "category.uncategorized",
  "Unassigned": "category.uncategorized",

  // System / transfer kinds (budget allocation picker)
  "系統": "category.system.group",
  "轉帳": "category.system.transfer",
  "一般轉帳": "category.system.transfer_normal",
  "手續費": "category.system.fee",
  "餘額調整": "category.system.balance_adjustment",
  "信用卡還款": "category.system.credit_card_payment",
  "股票買入": "category.system.stock_buy",
  "股票賣出": "category.system.stock_sell",
  "建倉": "category.system.position_increase",
  "平倉": "category.system.position_decrease",
  "持倉增加": "category.system.position_increase",
  "持倉減少": "category.system.position_decrease",
  "借出": "transfer.kind.lend",
  "借入": "transfer.kind.borrow",
  "還款": "transfer.kind.repay",
  "收款": "transfer.kind.collect",

  // Groups
  "餐飲群組": "category.group.food",
  "交通群組": "category.group.transport",
  "購物群組": "category.group.shopping",
  "居家群組": "category.group.home",
  "家庭群組": "category.group.home",
  "娛樂群組": "category.group.entertainment",
  "醫療群組": "category.group.medical",
  "生活群組": "category.group.life",
  "工作群組": "category.group.work",
  "投資群組": "category.group.investment",

  // Groups without suffix (Ensure these map correctly if used as Group Names)
  // "居家": "category.group.home",
  "生活": "category.group.life",
  "工作": "category.group.work",
  "收入": "category.group.income",
  
  // If groups use the same name as categories but mean Group
  // (Note: keys are unique in object, so "餐飲" maps to category.default.food. 
  // If group is named "餐飲", it will be translated as "Food" (category key), which is usually fine.)
};

type LanguageContextType = {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
  transCategory: (name: string) => string;
};

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: ReactNode }) {
  // Load initial language from localStorage or default to zh-TW
  const [language, setLanguageState] = useState<Language>(() => {
    const saved = localStorage.getItem("language");
    return (saved === "en" || saved === "zh-TW") ? saved : "zh-TW";
  });

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem("language", lang);
    // You might want to reload the page or trigger a re-render if deep components don't update
    // But with Context, they should update automatically.
  };

  const t = (key: string, params?: Record<string, string | number>) => {
    let text = translations[language][key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  };

  // Helper to translate system categories / groups
  const transCategory = (name: string) => {
    if (language !== 'en' || !name) return name;

    // Exact map hit (categories + "…群組" names)
    const directKey = SYSTEM_CATEGORY_MAP[name];
    if (directKey) {
      return translations['en'][directKey] || name;
    }

    // Groups often stored without the "群組" suffix — try adding it
    if (!name.endsWith("群組")) {
      const withSuffixKey = SYSTEM_CATEGORY_MAP[`${name}群組`];
      if (withSuffixKey) {
        return translations['en'][withSuffixKey] || name;
      }
    }

    // Or strip "群組" and map the prefix
    if (name.endsWith("群組")) {
      const prefix = name.replace(/群組$/, "");
      const prefixKey = SYSTEM_CATEGORY_MAP[prefix];
      if (prefixKey) {
        return translations['en'][prefixKey] || name;
      }
    }

    return name;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, transCategory }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
